(function () {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var r = createCommonjsModule(function (module) {
    /**
     * R
     *
     * Version   →  0.0.29
     * Github    →  https://github.com/ariiiman/r
     * License   →  https://opensource.org/licenses/MIT
     * Author    →  Copyright (c) 2019-present, Aristide Benoist
     * Website   →  https://www.aristidebenoist.com
     * Date      →  Jul 14, 2019
     */
    var R = {};
    (module.exports = R).M = function (t) {
      R.BM(this, ["gRaf", "run", "uSvg", "uLine", "uProp"]), this.v = this.vInit(t), this.raf = new R.Raf(this.run);
    }, R.M.prototype = {
      vInit: function vInit(t) {
        var c = {
          el: R.Select.el(t.el),
          e: {
            curve: t.e || "linear"
          },
          d: {
            origin: t.d || 0,
            curr: 0
          },
          delay: t.delay || 0,
          cb: t.cb || !1,
          r: t.r || 2,
          prog: 0,
          progE: 0,
          elapsed: 0
        };
        c.elL = c.el.length, R.Has(t, "update") ? c.up = function () {
          t.update(c);
        } : R.Has(t, "svg") ? c.up = this.uSvg : R.Has(t, "line") ? c.up = this.uLine : c.up = this.uProp;
        var i = t.p || !1,
            r = t.svg || !1,
            e = t.line || !1,
            s = !1;

        if (i) {
          c.prop = {}, c.propI = [];
          var n = Object.keys(i);
          c.propL = n.length;

          for (var a = 0; a < c.propL; a++) {
            var o = n[a];
            c.prop[a] = {
              name: o,
              origin: {
                start: i[o][0],
                end: i[o][1]
              },
              curr: i[o][0],
              start: i[o][0],
              end: i[o][1],
              unit: i[o][2] || "%"
            };
            var h = o.charAt(0),
                u = "r" === h && s ? "r2" : h;
            s = "r" === h, c.propI[u] = a;
          }
        } else if (r) c.svg = {
          type: r.type,
          attr: "polygon" === r.type ? "points" : "d",
          end: r.end,
          originArr: {},
          arr: {},
          val: []
        }, c.svg.start = r.start || c.el[0].getAttribute(c.svg.attr), c.svg.curr = c.svg.start, c.svg.originArr.start = this.svgS(c.svg.start), c.svg.originArr.end = this.svgS(c.svg.end), c.svg.arr.start = c.svg.originArr.start, c.svg.arr.end = c.svg.originArr.end, c.svg.arrL = c.svg.arr.start.length;else if (e) {
          var y = function y(t) {
            if ("circle" === t.tagName) return 2 * t.getAttribute("r") * Math.PI;

            if ("line" === t.tagName) {
              var i = t.getAttribute("x1"),
                  r = t.getAttribute("x2"),
                  e = t.getAttribute("y1"),
                  s = t.getAttribute("y2");
              return Math.sqrt((r -= i) * r + (s -= e) * s);
            }

            if ("polyline" !== t.tagName) return (t = c.line.elWL || t).getTotalLength();

            for (var n, a = 0, o = t.points.numberOfItems, h = 0; h < o; h++) {
              var u = t.points.getItem(h);
              0 < h && (a += Math.sqrt(Math.pow(u.x - n.x, 2) + Math.pow(u.y - n.y, 2))), n = u;
            }

            return a;
          };

          c.line = {
            elWL: e.elWithLength,
            dashed: e.dashed,
            coeff: {
              start: R.Is.def(e.start) ? (100 - e.start) / 100 : 1,
              end: R.Is.def(e.end) ? (100 - e.end) / 100 : 0
            },
            shapeL: [],
            origin: {
              start: [],
              end: []
            },
            curr: [],
            start: [],
            end: []
          };

          for (a = 0; a < c.elL; a++) {
            var l;

            if (c.line.shapeL[a] = y(c.el[a]), c.line.dashed) {
              for (var f = 0, p = dashed.split(/[\s,]/), v = p.length, d = 0; d < v; d++) {
                f += parseFloat(p[d]) || 0;
              }

              var g = "",
                  m = Math.ceil(c.line.shapeL[a] / f);

              for (d = 0; d < m; d++) {
                g += dashed + " ";
              }

              l = g + "0 " + c.line.shapeL[a];
            } else l = c.line.shapeL[a];

            c.el[a].style.strokeDasharray = l, c.line.origin.start[a] = c.line.coeff.start * c.line.shapeL[a], c.line.origin.end[a] = c.line.coeff.end * c.line.shapeL[a], c.line.curr[a] = c.line.origin.start[a], c.line.start[a] = c.line.origin.start[a], c.line.end[a] = c.line.origin.end[a];
          }
        }

        return c;
      },
      play: function play(t) {
        this.pause(), this.vUpd(t), this.delay.run();
      },
      pause: function pause() {
        this.raf.stop(), this.delay && this.delay.stop();
      },
      vUpd: function vUpd(t) {
        var i = t || {},
            r = R.Has(i, "reverse") ? "start" : "end";
        if (R.Has(this.v, "prop")) for (var e = 0; e < this.v.propL; e++) {
          this.v.prop[e].end = this.v.prop[e].origin[r], this.v.prop[e].start = this.v.prop[e].curr, R.Has(i, "p") && R.Has(i.p, this.v.prop[e].name) && (R.Has(i.p[this.v.prop[e].name], "newEnd") && (this.v.prop[e].end = i.p[this.v.prop[e].name].newEnd), R.Has(i.p[this.v.prop[e].name], "newStart") && (this.v.prop[e].start = i.p[this.v.prop[e].name].newStart));
        } else if (R.Has(this.v, "svg")) R.Has(i, "svg") && R.Has(i.svg, "start") ? this.v.svg.arr.start = i.svg.start : this.v.svg.arr.start = this.svgS(this.v.svg.curr), R.Has(i, "svg") && R.Has(i.svg, "end") ? this.v.svg.arr.end = i.svg.end : this.v.svg.arr.end = this.v.svg.originArr[r];else if (R.Has(this.v, "line")) {
          for (e = 0; e < this.v.elL; e++) {
            this.v.line.start[e] = this.v.line.curr[e];
          }

          if (R.Has(i, "line") && R.Has(i.line, "end")) {
            this.v.line.coeff.end = (100 - i.line.end) / 100;

            for (e = 0; e < this.v.elL; e++) {
              this.v.line.end[e] = this.v.line.coeff.end * this.v.line.shapeL[e];
            }
          } else this.v.line.end[e] = this.v.line.origin[r][e];
        }
        this.v.d.curr = R.Has(i, "d") ? i.d : R.R(this.v.d.origin - this.v.d.curr + this.v.elapsed), this.v.e.curve = i.e || this.v.e.curve, this.v.e.calc = R.Ease[this.v.e.curve], this.v.delay = R.Has(i, "delay") ? i.delay : this.v.delay, this.v.cb = R.Has(i, "cb") ? i.cb : this.v.cb, this.v.prog = this.v.progE = 0 === this.v.d.curr ? 1 : 0, this.delay = new R.Delay(this.gRaf, this.v.delay);
      },
      gRaf: function gRaf() {
        this.raf.run();
      },
      run: function run(t) {
        1 === this.v.prog ? (this.pause(), this.v.up(), this.v.cb && this.v.cb()) : (this.v.elapsed = R.Clamp(t, 0, this.v.d.curr), this.v.prog = R.Clamp(this.v.elapsed / this.v.d.curr, 0, 1), this.v.progE = this.v.e.calc(this.v.prog), this.v.up());
      },
      uProp: function uProp() {
        for (var t = this.v.prop, i = this.v.propI, r = 0; r < this.v.propL; r++) {
          t[r].curr = this.lerp(t[r].start, t[r].end);
        }

        var e = R.Has(i, "x") ? t[i.x].curr + t[i.x].unit : 0,
            s = R.Has(i, "y") ? t[i.y].curr + t[i.y].unit : 0,
            n = e + s === 0 ? 0 : "translate3d(" + e + "," + s + ",0)",
            a = R.Has(i, "r") ? t[i.r].name + "(" + t[i.r].curr + "deg)" : 0,
            o = R.Has(i, "r2") ? t[i.r2].name + "(" + t[i.r2].curr + "deg)" : 0,
            h = R.Has(i, "s") ? t[i.s].name + "(" + t[i.s].curr + ")" : 0,
            u = n + a + o + h === 0 ? 0 : [n, a, o, h].filter(function (t) {
          return 0 !== t;
        }).join(" "),
            c = R.Has(i, "o") ? t[i.o].curr : -1;

        for (r = 0; r < this.v.elL && !R.Is.und(this.v.el[r]); r++) {
          0 !== u && (this.v.el[r].style.transform = u), 0 <= c && (this.v.el[r].style.opacity = c);
        }
      },
      uSvg: function uSvg() {
        var t = this.v.svg;
        t.currTemp = "";

        for (var i = 0; i < t.arrL; i++) {
          t.val[i] = isNaN(t.arr.start[i]) ? t.arr.start[i] : this.lerp(t.arr.start[i], t.arr.end[i]), t.currTemp += t.val[i] + " ", t.curr = t.currTemp.trim();
        }

        for (i = 0; i < this.v.elL && !R.Is.und(this.v.el[i]); i++) {
          this.v.el[i].setAttribute(t.attr, t.curr);
        }
      },
      uLine: function uLine() {
        for (var t = this.v.line, i = 0; i < this.v.elL; i++) {
          var r = this.v.el[i].style;
          t.curr[i] = this.lerp(t.start[i], t.end[i]), r.strokeDashoffset = t.curr[i], 0 === this.v.prog && (r.opacity = 1);
        }
      },
      lerp: function lerp(t, i) {
        return R.R(R.Lerp(t, i, this.v.progE), this.v.r);
      },
      svgS: function svgS(t) {
        for (var i = [], r = t.split(" "), e = r.length, s = 0; s < e; s++) {
          for (var n = r[s].split(","), a = n.length, o = 0; o < a; o++) {
            var h = n[o];
            h = isNaN(h) ? h : +h, i.push(h);
          }
        }

        return i;
      }
    }, R.TL = function () {
      this.arr = [], this.del = 0;
    }, R.TL.prototype = {
      from: function from(t) {
        this.del += R.Has(t, "delay") ? t.delay : 0, t.delay = this.del, this.arr.push(new R.M(t));
      },
      play: function play(t) {
        this.run("play", t);
      },
      pause: function pause() {
        this.run("pause");
      },
      run: function run(t, i) {
        for (var r = this.arr.length, e = i || void 0, s = 0; s < r; s++) {
          this.arr[s][t](e);
        }
      }
    }, R.BM = function (t, i) {
      for (var r = i.length, e = 0; e < r; e++) {
        t[i[e]] = t[i[e]].bind(t);
      }
    }, R.Clamp = function (t, i, r) {
      return Math.min(Math.max(t, i), r);
    }, R.Delay = function (t, i) {
      this.cb = t, this.d = i, R.BM(this, ["loop"]), this.raf = new R.Raf(this.loop);
    }, R.Delay.prototype = {
      run: function run() {
        0 === this.d ? this.cb() : this.raf.run();
      },
      stop: function stop() {
        this.raf.stop();
      },
      loop: function loop(t) {
        var i = R.Clamp(t, 0, this.d);
        1 === R.Clamp(i / this.d, 0, 1) && (this.stop(), this.cb());
      }
    }, R.Ease = {
      linear: function linear(t) {
        return t;
      },
      i1: function i1(t) {
        return 1 - Math.cos(t * (Math.PI / 2));
      },
      o1: function o1(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      io1: function io1(t) {
        return -.5 * (Math.cos(Math.PI * t) - 1);
      },
      i2: function i2(t) {
        return t * t;
      },
      o2: function o2(t) {
        return t * (2 - t);
      },
      io2: function io2(t) {
        return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
      },
      i3: function i3(t) {
        return t * t * t;
      },
      o3: function o3(t) {
        return --t * t * t + 1;
      },
      io3: function io3(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      },
      i4: function i4(t) {
        return t * t * t * t;
      },
      o4: function o4(t) {
        return 1 - --t * t * t * t;
      },
      io4: function io4(t) {
        return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
      },
      i5: function i5(t) {
        return t * t * t * t * t;
      },
      o5: function o5(t) {
        return 1 + --t * t * t * t * t;
      },
      io5: function io5(t) {
        return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
      },
      i6: function i6(t) {
        return 0 === t ? 0 : Math.pow(2, 10 * (t - 1));
      },
      o6: function o6(t) {
        return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
      },
      io6: function io6(t) {
        return 0 === t ? 0 : 1 === t ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * --t));
      }
    }, R.Has = function (t, i) {
      return !!t && hasOwnProperty.call(t, i);
    }, R.Is = {
      str: function str(t) {
        return "string" == typeof t;
      },
      obj: function obj(t) {
        return t === Object(t);
      },
      arr: function arr(t) {
        return t.constructor === Array;
      },
      def: function def(t) {
        return void 0 !== t;
      },
      und: function und(t) {
        return void 0 === t;
      }
    }, R.Lerp = function (t, i, r) {
      return t * (1 - r) + i * r;
    }, R.R = function (t, i) {
      i = R.Is.und(i) ? 100 : Math.pow(10, i);
      return Math.round(t * i) / i;
    }, R.RafId = 0;

    var Raf = function Raf(t) {
      this.cb = t, this.active = !1, (this.c = this).id = R.RafId, R.RafId++, R.BM(this, ["loop"]);
    };

    Raf.prototype = {
      run: function run(t) {
        t ? this.sT += t : (R.Tab.add(this.id, this.c), this.sT = 0), this.gR(), this.active = !0;
      },
      stop: function stop(t) {
        this.active = !1, cancelAnimationFrame(this.raf), t || R.Tab.remove(this.id);
      },
      gR: function gR() {
        this.raf = requestAnimationFrame(this.loop);
      },
      loop: function loop(t) {
        this.time(t), this.active && this.gR();
      },
      time: function time(t) {
        this.sT || (this.sT = t);
        var i = t - this.sT;
        this.cb(i, this.id);
      }
    }, R.Raf = Raf, R.Rand = function (t, i, r) {
      return R.R(Math.random() * (i - t) + t, r);
    }, R.Snif = {
      uA: navigator.userAgent.toLowerCase(),

      get isMobileIE() {
        return /iemobile/i.test(this.uA);
      },

      get isMobileOpera() {
        return /opera mini/i.test(this.uA);
      },

      get isIOS() {
        return /iphone|ipad|ipod/i.test(this.uA);
      },

      get isBlackberry() {
        return /blackberry/i.test(this.uA);
      },

      get isMobileAndroid() {
        return /android.*mobile/.test(this.uA);
      },

      get isAndroid() {
        return this.isMobileAndroid || !this.isMobileAndroid && /android/i.test(this.uA);
      },

      get isFirefox() {
        return -1 < this.uA.indexOf("firefox");
      },

      get safari() {
        return this.uA.match(/version\/[\d\.]+.*safari/);
      },

      get isSafari() {
        return !!this.safari && !this.isAndroid;
      },

      get isSafariOlderThan8() {
        var t = 8;
        this.isSafari && (t = +this.safari[0].match(/version\/\d{1,2}/)[0].split("/")[1]);
        return t < 8;
      },

      get isIEolderThan11() {
        return -1 < this.uA.indexOf("msie");
      },

      get isIE11() {
        return 0 < navigator.appVersion.indexOf("Trident/");
      },

      get isIE() {
        return this.isIEolderThan11 || this.isIE11;
      },

      get isEdge() {
        return /Edge\/\d./i.test(this.uA);
      },

      get isMac() {
        return -1 < navigator.platform.toLowerCase().indexOf("mac");
      },

      get isMobile() {
        return this.isMobileAndroid || this.isBlackberry || this.isIOS || this.isMobileOpera || this.isMobileIE;
      },

      get isTouch() {
        return "ontouchstart" in window;
      }

    }, R.Throttle = function (t) {
      this.del = t.delay, this.onlyAtEnd = t.onlyAtEnd, this.cb = t.cb, this.last, this.t;
    }, R.Throttle.prototype = {
      run: function run() {
        var t = this,
            i = !0,
            r = Date.now();
        this.last && r < this.last + this.del || i ? (i = !1, clearTimeout(this.t), this.t = setTimeout(function () {
          t.last = r, t.cb();
        }, this.del)) : (this.last = r, this.onlyAtEnd || (i = !1, this.cb()));
      }
    }, R.Cr = function (t) {
      return document.createElement(t);
    }, R.G = {
      p: function p(t) {
        return t || document;
      },
      id: function id(t, i) {
        return this.p(i).getElementById(t);
      },
      "class": function _class(t, i) {
        return this.p(i).getElementsByClassName(t);
      },
      tag: function tag(t, i) {
        return this.p(i).getElementsByTagName(t);
      }
    }, R.Dom = {
      html: document.documentElement,
      body: document.body
    }, R.Select = {
      el: function el(t) {
        var i = [];

        if (R.Is.str(t)) {
          var r = t.substring(1);
          "#" === t.charAt(0) ? i[0] = R.G.id(r) : i = R.G["class"](r);
        } else i[0] = t;

        return i;
      },
      type: function type(t) {
        return "#" === t.charAt(0) ? "id" : "class";
      },
      name: function name(t) {
        return t.substring(1);
      }
    }, R.Index = {
      i: function i(t, _i) {
        for (var r = _i.length, e = 0; e < r; e++) {
          if (t === _i[e]) return e;
        }

        return -1;
      },
      list: function list(t) {
        var i = t.parentNode.children;
        return this.i(t, i);
      },
      "class": function _class(t, i) {
        var r = R.G["class"](i);
        return this.i(t, r);
      }
    }, R.L = function (t, i, r, e) {
      var s = document,
          n = (t = R.Select.el(t)).length,
          a = r,
          o = "mouse",
          h = ["scroll", o + "Wheel", o + "move", "touchmove", "touchstart"],
          u = -1 !== h.indexOf(r) && {
        passive: !1
      };
      r === h[1] ? a = "onwheel" in s ? "wheel" : R.Is.def(s.onmousewheel) ? o + "wheel" : "DOMMouseScroll" : "focusOut" === r && (a = R.Snif.isFirefox ? "blur" : "focusout");

      for (var c = "a" === i ? "add" : "remove", l = 0; l < n; l++) {
        t[l][c + "EventListener"](a, e, u);
      }
    };

    var MM = function MM(t) {
      this.cb = t.cb, this.el = R.Has(t, "el") ? R.Select.el(t.el)[0] : document, this.iM = R.Snif.isMobile, this.eT = this.iM ? "touch" : "mouse", this.tick = !1, R.BM(this, ["gRaf", "run"]), this.raf = new R.Raf(this.run);
    };

    MM.prototype = {
      on: function on() {
        this.l("a");
      },
      off: function off() {
        this.l("r");
      },
      l: function l(t) {
        R.L(this.el, t, this.eT + "move", this.gRaf);
      },
      gRaf: function gRaf(t) {
        this.e = t, this.tick || (this.tick = !0, this.raf.run());
      },
      run: function run() {
        var t = this.iM ? this.e.changedTouches[0] : this.e;
        this.cb(t.pageX, t.pageY, this.e), this.raf.stop(), this.tick = !1;
      }
    }, R.MM = MM;

    var RO = function RO(t) {
      this.cb = t.cb, this.eT = R.Snif.isMobile ? "orientationchange" : "resize", this.tick = !1, R.BM(this, ["gT", "gRaf", "run"]), this.t = new R.Throttle({
        delay: t.throttleDelay,
        onlyAtEnd: !0,
        cb: this.gRaf
      }), this.raf = new R.Raf(this.run);
    };

    RO.prototype = {
      on: function on() {
        this.l("a");
      },
      off: function off() {
        this.l("r");
      },
      l: function l(t) {
        R.L(window, t, this.eT, this.gT);
      },
      gT: function gT(t) {
        this.e = t, this.t.run();
      },
      gRaf: function gRaf() {
        this.tick || (this.tick = !0, this.raf.run());
      },
      run: function run() {
        this.cb(this.e), this.raf.stop(), this.tick = !1;
      }
    }, R.RO = RO;

    var Tab = function Tab() {
      this.arr = [], this.arrL = 0, this.pause = 0, R.BM(this, ["run"]), R.L(document, "a", "visibilitychange", this.run);
    };

    Tab.prototype = {
      add: function add(t, i) {
        this.arr.push([t, i]), this.arrL++;
      },
      remove: function remove(t) {
        for (var i = 0; i < this.arrL; i++) {
          this.arr[i][0] === t && (this.arr.splice(i, 1), this.arrL--);
        }
      },
      run: function run() {
        var t = performance.now();

        if (document.hidden) {
          this.pause = performance.now();

          for (var i = 0; i < this.arrL; i++) {
            this.arr[i][1].stop(!0);
          }
        } else {
          var r = t - this.pause;

          for (i = 0; i < this.arrL; i++) {
            this.arr[i][1].run(r);
          }
        }
      }
    }, R.Tab = new Tab(), R.STop = function (t) {
      var i,
          r = pageYOffset,
          e = {
        dest: 0,
        d: (i = R.Lerp(300, 1500, r / t.h), 0 === r ? 0 : i),
        e: r <= 2500 ? "io" + Math.ceil(r / 500) : "io6",
        cb: t.cb
      };
      R.STo(e);
    }, R.STo = function (t) {
      var i = document,
          r = i.scrollingElement ? i.scrollingElement : R.Dom.body,
          e = R.Snif.isFirefox || R.Snif.isIE ? i.documentElement : r,
          s = pageYOffset,
          n = t.dest,
          a = new R.M({
        d: t.d,
        e: t.e,
        update: function update(t) {
          e.scrollTop = R.R(R.Lerp(s, n, t.progress));
        },
        cb: o
      });

      function o() {
        t.cb && t.cb();
      }

      s === n ? o() : a.play();
    }, R.SZero = function () {
      window.scrollTo(0, 0);
    }, R.TopRefresh = function () {
      "scrollRestoration" in history ? history.scrollRestoration = "manual" : window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };
    }, R.PE = {
      s: function s(t, i) {
        t.style.pointerEvents = i;
      },
      all: function all(t) {
        this.s(t, "all");
      },
      none: function none(t) {
        this.s(t, "none");
      }
    }, R.T = function (t, i, r, e) {
      var s = R.Is.und(e) ? "%" : e;
      t.style.transform = "translate3d(" + i + s + "," + r + s + ",0)";
    };
  });

  var Support =
  /*#__PURE__*/
  function () {
    function Support() {
      _classCallCheck(this, Support);

      var c = _C;
      var snif = r.Snif; // Issues

      if (snif.isIEolderThan11 || snif.isSafariOlderThan8) {
        this.issue('update your browser');
      } else if (!this.glOn()) {
        this.issue('enable WebGL');
      } // Mobile


      c.isMobile = snif.isMobile || innerWidth < 768;
      c.isDesktop = !c.isMobile;
      c.isDevice = c.isMobile ? 'mobile' : 'desktop';
      c.isTouch = snif.isMobile;
      r.Dom.body.className = '_' + c.isDevice.charAt(0);
    }

    _createClass(Support, [{
      key: "issue",
      value: function issue(msg) {
        var issueW = this.div('-w');
        var issue = this.div('');
        issue.textContent = 'Please ' + msg + ' to view this website.';
        issueW.appendChild(issue);
        r.G.id('app').appendChild(issueW);
      }
    }, {
      key: "div",
      value: function div(c) {
        var div = r.Cr('div');
        div.className = 'iss' + c;
        return div;
      }
    }, {
      key: "glOn",
      value: function glOn() {
        try {
          var c = r.Cr('canvas');
          return !!window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'));
        } catch (e) {
          return false;
        }
      }
    }]);

    return Support;
  }();

  var Xhr =
  /*#__PURE__*/
  function () {
    function Xhr() {
      _classCallCheck(this, Xhr);
    }

    _createClass(Xhr, null, [{
      key: "controller",
      value: function controller(page, cb) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', page, true);
        xhr.responseType = 'document';

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var r$1 = xhr.response;
            var xhrBody = r.G.id('xhr', r$1);

            if (xhrBody) {
              var xhrContent = xhrBody.children[0];
              var title = r.G.tag('title', r$1)[0].textContent;
              r.G.tag('title')[0].textContent = title;
              history.pushState({}, '', page);
              cb(xhrContent);
            } else {
              window.location.href = page;
            }
          }
        };

        xhr.send(null);
      }
    }, {
      key: "onPopstate",
      value: function onPopstate() {
        var d = document;
        var w = window;
        var c = 'complete';
        var a = 'a';
        var popstateEventStopper = d.readyState !== c;
        r.L(w, a, 'load', load);
        r.L(w, a, 'popstate', popstate);

        function load() {
          setTimeout(function (_) {
            popstateEventStopper = false;
          }, 0);
        }

        function popstate(e) {
          if (popstateEventStopper && d.readyState === c) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }

        onpopstate = function onpopstate(e) {
          location.href = location.pathname;
        };
      }
    }]);

    return Xhr;
  }();

  var EDelegation =
  /*#__PURE__*/
  function () {
    function EDelegation(tr) {
      _classCallCheck(this, EDelegation);

      console.log('EDelegation'); // Transition

      this.tr = tr; // Parameters

      this.c = _C;
      this.c.eventDelegation = this;
      this.xhr = r.G.id('xhr');
      this.modulesId = 0;
      this.xhr.children[0].dataset.modulesId = this.modulesId;
      this.c.listener.createModules(this.xhr.children[0]); // Bind

      r.BM(this, ['eD', 'ajaxHref', 'done', 'xhrCb']);
      r.L(r.Dom.body, 'a', 'click', this.eD);
    }

    _createClass(EDelegation, [{
      key: "eD",
      value: function eD(e) {
        var w = window;
        var target = e.target;
        var targetIsATag = false;

        function pD() {
          e.preventDefault();
        }

        while (target) {
          var tagName = target.tagName;

          if (tagName === 'A') {
            targetIsATag = true;
            break;
          } else if ((tagName === 'INPUT' || tagName === 'BUTTON') && target.type === 'submit') {
            break;
          }

          target = target.parentNode;
        }

        if (targetIsATag) {
          var targetHref = target.href;

          if (target.classList.contains('_tb')) {
            // Target blank W3C compliant
            pD();
            w.open(targetHref);
          } else if (target.classList.contains('_pd')) {
            pD();
          } else if (target.classList.contains('yotpo-page-element')) ; else {
            this.ajaxHref(targetHref, target, e);
          }
        }
      }
    }, {
      key: "ajaxHref",
      value: function ajaxHref(href, target, e) {
        var t = href;
        var isInternal = href.charAt(0) === '/' || t.replace(/https?:\/\//i, '').indexOf(location.hostname) === 0;
        var isExternal = !isInternal; // console.log('isExternal', isExternal, href, t, location.hostname)
        // if (e) e.preventDefault()
        // return

        if (href.substring(0, 6) === 'mailto') {
          if (e) e.preventDefault(); // Prevent a white tab to stay open

          var myWindow = window.open(href);
          setTimeout(function (_) {
            myWindow.close();
          }, 300);
        } else if (isExternal) {
          if (e) e.preventDefault();
          window.open(href);
        } else {
          // DO NOTHING
          if (!e) window.location.href = href; // We have disabled page-to-page transitions until we are able to fully
          // test site behavior, plugins and analytics
          // if (this.c.outroIsOn) {
          //     this.path = {
          //         old: location.pathname,
          //         new: href.replace(/^.*\/\/[^/]+/, '')
          //     }
          //
          //     if (this.path.old !== this.path.new) {
          //         this.c.outroIsOn = false
          //
          //         this.xhrReq(target)
          //     }
          // }
        }
      }
    }, {
      key: "xhrReq",
      value: function xhrReq(target) {
        this.c.done = this.done;
        this.c.target = target;
        this.c.path = this.path; // Old outro

        this.tr.outro();
      }
    }, {
      key: "done",
      value: function done() {
        Xhr.controller(this.path["new"], this.xhrCb);
      }
    }, {
      key: "xhrCb",
      value: function xhrCb(r) {
        var _this = this;

        this.c.xhr = {
          insertNew: function insertNew(_) {
            _this.xhr.appendChild(r);

            r.dataset.modulesId = ++_this.modulesId;

            _this.c.listener.createModules(r);
          },
          removeOld: function removeOld(_) {
            var xhrC = _this.xhr.children[0];
            xhrC.parentNode.removeChild(xhrC);

            _this.c.listener.destroyModules(xhrC);
          } // New intro

        };
        this.tr.intro();
      }
    }]);

    return EDelegation;
  }();

  var Loader =
  /*#__PURE__*/
  function () {
    function Loader() {
      _classCallCheck(this, Loader);

      this.c = _C;
    }

    _createClass(Loader, [{
      key: "init",
      value: function init(o) {
        // -------------------------------------------
        // Elements
        var loaderLogo = r.G.id('loader-logo'); // -------------------------------------------
        // Local

        var isLocal = this.c.isLocal;
        var d1 = isLocal ? 0 : 400; // -------------------------------------------
        // Loader show

        var _show = new r.TL();

        _show.from({
          el: loaderLogo,
          p: {
            opacity: [0, 1]
          },
          d: d1,
          e: 'linear',
          delay: d1
        }); // -------------------------------------------
        // Loader hide


        var _hide = new r.TL();

        _hide.from({
          el: loaderLogo,
          p: {
            opacity: [1, 0]
          },
          d: d1,
          e: 'linear'
        });

        return {
          show: function show(_) {
            _show.play();
          },
          hide: function hide(_) {
            _hide.play();
          }
        };
      }
    }]);

    return Loader;
  }();

  var Loader$1 = new Loader();

  var Grid =
  /*#__PURE__*/
  function () {
    function Grid() {
      _classCallCheck(this, Grid);

      this.inDom = false;
      r.BM(this, ['click']);

      if (r.G.id('grid-cta')) {
        r.L('#grid-cta', 'a', 'click', this.click);
      } // this.click()

    }

    _createClass(Grid, [{
      key: "click",
      value: function click() {
        if (this.inDom) {
          // Remove grid
          if (this.gridW.className === 'o') {
            this.gridW.parentNode.removeChild(this.gridW);
            this.inDom = false; // Change grid opacity
          } else {
            this.gridW.className = 'o';
          } // Add grid

        } else {
          // Grid wrap
          var g = 'grid';
          this.gridW = r.Cr('div');
          this.gridW.id = g + '-w';
          var grid = r.Cr('div'); // Grid

          grid.id = g; // Grid columns 9

          var gridCol = [];

          for (var i = 0; i < 9; i++) {
            gridCol[i] = r.Cr('div');
            grid.appendChild(gridCol[i]);
          } // Add to dom


          this.gridW.appendChild(grid);
          r.G.id('app').appendChild(this.gridW);
          this.inDom = true;
        }
      }
    }]);

    return Grid;
  }();

  var Color =
  /*#__PURE__*/
  function () {
    function Color() {
      _classCallCheck(this, Color);

      this.c = _C;
      this.bgLight = r.G.id('bg-light');
      this.update();
    }

    _createClass(Color, [{
      key: "update",
      value: function update() {
        var topNav = r.G["class"]('top-nav')[0];
        if (!topNav) return;
        var isHomePage = this.c.path["new"] === '/' || this.c.path["new"] === '/account/logout';
        var bgIsDark = isHomePage;
        this.cL(topNav, bgIsDark, 'dark');
        this.bgLight.style.opacity = bgIsDark ? 0 : 1;
        var noBanner = r.Is.und(r.G["class"]('alert-banner')[0]); // Page update

        var page = r.G["class"]('page')[0];
        this.cL(page, noBanner, 'banner-enable');
      }
    }, {
      key: "cL",
      value: function cL(el, condition, c) {
        var action = condition ? 'remove' : 'add';
        el.classList[action](c);
      }
    }]);

    return Color;
  }();

  var Inside =
  /*#__PURE__*/
  function () {
    function Inside() {
      _classCallCheck(this, Inside);

      this.c = _C;
    }

    _createClass(Inside, [{
      key: "init",
      value: function init(o) {
        this.arr = [];
        var sections = r.G.id('xhr').children[0].children;
        this.arrL = sections.length;
        this.cb = o.cb; // -----------------------
        // Arr
        // -----------------------

        for (var i = 0; i < this.arrL; i++) {
          var a = this.arr[i] = {};
          a.dom = sections[i]; // -----------------------
          // Inside

          a.isOut = true;
          a.inside = {};
        }
      }
    }, {
      key: "resize",
      value: function resize(scroll) {
        var winH = this.c.win.h;

        for (var i = 0; i < this.arrL; i++) {
          var a = this.arr[i]; // -----------------------
          // Draw
          // -----------------------

          this.draw(a, scroll); // -----------------------
          // Inside for dom
          // -----------------------

          var top = a.dom.getBoundingClientRect().top;
          var bottom = top + a.dom.offsetHeight; // Inside init

          a.inside.top = top - winH + scroll;
          a.inside.bottom = bottom + scroll;
        }
      }
    }, {
      key: "run",
      value: function run(o) {
        var scroll = o.scroll;

        for (var i = 0; i < this.arrL; i++) {
          var a = this.arr[i];

          if (scroll >= a.inside.top && scroll <= a.inside.bottom) {
            a.isOut = false;
            this.draw(a, scroll);
          } else if (!a.isOut) {
            a.isOut = true;
            this.draw(a, scroll);
          }
        }
      }
    }, {
      key: "draw",
      value: function draw(a, scroll) {
        this.cb(a.dom, scroll);
      }
    }, {
      key: "reset",
      value: function reset() {
        for (var i = 0; i < this.arrL; i++) {
          var a = this.arr[i];
          this.draw(a, 0);
        }
      }
    }]);

    return Inside;
  }();

  var Inside$1 = new Inside();

  var VScroll =
  /*#__PURE__*/
  function () {
    function VScroll(o) {
      _classCallCheck(this, VScroll);

      this.c = _C;
      this.cbX = o.x;
      this.cbXL = r.Is.def(o.x) ? this.cbX.length : 0;
      this.cbY = o.y;
      this.isOn = false;
      this.x = 0;
      this.y = 0;
      this.isFF = r.Snif.isFirefox;
      this.e = {
        target: r.G.id('app') // Bind

      };
      r.BM(this, ['raf', 'run', 'tS']);
    }

    _createClass(VScroll, [{
      key: "on",
      value: function on(o) {
        if (o.reset) {
          this.x = 0;
          this.y = 0;
          this.c.formNeedKey = false;
        }

        this.isOn = true;
        this.tick = false; // Only add Listeners above 767 or on touch device

        if (innerWidth >= 768 || this.c.isTouch) {
          this.manageListener('a');
        } else if (this.c.sideBarIsOpen['cart'] || this.c.sideBarIsOpen['sign'] || this.c.lightboxIsOn) {
          this.manageListener('a');
        }
      }
    }, {
      key: "off",
      value: function off() {
        this.isOn = false;
        this.manageListener('r');

        if (this.c.isMobile) {
          Inside$1.reset();
        }
      }
    }, {
      key: "manageListener",
      value: function manageListener(a) {
        var tD = ['wheel', 'keydown'];
        var tM = ['touchmove', 'touchstart'];
        var t = this.c.isTouch ? tM : tD;

        for (var i = 0; i < 2; i++) {
          var cb = this.c.isTouch && i === 1 ? this.tS : this.raf;

          if (a === 'a') {
            document.addEventListener(t[i], cb, {
              capture: false,
              passive: false
            });
          } else {
            document.removeEventListener(t[i], cb, {
              capture: false,
              passive: false
            });
          } // R.L(document, a, t[i], cb)

        }
      }
    }, {
      key: "scrollTo",
      value: function scrollTo(t) {
        this.y = -t;
      }
    }, {
      key: "resize",
      value: function resize(maxY) {
        this.maxY = maxY;

        if (this.c.win) {
          this.spaceGap = this.c.win.h - 40;
        }

        if (this.c.outroIsOn) {
          this.gCb();
        }
      }
    }, {
      key: "raf",
      value: function raf(e) {
        this.e = e;
        this.eT = e.type;
        this.eK = e.key;
        if (!this.isOn && this.c.isMobile) return;
        if (this.c.isMobile && this.c.isSliding) return;

        if (e.cancelable && (this.eT !== 'keydown' || this.eK === 'Tab' && !this.c.formNeedKey)) {
          e.preventDefault();
        }

        if (!this.isOn && !this.c.isMobile) return;

        if (!this.tick) {
          requestAnimationFrame(this.run);
          this.tick = true;
        }
      }
    }, {
      key: "run",
      value: function run() {
        var eT = this.eT;

        if (eT === 'wheel') {
          this.onW();
        } else if (eT === 'mousewheel') {
          // IE11
          this.onMW();
        } else if (eT === 'touchmove') {
          this.tM();
        } else if (eT === 'keydown') {
          if (this.c.formNeedKey) {
            this.gCb();
          } else {
            this.keyD();
          }
        }
      }
    }, {
      key: "onMW",
      value: function onMW() {
        var dY = this.e.wheelDeltaY ? this.e.wheelDeltaY : this.e.wheelDelta;
        this.y += dY;
        this.gCb();
      }
    }, {
      key: "onW",
      value: function onW() {
        var dX = this.e.wheelDeltaX || this.e.deltaX * -1;
        var dY = this.e.wheelDeltaY || this.e.deltaY * -1;
        var need60 = this.isFF && this.e.deltaMode === 1;

        if (Math.abs(dX) > Math.abs(dY)) {
          if (need60) {
            dX *= 60;
          }

          dX *= 0.556;
          this.x = dX;
        } else {
          if (need60) {
            dY *= 60;
          }

          dY *= 0.556;
          this.x = 0;
          this.y += dY;
        }

        this.gCb();
      }
    }, {
      key: "tS",
      value: function tS(e) {
        this.prevMove = this.y;
        this.start = e.targetTouches[0].pageY;
      }
    }, {
      key: "tM",
      value: function tM() {
        this.y = (this.e.targetTouches[0].pageY - this.start) * 2 + this.prevMove;
        this.gCb();
      }
    }, {
      key: "keyD",
      value: function keyD() {
        var k = this.eK;
        var up = k === 'ArrowUp';
        var down = k === 'ArrowDown';
        var space = k === ' ';

        if (up || down || space) {
          var dY = 0;

          if (up) {
            dY = 100;
          } else if (down) {
            dY = -100;
          } else if (space) {
            var direction = this.e.shiftKey ? 1 : -1;
            dY = this.spaceGap * direction;
          }

          this.y += dY;
          this.gCb();
        } else {
          this.tick = false;
        }
      }
    }, {
      key: "gCb",
      value: function gCb() {
        if (!this.tick) return;
        this.y = r.R(r.Clamp(this.y, -this.maxY, 0));

        if (this.x === 0) {
          this.cbY(-this.y);
        } else {
          for (var i = 0; i < this.cbXL; i++) {
            this.cbX[i](-this.x, this.e.target);
          }
        }

        this.tick = false;
      }
    }]);

    return VScroll;
  }();

  var ScrollSecondary =
  /*#__PURE__*/
  function () {
    function ScrollSecondary(o) {
      _classCallCheck(this, ScrollSecondary);

      this.c = _C;
      this.a = {
        pause: function pause(_) {}
      };
      this.sY = {};
      this.needScrollbar = r.Is.def(o) && o.fromConfigCustom; // Bind maker

      r.BM(this, ['scroll', 'loop', 'resize', 'move', 'down', 'up']); // Event

      this.vScroll = new VScroll({
        y: this.scroll
      });
      this.raf = new r.Raf(this.loop);
      this.ro = new r.RO({
        cb: this.resize,
        throttleDelay: 100
      });

      if (this.needScrollbar) {
        this.startY = 0;
        this.isDown = false;
        this.baseC = 'pack-config-custom-desktop-scrollbar';
      }
    }

    _createClass(ScrollSecondary, [{
      key: "init",
      value: function init(o) {
        this.el = r.Select.el(o.el)[0];
        this.wrap = o.wrap;

        if (this.needScrollbar) {
          this.scrollbarWrap = r.G["class"](this.baseC + '-wrap')[0];
          this.scrollbar = r.G["class"](this.baseC)[0];
          this.mm = new r.MM({
            cb: this.move,
            el: '.' + this.baseC + '-wrap'
          });
        }

        this.sYUp(0);
        this.resize();
        this.ro.on();
      }
    }, {
      key: "resize",
      value: function resize(upTargetOnly) {
        var wrapH = r.Is.def(this.wrap) ? this.wrap.offsetHeight : this.c.win.h;
        var elH = this.el.offsetHeight;
        this.maxY = elH - wrapH;
        this.vScroll.resize(this.maxY);

        if (this.needScrollbar) {
          var scrollbarH = Math.min(wrapH / elH * wrapH, wrapH);
          var noScrollBarRequired = wrapH === scrollbarH;
          this.scrollbarWrap.style.opacity = noScrollBarRequired ? 0 : 1;
          this.scrollbar.style.height = noScrollBarRequired ? 0 + 'px' : scrollbarH + 'px';
          this.scrollTarget = wrapH - scrollbarH;
        }

        var newSYTarg = this.minMax(this.sY.targ);

        if (upTargetOnly) {
          this.sY.targ = newSYTarg;
        } else {
          this.sYUp(newSYTarg);
        }

        this.draw();
      }
    }, {
      key: "down",
      value: function down(e) {
        this.isDown = true;
        this.startY = e.pageY;
        this.last = this.sY.targ;
      }
    }, {
      key: "move",
      value: function move(x, y, e) {
        if (!this.isDown) return;
        this.sY.targ = (y - this.startY) * 2 + this.last;
        this.sY.targ = this.minMax(this.sY.targ);
      }
    }, {
      key: "minMax",
      value: function minMax(v) {
        return r.R(r.Clamp(v, this.maxY, 0));
      }
    }, {
      key: "up",
      value: function up() {
        this.isDown = false;
      }
    }, {
      key: "l",
      value: function l(a) {
        var d = document;
        r.L(this.scrollbarWrap, a, 'mousedown', this.down);
        r.L(d, a, 'mouseup', this.up);
        r.L(d, a, 'mouseout', this.up);
      }
    }, {
      key: "run",
      value: function run() {
        this.raf.run();
      }
    }, {
      key: "on",
      value: function on(o) {
        if (this.needScrollbar) {
          this.mm.on();
          this.l('a');
        }

        this.vScroll.on(o);
      }
    }, {
      key: "off",
      value: function off() {
        if (this.needScrollbar) {
          this.mm.off();
          this.l('r');
        }

        this.ro.off();
        this.vScroll.off();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.raf.stop();
        this.sYUp(this.minMax(this.sY.curr));
      }
    }, {
      key: "scroll",
      value: function scroll(y) {
        this.sY.targ = r.R(y);
      }
    }, {
      key: "sTo",
      value: function sTo(o) {
        var _this = this;

        var start = this.sY.targ;
        var end = r.R(r.Clamp(o.targ, 0, this.maxY));
        this.a = new r.M({
          d: o.d,
          e: o.e,
          update: function update(v) {
            var y = r.Lerp(start, end, v.progeE);

            _this.vScroll.scrollTo(y);

            _this.scroll(0, y);
          }
        });
        this.a.play();
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.sY.currR !== this.sY.targ) {
          this.sY.curr += (this.sY.targ - this.sY.curr) * 0.1;
          this.sY.currR = r.R(this.sY.curr);
          this.draw();
        }
      }
    }, {
      key: "draw",
      value: function draw() {
        r.T(this.el, 0, -this.sY.currR, 'px');

        if (this.needScrollbar) {
          var scrollbarY = this.sY.currR / this.maxY * this.scrollTarget;
          r.T(this.scrollbar, 0, scrollbarY, 'px');
        }
      }
    }, {
      key: "sYUp",
      value: function sYUp(y) {
        // Update all y
        this.sY.targ = y;
        this.sY.curr = y;
        this.sY.currR = 0;
      }
    }]);

    return ScrollSecondary;
  }();

  var OverPage =
  /*#__PURE__*/
  function () {
    function OverPage() {
      _classCallCheck(this, OverPage);

      this.c = _C;
      this.c.overPageIsOn = false; // Instance

      this.sOverPage = new ScrollSecondary(); // Elements

      this.overPage = r.G.id('over-page');
    }

    _createClass(OverPage, [{
      key: "show",
      value: function show() {
        r.PE.all(this.overPage);
        this.c.overPageIsOn = true; // this.c.GL.show({d: 700, e: 'o2', fromMenu: true, cb: false})

        this.c.sail.show({
          d: 400,
          e: 'o1',
          fromMenu: true,
          cb: false
        });
      }
    }, {
      key: "lightboxShow",
      value: function lightboxShow() {
        r.PE.all(this.overPage);
        this.c.overPageIsOn = true; // this.c.GL.show({d: 700, e: 'o2', fromLightbox: true, cb: false})

        this.c.sail.show({
          d: 400,
          e: 'o1',
          fromLightbox: true,
          cb: false
        });
        this.c.lightboxIsOn = true;
        var lightbox = r.G.id('lightbox');
        this.sOn({
          el: lightbox
        });
      }
    }, {
      key: "videoShow",
      value: function videoShow() {
        r.PE.all(this.overPage);
        this.c.overPageIsOn = true;
        this.c.sail.show({
          d: 400,
          e: 'o1',
          fromMenu: true,
          cb: false
        });
      }
    }, {
      key: "textModalShow",
      value: function textModalShow() {
        r.PE.all(this.overPage);
        this.c.overPageIsOn = true;
        this.c.sail.show({
          d: 400,
          e: 'o1',
          fromMenu: true,
          cb: false
        });
      }
    }, {
      key: "hide",
      value: function hide() {
        this.c.overPageIsOn = false;
        r.PE.none(this.overPage); // this.c.GL.hide({d: 900, e: 'o3', cb: false})

        this.c.sail.hide({
          d: 500,
          e: 'o3'
        });
      }
    }, {
      key: "transitionMobileMenu",
      value: function transitionMobileMenu() {
        this.c.overPageIsOn = false;
        r.PE.none(this.overPage); // this.c.GL.fromOverPage({d: 300, e: 'linear', cb: false})

        this.c.sail.fromOverPage({
          d: 500,
          e: 'o3'
        });
      }
    }, {
      key: "transitionCartDesktop",
      value: function transitionCartDesktop() {
        this.c.overPageIsOn = false;
        r.PE.none(this.overPage); // this.c.GL.fromOverPage({d: 300, e: 'linear', cb: false})

        this.c.sail.fromOverPage({
          d: 500,
          e: 'o3'
        });
      }
    }, {
      key: "transitionCartMobile",
      value: function transitionCartMobile() {
        this.c.overPageIsOn = false;
        r.PE.none(this.overPage); // this.c.GL.show({d: 700, e: 'o2', fromMenu: false, cb: false})

        this.c.sail.show({
          d: 400,
          e: 'o1',
          fromMenu: false,
          cb: false
        });
      }
    }, {
      key: "sOn",
      value: function sOn(o) {
        if (this.c.isDesktop) {
          this.c.smoothScroll.disableScrolling(); // this.c.scroll.off()
        }

        this.sOverPage.init(o);
        this.sOverPage.run();
        this.sOverPage.on({
          reset: true
        });
      }
    }, {
      key: "sOff",
      value: function sOff() {
        this.sOverPage.off();

        if (this.c.isDesktop) {
          this.c.smoothScroll.enableScrolling(); // this.c.scroll.on({reset: false})
        }
      }
    }, {
      key: "sDestroy",
      value: function sDestroy() {
        this.sOverPage.destroy();
      }
    }, {
      key: "sResize",
      value: function sResize() {
        this.sOverPage.resize();
      }
    }]);

    return OverPage;
  }();

  var Sail =
  /*#__PURE__*/
  function () {
    function Sail() {
      _classCallCheck(this, Sail);

      this.c = _C;
      this.s = r.G.id('sail');
      this.sLight = r.G.id('sail-light');
      this.opacityMax = 1;
    }

    _createClass(Sail, [{
      key: "show",
      value: function show(o) {
        var isLight = true;

        if (o.fromMenu || o.fromIntro) {
          isLight = false;
        } else if (o.fromLightbox) {
          isLight = true;
        } else if (this.c.path.old === '/') {
          isLight = false;
        }

        this.opacityMax = o.fromMenu || o.fromLightbox && this.c.isDesktop ? 0.96 : 1;
        this.sLight.style.opacity = isLight ? 1 : 0;
        this.tl([0, this.opacityMax], o);
      }
    }, {
      key: "fromOverPage",
      value: function fromOverPage(o) {
        this.tl([0.96, 1], o);
      }
    }, {
      key: "hide",
      value: function hide(o) {
        if (!o) {
          this.s.style.opacity = 0;
        } else {
          this.tl([this.opacityMax, 0], o);
        }
      }
    }, {
      key: "tl",
      value: function tl(p, o) {
        var tl = new r.TL();
        tl.from({
          el: this.s,
          p: {
            opacity: p
          },
          d: o.d,
          e: o.e,
          cb: o.cb
        });
        tl.play();
      }
    }]);

    return Sail;
  }();

  var Preloader =
  /*#__PURE__*/
  function () {
    function Preloader() {
      _classCallCheck(this, Preloader);

      this.c = _C;
    }

    _createClass(Preloader, [{
      key: "run",
      value: function run() {
        var isDesktop = this.c.isDesktop;
        this.isLocal = this.c.isLocal; // -------------------------------------------
        // GL
        // this.c.GLCore.init()
        // this.c.GL.init()

        this.c.sail = new Sail(); // -------------------------------------------
        // C instance

        this.c.topNavColor = new Color();
        this.c.overPage = new OverPage(); // -------------------------------------------
        // Grid

        new Grid(); // -----------------------

        this.loader = Loader$1.init(); // this.loader.show()
        // -----------------------
        // const delay = this.isLocal ? 0 : 1000
        // new R.Delay(_ => {
        //     this.hide()
        // }, delay).run()
        // testing!

        this.c.listener.init();
        this.loader.hide();
        this.c.outroIsOn = true;
        this.c.listener.on();
        this.c.sail.hide(); // this.c.sail.hide({d: 0, e: 'o2'})
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this = this;

        this.c.listener.init(); // -----------------------

        this.loader.hide(); // -----------------------

        var delay = this.isLocal ? 0 : 500;
        var delayGl = this.isLocal ? 0 : 500;
        new r.Delay(function (_) {
          new r.Delay(function (_) {
            _this.c.outroIsOn = true;

            _this.c.listener.on();
          }, 300).run();

          _this.c.sail.hide({
            d: 500,
            e: 'o2'
          }); // this.c.GL.hide({d: delayGl, e: 'o3'})

        }, delay).run();
      }
    }]);

    return Preloader;
  }();

  var Preloader$1 = new Preloader();

  var Transition =
  /*#__PURE__*/
  function () {
    function Transition() {
      _classCallCheck(this, Transition);
    }

    _createClass(Transition, [{
      key: "outro",
      value: function outro() {
        this.c = _C; // -----------------------

        this.c.listener.off(); // -----------------------

        if (this.c.mobileMenuIsOpen) {
          this.c.mobileMenu.closeTransition({
            cb: this.c.done
          });
        } else if (this.c.sideBarIsOpen.cart) {
          this.c.cartSidebar.closeTransition({
            cb: this.c.done
          });
        } else if (this.c.sideBarIsOpen.sign) {
          this.c.signinSidebar.closeTransition({
            cb: this.c.done
          });
        } else {
          // this.c.GL.show({d: 700, e: 'o2', cb: this.c.done})
          this.c.sail.show({
            d: 400,
            e: 'o1',
            cb: this.c.done
          });
        }
      }
    }, {
      key: "intro",
      value: function intro() {
        var _this = this;

        this.c.outroIsOn = false; // -----------------------

        this.c.xhr.removeOld();
        this.c.xhr.insertNew(); // -----------------------

        r.SZero(); // -----------------------

        this.c.topNavColor.update(); // -----------------------

        this.c.listener.init(); // -----------------------

        new r.Delay(function (_) {
          _this.c.outroIsOn = true;

          _this.c.listener.on();
        }, 300).run();
        this.c.sail.hide({
          d: 500,
          e: 'o2'
        }); // this.c.GL.hide({d: 900, e: 'o3'})
      }
    }]);

    return Transition;
  }();

  var Transition$1 = new Transition();

  var Controller = function Controller() {
    _classCallCheck(this, Controller);

    var c = _C;
    c.outroIsOn = false; // to paralyse transition outro method during motion

    c.path = {
      "new": location.pathname
    };
    Xhr.onPopstate();
    new EDelegation(Transition$1);
    Preloader$1.run();
  };

  var Resize =
  /*#__PURE__*/
  function () {
    function Resize() {
      _classCallCheck(this, Resize);

      r.BM(this, ['ro']);
      new r.RO({
        cb: this.ro,
        throttleDelay: 100
      }).on();
      this.ro();
    }

    _createClass(Resize, [{
      key: "ro",
      value: function ro() {
        var c = _C;
        var snif = r.Snif;
        c.isMobile = snif.isMobile || innerWidth < 768;
        c.isDesktop = !c.isMobile;
        c.isDevice = c.isMobile ? 'mobile' : 'desktop';
        c.isTouch = snif.isMobile;
        var data = c.data[c.isDevice];
        var psd = data.psd;
        c.win = {
          w: innerWidth,
          h: innerHeight
        };
        c.winDemi = {
          w: c.win.w / 2,
          h: c.win.h / 2
        };
        c.psd = {
          w: psd.w
        };
        c.winWpsdW = c.win.w / c.psd.w;
        c.psdWwinW = c.psd.w / c.win.w;
        c.over500 = window.matchMedia('(min-width: 501px)').matches;

        if (c.isMobile) {
          r.Dom.body.classList.remove('_d');
          r.Dom.body.className = '_m';
          r.Dom.body.classList.add('_mobile-desktop');
        } else {
          r.Dom.body.classList.remove('_m');
          r.Dom.body.className = '_d';
        }
      }
    }]);

    return Resize;
  }();

  var Pointer =
  /*#__PURE__*/
  function () {
    function Pointer() {
      var _this = this;

      _classCallCheck(this, Pointer);

      this.c = _C;
      this.isRunning = false;
      this.timer = new r.Delay(function (_) {
        _this.isRunning = false;

        _this.pointer('all');
      }, 300);
    }

    _createClass(Pointer, [{
      key: "init",
      value: function init() {
        this.isMobile = this.c.isMobile;
        if (this.isMobile) return;
        this.el = r.G["class"]('_p');
        this.elL = this.el.length;
      }
    }, {
      key: "run",
      value: function run() {
        if (this.isMobile) return;
        this.timer.stop();

        if (!this.isRunning) {
          this.isRunning = true;
          this.pointer('none');
        }

        this.timer.run();
      }
    }, {
      key: "pointer",
      value: function pointer(p) {
        for (var i = 0; i < this.elL; i++) {
          r.PE[p](this.el[i]);
        }
      }
    }]);

    return Pointer;
  }();

  new Pointer();

  var MobileSS =
  /*#__PURE__*/
  function () {
    function MobileSS() {
      _classCallCheck(this, MobileSS);

      this.c = _C;

      if (this.c.isMobile) {
        this.start = {
          x: 0,
          y: 0
        };
        r.BM(this, ['pr', 'move', 'down']);
        this.mm = new r.MM({
          cb: this.move
        });
      } else {
        this.c.isSliding = true;
      }
    }

    _createClass(MobileSS, [{
      key: "init",
      value: function init() {
        this.c.isSliding = false;
        this.mm.off();
        this.paralyse('r');
        this.tick = true;
      }
    }, {
      key: "on",
      value: function on() {
        this.mm.on();
        this.downL('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.downL('r');
      }
    }, {
      key: "down",
      value: function down(e) {
        var t = e.targetTouches[0];
        this.start.y = t.pageY;
        this.start.x = t.pageX;
        this.onSlider = e.target.classList.contains('_ss');
        this.c.isSliding = false;
        this.paralyse('r');

        if (!this.tick) {
          this.tick = true;
        }
      }
    }, {
      key: "move",
      value: function move(x, y) {
        if (this.onSlider) {
          if (this.tick) {
            var xDelta = Math.abs(x - this.start.x);
            var yDelta = Math.abs(y - this.start.y); // X and Y need to be different

            if (xDelta !== yDelta) {
              this.tick = false;
              this.c.isSliding = xDelta > yDelta;

              if (this.c.isSliding) {
                this.paralyse('a');
              }
            }
          }
        }
      }
    }, {
      key: "downL",
      value: function downL(a) {
        r.L(document, a, 'touchstart', this.down);
      }
    }, {
      key: "paralyse",
      value: function paralyse(a) {
        r.L(document, a, 'touchmove', this.pr);
      }
    }, {
      key: "pr",
      value: function pr(e) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }
    }]);

    return MobileSS;
  }(); // export default new MobileSS()

  var MobileNav =
  /*#__PURE__*/
  function () {
    function MobileNav() {
      _classCallCheck(this, MobileNav);

      this.c = _C;
      r.BM(this, ['fn']);
      this.nav = r.G["class"]('subpage-nav')[0];
      this.noSubpageNav = r.Is.und(this.nav);
    }

    _createClass(MobileNav, [{
      key: "fn",
      value: function fn(e) {
        if (e.target.href) {
          var href = e.target.href;

          if (href.replace && href.replace(/^.*\/\/[^/]+/, '') !== location.pathname) {
            return;
          }
        }

        var type = this.nav.classList.contains('open') ? 'remove' : 'add';
        this.nav.classList[type]('open');
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (this.noSubpageNav) return;
        r.L(this.nav, a, 'click', this.fn);
      }
    }]);

    return MobileNav;
  }();

  var DisableScrollOnFocus =
  /*#__PURE__*/
  function () {
    function DisableScrollOnFocus() {
      _classCallCheck(this, DisableScrollOnFocus);

      this.c = _C;
      r.BM(this, ['fn']);
    }

    _createClass(DisableScrollOnFocus, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "fn",
      value: function fn(e) {
        this.c.formNeedKey = e.type === 'focus';
      }
    }, {
      key: "l",
      value: function l(a) {
        var t = ['focus', 'blur'];

        for (var i = 0; i < 2; i++) {
          r.L('.form-field', a, t[i], this.fn);
        }
      }
    }]);

    return DisableScrollOnFocus;
  }();

  var DisableScrollOnFocus$1 = new DisableScrollOnFocus();

  var FormField =
  /*#__PURE__*/
  function () {
    function FormField() {
      _classCallCheck(this, FormField);

      this.c = _C;
      r.BM(this, ['fn']);
    }

    _createClass(FormField, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "fn",
      value: function fn(e) {
        var target = e.target;
        var parent = target.parentNode;
        var label = r.G["class"]('form-label', parent)[0];

        function cUp(type, c) {
          parent.classList[type](c);
        }

        if (e.type === 'focus') {
          var t = 'add';
          cUp(t, 'active');
          cUp(t, 'complete');
          r.PE.none(label);
        } else {
          var _t = 'remove';

          if (target.value === '') {
            cUp(_t, 'complete');
          }

          cUp(_t, 'active');
          r.PE.all(label);
        }
      }
    }, {
      key: "l",
      value: function l(a) {
        var t = ['focus', 'blur'];

        for (var i = 0; i < 2; i++) {
          r.L('.form-field', a, t[i], this.fn);
        }
      }
    }]);

    return FormField;
  }();

  var FormField$1 = new FormField();

  var Select =
  /*#__PURE__*/
  function () {
    function Select() {
      _classCallCheck(this, Select);

      this.c = _C;
      r.BM(this, ['fn']);
    }

    _createClass(Select, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "fn",
      value: function fn(e) {
        var target = e.target;
        var parent = target.parentNode;

        function cUp(type, c) {
          parent.classList[type]('active');
        }

        if (e.type === 'click') {
          var t = parent.classList.contains('active') ? 'remove' : 'add';
          cUp(t);
        } else {
          cUp('remove');
        }
      }
    }, {
      key: "l",
      value: function l(a) {
        var t = ['click', 'blur'];

        for (var i = 0; i < 2; i++) {
          r.L('.form-select', a, t[i], this.fn);
        }
      }
    }]);

    return Select;
  }();

  var Select$1 = new Select();

  var Form =
  /*#__PURE__*/
  function () {
    function Form() {
      _classCallCheck(this, Form);

      this.c = _C;
    }

    _createClass(Form, [{
      key: "on",
      value: function on() {
        DisableScrollOnFocus$1.on();
        FormField$1.on();
        Select$1.on();
      }
    }, {
      key: "off",
      value: function off() {
        DisableScrollOnFocus$1.off();
        FormField$1.off();
        Select$1.off();
      }
    }]);

    return Form;
  }();

  var Form$1 = new Form();

  var Slider0 =
  /*#__PURE__*/
  function () {
    function Slider0(o) {
      _classCallCheck(this, Slider0);

      this.c = _C;
      this.isMobile = this.c.isMobile;
      this.isDesktop = this.c.isDesktop;
      this.parentClass = o.parent; // this.parentElement = o.element

      this.isLogo = this.parentClass === '.logos-slider';
      r.BM(this, ['downList', 'upList', 'downProgress', 'upProgress', 'sX']);
      this.c.horizontalScroll.registerScroll(this.sX);
    }

    _createClass(Slider0, [{
      key: "init",
      value: function init(o) {
        this.parent = r.Select.el(this.parentClass)[0]; // this.parent = R.G.class(this.parentClass.slice(1), this.parentElement)[0]

        this.noSlider = r.Is.und(this.parent);
        if (this.noSlider) return;
        var parentC = this.parentClass.substr(1);
        this.ul = r.G["class"]('slider-0-list', this.parent)[0];
        this.listC = parentC + '-list';
        this.linkC = parentC + '-link';
        this.progressC = parentC + '-progress';
        this.sliderListW = r.G["class"]('slider-0-list-w', this.parent)[0];
        this.sliderProgress = r.G["class"]('slider-0-progress', this.parent)[0];
        this.sliderProgressChild = this.sliderProgress.children[0];
        this.progress = r.G["class"]('progress', this.parent)[0];
        this.li = this.ul.children;
        this.liL = this.li.length;
        this.targ = 0;
        this.prev = 0;
        this.curr = 0;
        this.progressTarg = 0;
        this.start = {
          x: 0,
          y: 0
        };
        this.isDownList = false;
        this.y = 0;
        this.lastY = 0;
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.noSlider) return;
        var liWFirst = this.li[0].offsetWidth;
        var liWLast = this.li[this.liL - 1].offsetWidth;
        var marge = this.isLogo ? 0 : liWFirst - liWLast - 2; // 2 for demi pixel tolerence

        this.sliderProgressW = this.sliderProgressChild.offsetWidth;
        var col = this.isLogo ? Math.ceil(this.liL / 2) : this.liL;
        var ulW = liWFirst * col - marge;
        this.ul.style.width = ulW + 'px';
        this.max = -(ulW - this.sliderProgressW);
        this.min = 0;
        this.targ = this.minMax(this.targ);
        this.curr = this.targ; // ------------------------------
        // Progress

        this.progressW = this.progress.offsetWidth;
        this.progressMax = this.sliderProgressW - this.progressW;
        this.progressTarg = this.getProgressTarg();
        this.domUp(this.targ, this.progressTarg); // ------------------------------
        // Progress Drag

        var sliderProgressLeft = this.sliderProgressChild.getBoundingClientRect().left;
        this.progressLeft = sliderProgressLeft;
        this.progressRight = this.progressLeft + this.sliderProgressW;
        this.progressToTarg = this.max / (this.progressRight - this.progressLeft); // ------------------------------
      }
    }, {
      key: "getProgressTarg",
      value: function getProgressTarg() {
        return r.Lerp(0, this.progressMax, this.curr / this.max);
      }
    }, {
      key: "on",
      value: function on() {
        if (this.noSlider) return;
        this.listL('a');
        this.downProgressL('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noSlider) return;
        this.listL('r');
        this.downProgressL('r');
      }
    }, {
      key: "downList",
      value: function downList(e) {
        this.isDownList = true;

        if (!this.c.isTouch) ;

        var t = !this.c.isTouch ? e : e.targetTouches[0];
        this.start.x = t.pageX;
        this.start.y = t.pageY;
        this.last = this.targ;
        this.lastY = this.y;
      }
    }, {
      key: "move",
      value: function move(x, y) {
        if (this.noSlider) return;
        var isDownProgress = this.isDownProgress && this.dragScrollBar; // console.log(this.isDownProgress, this.dragScrollBar)
        // Is down

        if (this.isDownList || isDownProgress) {
          var direction = isDownProgress ? -1 : 1;
          var moveX = (x - this.start.x) * direction;
          this.y = y;
          if (!this.c.isSliding) return;
          var sensitivity = !this.c.isTouch ? 2 : 2.5; // Reset when limit

          if (this.isDownList) {
            if (x > this.prev && this.targ === this.min) {
              this.start.x = x + (this.last - this.min) / sensitivity;
            } else if (x < this.prev && this.targ === this.max) {
              this.start.x = x + (this.last - this.max) / sensitivity;
            }
          }

          this.targ = moveX * sensitivity + this.last;
          this.targ = this.minMax(this.targ);
          this.prev = x;
        }
      }
    }, {
      key: "upList",
      value: function upList(e) {
        if (!this.isDownList) return;
        this.isDownList = false;

        if (!this.c.isTouch) ;

        var target = e.target;
        var click = Math.abs(this.targ - this.last) < 3 && Math.abs(this.y - this.lastY) < 3 && this.isLink(target);

        if (click) {
          var aTag = target.children[0];
          target.children[0].click();
        }
      }
    }, {
      key: "isLink",
      value: function isLink(target) {
        return target.classList.contains(this.linkC);
      }
    }, {
      key: "sX",
      value: function sX(x, target) {
        if (this.noSlider) return;
        var isOver = target.classList.contains(this.listC) || target.classList.contains(this.progressC) || this.isLink(target);

        if (isOver) {
          this.targ -= x;
          this.targ = this.minMax(this.targ);
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.noSlider) return;

        if (r.R(this.curr) !== this.targ) {
          this.curr += (this.targ - this.curr) * 0.09;
          this.progressTarg = this.getProgressTarg();
          this.domUp(r.R(this.curr), this.progressTarg);
        }
      }
    }, {
      key: "domUp",
      value: function domUp(v0, v1) {
        r.T(this.ul, v0, 0, 'px');
        r.T(this.progress, v1, 0, 'px');
      }
    }, {
      key: "minMax",
      value: function minMax(v) {
        return r.R(r.Clamp(v, this.max, this.min));
      }
    }, {
      key: "listL",
      value: function listL(a) {
        var typeDown = this.c.isTouch ? 'touchstart' : 'mousedown';
        var typeUp = this.c.isTouch ? 'touchend' : 'mouseup';
        r.L(this.sliderListW, a, typeDown, this.downList);
        r.L(document, a, typeUp, this.upList);
      }
    }, {
      key: "downProgressL",
      value: function downProgressL(a) {
        var type = !this.c.isTouch ? 'mousedown' : 'touchstart';
        r.L(this.sliderProgress, a, type, this.downProgress);
      }
    }, {
      key: "upProgressL",
      value: function upProgressL(a) {
        var type = !this.c.isTouch ? 'mouseup' : 'touchend';
        r.L(document, a, type, this.upProgress);
      }
    }, {
      key: "downProgress",
      value: function downProgress(e) {
        this.downProgressL('r');
        this.isDownProgress = true;

        if (!this.c.isTouch) ;

        var t = !this.c.isTouch ? e : e.targetTouches[0];
        this.start.x = t.pageX;
        this.last = this.targ;
        this.gTargDown(t.pageX);
        this.upProgressL('a');
      }
    }, {
      key: "gTargDown",
      value: function gTargDown(x) {
        var xProg = x - this.progressLeft;

        if (xProg > this.progressTarg && xProg < this.progressTarg + this.progressW) {
          this.dragScrollBar = true;
        } else {
          this.dragScrollBar = false;

          if (x >= this.progressLeft && x <= this.progressRight) {
            var _xProg = x - this.progressLeft;

            this.targ = _xProg * this.progressToTarg;
          } else if (x < this.progressLeft) {
            this.targ = this.min;
          } else {
            this.targ = this.max;
          }
        }
      }
    }, {
      key: "upProgress",
      value: function upProgress(e) {
        if (!this.isDownProgress) return;
        this.upProgressL('r');
        this.isDownProgress = false;

        if (!this.c.isTouch) ;

        this.downProgressL('a');
      }
    }]);

    return Slider0;
  }();

  (function () {

    if (typeof Array.prototype.findIndex !== "function") {
      Array.prototype.findIndex = function (predicate, thisArg) {
        if (this === null) {
          throw new TypeError('Cannot read property \'findIndex\' of null');
        }

        if (typeof predicate !== "function") {
          throw new TypeError(_typeof(predicate) + ' is not a function');
        }

        var arrLength = this.length;
        var index = -1;

        for (var i = 0; i < arrLength; i++) {
          if (predicate.call(thisArg, this[i], i, this)) {
            index = i;
            break;
          }
        }

        return index;
      };
    }
  })();

  var Slider1 =
  /*#__PURE__*/
  function () {
    function Slider1(o) {
      _classCallCheck(this, Slider1);

      this.c = _C;
      this.parentSelector = o.parent;
      this.parentElement = o.element;
      this.isLightbox = this.parentSelector === '#lightbox';
      this.isHomeHero = this.parentSelector === '.home-hero';
      this.isThreeUp = this.parentSelector === '.three-up-content';
      this.isProductCarouselHero = this.parentSelector === '.product-carousel-hero';
      r.BM(this, ['slide', 'cb', 'down', 'up', 'on', 'click', 'mouseEnter', 'setImageMarginTop']);

      if (this.parentSelector.charAt(0) === '#') {
        this.parent = r.G.id(this.parentSelector.slice(1));
      } else {
        this.parent = r.G["class"](this.parentSelector.slice(1), this.parentElement)[0];
      }

      this.noSlider = r.Is.und(this.parent);
      if (this.noSlider) return;
      this.isRunning = false;
      this.alreadySlided = false;
      this.start = {
        x: 0,
        y: 0
      };
      this.direction = -1;
      this.no = 0; // Common

      this.areaC = 'slider-1-interaction-area';
      this.area = r.G["class"](this.areaC, this.parent)[0];
      this.areaCenter = r.G["class"](this.areaC + '-center', this.parent)[0];
      this.noAreaCenter = r.Is.und(this.areaCenter); // Img

      this.isImgTranslate = r.Is.def(r.G["class"]('slider-img-translate-wrap', this.parent)[0]);
      var imgTypeClass = this.isImgTranslate ? 'translate' : 'fade';
      this.imgW = r.G["class"]('slider-img-' + imgTypeClass + '-w', this.parent);
      this.img = r.G["class"]('slider-img-' + imgTypeClass + '', this.parent);
      this.imgL = this.img.length;
      this.limit = this.imgL - 1; // Progress

      this.progress = r.G["class"]('progress', this.parent)[0];
      this.progressW = r.G["class"]('progress-w', this.parent)[0];
      this.hasProgress = r.Is.def(this.progress); // Pagination

      this.pagination = r.G["class"]('slider-pagination-curr', this.parent)[0];
      this.hasPagination = r.Is.def(this.pagination); // Cursor

      if (!this.c.isTouch) {
        this.cursorIsCenter = undefined;
        this.cursorIsVisible = false;
        this.x = -1;
        this.y = -1;
        this.cursor = {
          x: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          y: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          el: {}
        };
        this.cursor.el.main = r.G["class"]('slider-cursor', this.parent)[0];
        this.cursor.el.arrow = r.G["class"]('slider-cursor-arrow-w', this.parent)[0];
        this.cursor.el.center = r.G["class"]('slider-cursor-center', this.parent)[0];
        this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.parent)[0];
        this.cursorShow = new r.M({
          el: this.cursor.el.main,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorScale = new r.M({
          el: this.cursor.el.bg,
          p: {
            scale: [0.9, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorArrowShow = new r.M({
          el: this.cursor.el.arrow,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorCenterShow = new r.M({
          el: this.cursor.el.center,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
      }

      if (this.isLightbox) {
        this.lightboxImgW = r.G.id('lightbox-img');
        this.lightboxInfo = r.G.id('lightbox-info');
      }

      if (imgTypeClass === 'fade') {
        var supportsObjectFit = 'objectFit' in document.documentElement.style;

        if (!supportsObjectFit) {
          for (var i = 0; i < this.imgL; i++) {
            var img = r.G.tag('img', this.img[i])[0];

            if (!img.classList.contains('no-object-fit')) {
              img.classList.add('no-object-fit');
              img.style.backgroundImage = "url(".concat(img.src, ")");
              img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
              img.style.backgroundPosition = 'center';
              img.style.backgroundRepeat = 'no-repeat';
              img.style.backgroundSize = 'contain';
            }
          }
        }
      }
    }

    _createClass(Slider1, [{
      key: "resize",
      value: function resize() {
        if (this.noSlider) return;
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top; // Desktop

        if (!this.c.isTouch) {
          this.areaTop = areaRectTop + pageYOffset;
          this.areaLeft = areaRect.left;

          if (this.noAreaCenter) {
            this.areaCenterLeft = this.area.offsetWidth / 2;
            this.areaCenterRight = this.areaCenterLeft;
          } else {
            this.areaCenterLeft = this.areaCenter.getBoundingClientRect().left;
            this.areaCenterRight = this.areaCenterLeft + this.areaCenter.offsetWidth;
          }

          this.cursor.w = this.cursor.el.main.offsetWidth;
          this.cursor.wDemi = this.cursor.w / 2;
          this.cursor.x.max = this.area.offsetWidth;
          this.cursor.y.max = this.area.offsetHeight; // Mobile
        } else {
          this.areaCenterTop = areaRectTop + pageYOffset;
          this.areaCenterBottom = this.areaCenterTop + this.area.offsetHeight;
        }

        if (this.hasProgress) {
          var progressWWidth = this.progressW.offsetWidth;
          var progressWidth = progressWWidth / this.imgL;
          this.progress.style.width = progressWidth + 'px';
          this.progressStep = progressWidth;
          var progressEnd = r.R(this.progressStep * this.no);
          r.T(this.progress, progressEnd, 0, 'px');
        }

        if (this.c.isMobile && this.isThreeUp) {
          this.l('a');
        }
      }
    }, {
      key: "on",
      value: function on() {
        if (this.noSlider) return;
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noSlider) return;
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (this.c.isTouch) {
          r.L(this.area, a, 'touchstart', this.down);
          r.L(this.area, a, 'touchend', this.up);
        } else {
          r.L(this.area, a, 'click', this.slide);
          r.L(this.area, a, 'mouseover', this.mouseEnter);
        }
      }
    }, {
      key: "down",
      value: function down(e) {
        this.alreadySlided = false;
        var tt = e.targetTouches[0];
        this.start.x = tt.pageX;
        this.start.y = tt.pageY + pageYOffset;
      }
    }, {
      key: "up",
      value: function up(e) {
        if (!this.alreadySlided) {
          var ct = e.changedTouches[0];
          var x = ct.pageX;
          var y = ct.pageY;
          var deltaY = Math.abs(this.start.y - (y + pageYOffset));
          var deltaX = Math.abs(this.start.x - x);
          var overLink = y > this.areaCenterTop && y < this.areaCenterBottom;

          if (deltaY < 2 && deltaX < 2 && overLink) {
            this.click();
          }
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (this.noSlider) return; // -----------------------
        // Desktop
        // -----------------------

        if (!this.c.isTouch) {
          this.moveDesktop(x, y, target); // -----------------------
          // Mobile
          // -----------------------
        } else if (this.c.isSliding) {
          // if (this.isHomeHero) {
          if (target === this.area) {
            this.moveMobile(x, y, target);
          }
        }
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;

        if (this.isThreeUp) {
          this.y = y - this.threeUpAreaTop;
        } else {
          this.y = y - this.areaTop;
        }

        this.moveTarget = target;
      }
    }, {
      key: "moveMobile",
      value: function moveMobile(x, y, target) {
        // if (Math.abs(deltaX) < 50 || this.alreadySlided || R.Is.und(target)) return
        var deltaY = y - this.start.y + pageYOffset;
        var deltaX = x - this.start.x;
        if (Math.abs(deltaX) < 30 || Math.abs(deltaY) > Math.abs(deltaX) || this.alreadySlided) return;
        this.alreadySlided = true;
        this.direction = deltaX > 0 ? -1 : 1;
        this.slide();
      }
    }, {
      key: "mouseEnter",
      value: function mouseEnter() {
        if (this.isThreeUp && this.c.isMobile) {
          this.threeUpAreaTop = this.area.getBoundingClientRect().top + pageYOffset;
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.noSlider) return;
        var x = r.R(this.x);
        var y = r.R(this.y);

        if (!this.c.isTouch) {
          // Check if in slider
          var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
          var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
          var cursorIn = xIn && yIn;

          if (cursorIn) {
            if (this.isLightbox) {
              cursorIn = this.c.lightboxIsOn;
            } else {
              cursorIn = !this.c.overPageIsOn;
            }
          }

          if (cursorIn) {
            cursorIn = this.moveTarget.classList.contains(this.areaC);
          }

          if (cursorIn) {
            this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
            this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

            if (!this.cursorIsVisible) {
              this.cursorIsVisible = true;
              this.cursor.x.curr = this.cursor.x.targ;
              this.cursor.y.curr = this.cursor.y.targ;
              this.cursorShow.play();
              this.cursorScale.play();
            }
          } else if (!cursorIn && this.cursorIsVisible) {
            this.cursorIsVisible = false;
            this.cursorIsCenter = undefined;
            this.cursorShow.play({
              reverse: true
            });
            this.cursorScale.play({
              reverse: true
            });
          }

          var cursorXMoving = r.R(this.cursor.x.curr) !== this.cursor.x.targ;
          var cursorYMoving = r.R(this.cursor.y.curr) !== this.cursor.y.targ;
          var cursorMoving = cursorXMoving || cursorYMoving;

          if (cursorMoving || cursorIn) {
            // Direction
            if (this.x + this.areaLeft > this.areaCenterRight) {
              this.direction = 1;
            } else if (this.x + this.areaLeft <= this.areaCenterLeft) {
              this.direction = -1;
            } else {
              this.direction = 0;
            } // Change cursor


            this.firstTimeDi = r.Is.und(this.cursorIsCenter);
            var d = this.firstTimeDi ? 0 : 300;

            if (this.direction === 0 && (!this.cursorIsCenter || this.firstTimeDi)) {
              this.cursorIsCenter = true;
              this.cursorArrowShow.play({
                d: d,
                reverse: true
              });
              this.cursorCenterShow.play({
                d: d
              });
            } else if (this.direction !== 0) {
              if (this.cursorIsCenter || this.firstTimeDi) {
                this.cursorIsCenter = false;
                this.cursorArrowShow.play({
                  d: d
                });
                this.cursorCenterShow.play({
                  d: d,
                  reverse: true
                });
              }

              if (this.direction === 1) {
                this.cursor.el.arrow.style.transform = 'rotate(0deg)';
              } else {
                this.cursor.el.arrow.style.transform = 'rotate(180deg)';
              }
            }

            this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
            this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
            r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
          }
        }
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }, {
      key: "slideRight",
      value: function slideRight(force) {
        this.direction = 1;
        var index = this.no + 1;
        if (index > this.limit) index = 0;
        this.slide(null, index, force);
      }
    }, {
      key: "slideToIndex",
      value: function slideToIndex(index, force) {
        if (index > this.no) {
          this.direction = 1;
        } else {
          this.direction = -1;
        }

        this.slide(null, index, force);
      }
    }, {
      key: "slide",
      value: function slide(e, index, force) {
        if (!force) {
          if (this.isRunning || r.Is.und(this.cursorIsCenter) && !this.c.isTouch) {
            // console.log('returning', this.isRunning, R.Is.und(this.cursorIsCenter), !this.c.isTouch)
            return;
          }
        }

        if (this.direction === 0) {
          this.click();
          return;
        } else if (!this.limit) {
          return;
        } else if (index !== undefined) {
          if (index > this.limit) {
            this.newNo = this.limit;
          } else if (index < 0) {
            this.newNo = 0;
          } else {
            this.newNo = index;
          }
        } else {
          this.isRunning = true;
          this.c.outroIsOn = false;

          if (this.direction === 1) {
            if (this.no === this.limit) {
              this.newNo = 0;
            } else {
              this.newNo = this.no + 1;
            }
          } else if (this.direction === -1) {
            if (this.no === 0) {
              this.newNo = this.limit;
            } else {
              this.newNo = this.no - 1;
            }
          }
        }

        var d0 = 600;
        var d1 = 1000;
        var e0 = 'i3';
        var e1 = 'o5';
        var eMobile = 'o4';
        var dMobile = 1000;
        var tl0 = new r.TL();
        var tl1 = new r.TL();
        var tl2 = new r.TL(); // -------------------------------------------
        // Progress

        if (this.hasProgress) {
          var progressStart = r.R(this.progressStep * this.no);
          var progressEnd = r.R(this.progressStep * this.newNo);
          var progressDemi = (progressStart + progressEnd) / 2;

          if (!this.c.isTouch) {
            tl1.from({
              el: this.progress,
              p: {
                x: [progressStart, progressDemi, 'px']
              },
              d: d0,
              e: e0
            });
            tl1.from({
              el: this.progress,
              p: {
                x: [progressDemi, progressEnd, 'px']
              },
              d: d1,
              e: e1,
              delay: d0
            });
          } else {
            tl1.from({
              el: this.progress,
              p: {
                x: [progressStart, progressEnd, 'px']
              },
              d: dMobile,
              e: eMobile
            });
          }
        } // -------------------------------------------
        // Img
        // Translate


        if (this.isImgTranslate) {
          var noEnd = -60 * this.direction;
          var noEndDemi = noEnd / 2;
          var newNoEnd = 100 * this.direction;
          var newNoEndDemi = newNoEnd / 2;

          if (!this.c.isTouch) {
            // Step 0
            tl0.from({
              el: this.imgW[this.no],
              p: {
                x: [0, noEndDemi]
              },
              d: d0,
              e: e0
            });
            tl0.from({
              el: this.imgW[this.newNo],
              p: {
                x: [newNoEnd, newNoEndDemi]
              },
              d: d0,
              e: e0
            });
            tl0.from({
              el: this.img[this.newNo],
              p: {
                scale: [1.4, 1.2]
              },
              d: d0,
              e: e0,
              r: 4
            }); // Step 1

            tl0.from({
              el: this.imgW[this.no],
              p: {
                x: [noEndDemi, noEnd]
              },
              d: d1,
              e: e1,
              delay: d0
            });
            tl0.from({
              el: this.imgW[this.newNo],
              p: {
                x: [newNoEndDemi, 0]
              },
              d: d1,
              e: e1
            });
            tl0.from({
              el: this.img[this.newNo],
              p: {
                scale: [1.2, 1]
              },
              d: d1,
              e: e1,
              cb: this.cb,
              r: 4
            });
          } else {
            tl0.from({
              el: this.imgW[this.no],
              p: {
                x: [0, noEnd]
              },
              d: dMobile,
              e: eMobile
            });
            tl0.from({
              el: this.imgW[this.newNo],
              p: {
                x: [newNoEnd, 0]
              },
              d: dMobile,
              e: eMobile
            });
            tl0.from({
              el: this.img[this.newNo],
              p: {
                scale: [1.4, 1]
              },
              d: dMobile,
              e: eMobile,
              cb: this.cb,
              r: 4
            });
          } // Fade

        } else {
          tl0.from({
            el: this.img[this.no],
            p: {
              opacity: [1, 0]
            },
            d: 500,
            e: 'o3'
          });
          tl0.from({
            el: this.img[this.newNo],
            p: {
              opacity: [0, 1]
            },
            d: 500,
            e: 'o3',
            cb: this.cb
          });
        } // Z Index


        if (this.isImgTranslate) {
          this.imgW[this.newNo].style.zIndex = 2;
          this.imgW[this.no].style.zIndex = 1;
        } // -------------------------------------------
        // Optional


        if (this.isLightbox) {
          this.lightboxMotion(tl2);
          this.c.overPage.sResize();
        } else if (this.isHomeHero) {
          this.homeHeroMotion(tl2);
        } else if (this.isThreeUp) {
          this.threeUpMotion(tl2);
        } else if (this.isProductCarouselHero) {
          this.productCarouselMotion(tl2);
        } // -------------------------------------------
        // Pagination


        if (this.hasPagination) {
          var currValue = this.newNo + 1;
          var leadingZero = currValue < 10 ? '0' : '';
          this.pagination.textContent = '0' + leadingZero + currValue;
        } // -------------------------------------------
        // Go


        tl0.play();
        tl1.play();
        tl2.play();
        if (this.onWillSlide) this.onWillSlide();
      }
    }, {
      key: "cb",
      value: function cb() {
        if (this.isImgTranslate) {
          this.imgW[this.no].style.zIndex = 1;
          r.T(this.imgW[this.no], -100, 0);
        }

        this.no = this.newNo;
        this.c.outroIsOn = true;
        this.isRunning = false;
      }
    }, {
      key: "click",
      value: function click() {
        var _this = this;

        if (!this.c.outroIsOn) return;
        this.target = r.G["class"]('slider-1-url', this.parent)[this.no];

        if (r.Is.def(this.target)) {
          this.href = this.target.href;
          this.c.eventDelegation.ajaxHref(this.href); // } else if (!this.c.isTouch) {
        } else if (!this.isLightbox) {
          var index;

          if (this.no === 0) {
            var variantImage = this.img[0].children[0];
            index = this.c.backendData.lightbox.simpleProduct.findIndex(function (x) {
              return x.url.replace(_this.c.s3Domain, _this.c.cloudFrontDomain) === variantImage.src;
            });
          } else {
            var image = this.img[this.no].children[0].children[2];
            index = this.c.backendData.lightbox.simpleProduct.findIndex(function (x) {
              return x.url.replace(_this.c.s3Domain, _this.c.cloudFrontDomain) === image.src;
            });
          }

          this.c.lightbox.show({
            cb: this.on,
            index: index
          });
        }
      }
    }, {
      key: "reset",
      value: function reset() {
        this.no = 0;
      }
    }, {
      key: "lightboxMotion",
      value: function lightboxMotion(tl2) {
        var simpleLi = r.G["class"]('lightbox-simple-li');
        var accessoriesLi = r.G["class"]('lightbox-accessories-li');

        if (simpleLi.length > 0) {
          var liNo = simpleLi[this.no];
          var liNewNo = simpleLi[this.newNo];
          tl2.from({
            el: liNo,
            p: {
              opacity: [1, 0]
            },
            d: 300,
            e: 'o3'
          });
          tl2.from({
            el: liNewNo,
            p: {
              opacity: [0, 1]
            },
            d: 500,
            e: 'o3'
          });
          liNo.classList.add('hidden');
          liNewNo.classList.remove('hidden');
        } else if (accessoriesLi.length > 0) {
          var _liNo = accessoriesLi[this.no];
          var _liNewNo = accessoriesLi[this.newNo]; // Transition

          tl2.from({
            el: _liNo,
            p: {
              opacity: [1, 0]
            },
            d: 300,
            e: 'o3'
          });
          tl2.from({
            el: _liNewNo,
            p: {
              opacity: [0, 1]
            },
            d: 500,
            e: 'o3'
          }); // Colors li PE

          var colorListNo = r.G["class"]('configurator-left-options-color', _liNo)[0].children;
          var colorListNoL = colorListNo.length;
          var colorListNewNo = r.G["class"]('configurator-left-options-color', _liNewNo)[0].children;
          var colorListNewNoL = colorListNewNo.length;

          for (var i = 0; i < colorListNoL; i++) {
            r.PE.none(colorListNo[i]);
          }

          for (var _i = 0; _i < colorListNewNoL; _i++) {
            r.PE.all(colorListNewNo[_i]);
          } // Btn PE


          var btnNo = r.G["class"]('btn-w', _liNo)[0];
          var btnNewNo = r.G["class"]('btn-w', _liNewNo)[0];
          if (btnNo) r.PE.none(btnNo);
          if (btnNewNo) r.PE.all(btnNewNo);

          _liNo.classList.add('hidden');

          _liNewNo.classList.remove('hidden');
        }

        this.setImageMarginTop();
      }
    }, {
      key: "setImageMarginTop",
      value: function setImageMarginTop() {
        var simpleLi = r.G["class"]('lightbox-simple-li');
        var accessoriesLi = r.G["class"]('lightbox-accessories-li');

        if (simpleLi.length > 0) {
          if (this.c.isDesktop) {
            this.lightboxImgW.style.marginTop = null;
          } else {
            this.lightboxImgW.style.marginTop = simpleLi[this.newNo].offsetHeight + this.lightboxInfo.offsetHeight + 75 + 'px';
          }
        } else if (accessoriesLi.length > 0) {
          if (this.c.isDesktop) {
            this.lightboxImgW.style.marginTop = null;
          } else {
            this.lightboxImgW.style.marginTop = accessoriesLi[this.newNo].offsetHeight + this.lightboxInfo.offsetHeight + 'px';
          }
        }
      }
    }, {
      key: "homeHeroMotion",
      value: function homeHeroMotion(tl2) {
        var img = r.G["class"]('home-hero-svg-' + this.c.isDevice, this.parentElement)[0].children;
        var imgL = img.length / 2;
        var d0 = 600;
        var e0 = 'o2';
        var e1 = 'o3';
        tl2.from({
          el: img[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: img[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1,
          delay: d0
        });
      }
    }, {
      key: "threeUpMotion",
      value: function threeUpMotion(tl2) {
        var txt = r.G["class"]('three-up-txt');
        var d0 = 600;
        var e0 = 'o2';
        var e1 = 'o3';
        tl2.from({
          el: txt[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: txt[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1,
          delay: d0
        });
      }
    }, {
      key: "productCarouselMotion",
      value: function productCarouselMotion(tl2) {
        var primary = r.G["class"]('product-carousel-hero-primary');
        var secondary = r.G["class"]('product-carousel-hero-secondary');
        var tertiary = r.G["class"]('product-carousel-hero-tertiary');
        var price = r.G["class"]('product-carousel-hero-price');
        var star = r.G["class"]('product-carousel-hero-star');
        var btnLi = r.G["class"]('product-carousel-btn-li');
        var btn = r.G["class"]('product-carousel-btn-li');
        var d0 = 600;
        var e0 = 'o2';
        var e1 = 'o3';
        tl2.from({
          el: primary[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: secondary[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: tertiary[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: price[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: star[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: btnLi[this.no],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: e0
        });
        tl2.from({
          el: primary[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1,
          delay: d0
        });
        tl2.from({
          el: secondary[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1
        });
        tl2.from({
          el: tertiary[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1
        });
        tl2.from({
          el: price[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1
        });
        tl2.from({
          el: star[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1
        });
        tl2.from({
          el: btnLi[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d0,
          e: e1
        });
        r.PE.none(btnLi[this.no].children[0]);
        r.PE.all(btnLi[this.newNo].children[0]);
      }
    }]);

    return Slider1;
  }();

  var EditorialPhotoStrip =
  /*#__PURE__*/
  function () {
    function EditorialPhotoStrip(element) {
      _classCallCheck(this, EditorialPhotoStrip);

      this.c = _C;
      this.isDesktop = this.c.isDesktop;
      this.isDown = false;
      this.startX = 0;
      r.BM(this, ['up', 'down']);
      this.parent = r.G["class"]('editorial-photo-strip-list-w', element)[0];
      this.ul = r.G["class"]('editorial-photo-strip-list', this.parent)[0];
      this.noSlider = !this.c.isMobile;
      this.li = this.ul.children;
      this.liL = this.li.length;
      this.no = 1;
      this.targ = 0;
      this.prev = 0;
      this.curr = 0;
    }

    _createClass(EditorialPhotoStrip, [{
      key: "resize",
      value: function resize() {
        this.noSlider = !this.c.isMobile;

        if (this.noSlider) {
          this.ul.style.transform = 'inherit';
          return;
        }

        this.winDemiW = this.c.winDemi.w;
        var ulLeft = this.ul.getBoundingClientRect().left - this.targ;
        this.max = -(this.ul.offsetWidth - (this.c.win.w - ulLeft * 2));
        this.min = 0;
        this.arr = [];

        for (var i = 0; i < this.liL; i++) {
          var li = this.li[i];
          var liW = li.offsetWidth;
          var liLeft = li.getBoundingClientRect().left - this.targ;
          var margeLeft = i === 0 ? 0 : (liLeft - (this.arr[i - 1].left + this.arr[i - 1].w)) / 2;
          this.arr[i] = {
            w: liW,
            wDemi: liW / 2,
            left: liLeft,
            limit: -(liLeft - margeLeft - this.winDemiW)
          };
        }

        this.targUp();
        this.curr = this.targ;
        this.domUp(this.targ);
      }
    }, {
      key: "targUp",
      value: function targUp() {
        var arrCurr = this.arr[this.no]; // if (!arrCurr) return

        var arrCurrCenter = arrCurr.left + arrCurr.wDemi;
        this.targ = r.R(r.Clamp(this.winDemiW - arrCurrCenter, this.max, this.min));
      }
    }, {
      key: "on",
      value: function on() {
        if (this.noSlider) return;
        this.downL('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noSlider) return;
        this.downL('r');
      }
    }, {
      key: "down",
      value: function down(e) {
        this.downL('r'); // -----------------------

        this.isDown = true;
        var t = this.isDesktop ? e : e.targetTouches[0];
        this.startX = t.pageX;
        this.last = this.targ; // ----------------------

        this.upL('a');
      }
    }, {
      key: "move",
      value: function move(x) {
        if (this.noSlider || !this.isDown || !this.c.isSliding) return;
        var sensitivity = 3; // Reset when limit

        if (x > this.prev && this.targ === this.min) {
          this.startX = x + (this.last - this.min) / sensitivity;
        } else if (x < this.prev && this.targ === this.max) {
          this.startX = x + (this.last - this.max) / sensitivity;
        }

        this.targ = (x - this.startX) * sensitivity + this.last;
        this.targ = r.R(r.Clamp(this.targ, this.max, this.min));
        this.prev = x;
      }
    }, {
      key: "up",
      value: function up() {
        this.upL('r'); // -----------------------

        this.isDown = false;
        var no = 0;

        for (var i = this.liL - 1; i > -1; i--) {
          if (this.targ < this.arr[i].limit) {
            no = i;
            break;
          }
        }

        this.no = no;
        this.targUp(); // -----------------------

        this.downL('a');
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.noSlider) return;

        if (r.R(this.curr) !== this.targ) {
          this.curr += (this.targ - this.curr) * 0.09;
          this.domUp(r.R(this.curr));
        }
      }
    }, {
      key: "domUp",
      value: function domUp(v) {
        r.T(this.ul, v, 0, 'px');
      }
    }, {
      key: "downL",
      value: function downL(a) {
        r.L(this.parent, a, 'touchstart', this.down);
      }
    }, {
      key: "upL",
      value: function upL(a) {
        r.L(this.parent, a, 'touchend', this.up);
      }
    }]);

    return EditorialPhotoStrip;
  }();

  Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
    value: function value(r, e) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var t = Object(this),
          n = t.length >>> 0;
      if (0 === n) return !1;

      for (var i = 0 | e, o = Math.max(i >= 0 ? i : n - Math.abs(i), 0); o < n;) {
        if (function (r, e) {
          return r === e || "number" == typeof r && "number" == typeof e && isNaN(r) && isNaN(e);
        }(t[o], r)) return !0;
        o++;
      }

      return !1;
    }
  });

  var ReviewQuestion =
  /*#__PURE__*/
  function () {
    function ReviewQuestion(element) {
      var _this = this;

      _classCallCheck(this, ReviewQuestion);

      this.c = _C;
      this.element = element;
      this.reviewsFound = false;
      r.BM(this, ['domMutation', 'internalClick']);

      try {
        var config = {
          attributes: false,
          childList: true,
          subtree: true
        };
        this.observer = new MutationObserver(this.domMutation);
        this.observer.observe(element, config);
      } catch (err) {
        console.log(err);
      }

      if (window.yotpo) {
        try {
          window.yotpo.refreshWidgets();
        } catch (error) {
          console.log(error);
        }

        setTimeout(function (_) {
          if (_this.c.scroll) _this.c.scroll.resize();
        }, 500);
      }

      this.element.addEventListener('click', this.internalClick);
    }

    _createClass(ReviewQuestion, [{
      key: "deinit",
      value: function deinit() {
        this.observer.disconnect();
        this.element.removeEventListener('click', this.internalClick);

        if (window.yotpo) {
          try {
            window.yotpo.refreshWidgets();
          } catch (error) {
            console.log(error);
          }
        }
      }
    }, {
      key: "domMutation",
      value: function domMutation(mutationsList, observer) {
        var _this2 = this;

        mutationsList.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            _this2.checkForReviews();

            if (_this2.c.scroll) _this2.c.scroll.resize();
          }
        });
      }
    }, {
      key: "internalClick",
      value: function internalClick(e) {
        var _this3 = this;

        if (this.c.scroll) this.c.scroll.resize();
        setTimeout(function (_) {
          if (_this3.c.scroll) _this3.c.scroll.resize();

          _this3.c.smoothScroll.reset();
        }, 1000);
      }
    }, {
      key: "checkForReviews",
      value: function checkForReviews() {
        if (this.reviewsFound) return;
        var mainWidget = r.G["class"]('main-widget', this.element)[0];
        if (!mainWidget) return;
        var avgScore = r.G["class"]('avg-score', mainWidget)[0];
        if (!avgScore) return;
        var numReviews = r.G["class"]('reviews-qa-label', mainWidget)[0];
        this.avgRating = parseFloat(avgScore.innerHTML.split(' ')[0]);
        this.numRatings = parseInt(numReviews.innerHTML.split(' ')[0]);

        try {
          this.dispatchEvent();
        } catch (error) {
          console.log(error);
        }

        this.reviewsFound = true;
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent() {
        var reviewsEvent = new CustomEvent('reviewsloaded', {
          detail: {
            averageRating: this.avgRating,
            count: this.numRatings
          }
        });
        window.dispatchEvent(reviewsEvent);
      }
    }]);

    return ReviewQuestion;
  }();

  var TouchDisable =
  /*#__PURE__*/
  function () {
    function TouchDisable() {
      _classCallCheck(this, TouchDisable);
    }

    _createClass(TouchDisable, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(document, a, 'touchmove', this.p);
      }
    }, {
      key: "p",
      value: function p(e) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }
    }]);

    return TouchDisable;
  }();

  var TouchDisable$1 = new TouchDisable();

  function debounce (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  !function (r) {
    function n(e) {
      if (t[e]) return t[e].exports;
      var o = t[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return r[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    var t = {};
    n.m = r, n.c = t, n.d = function (r, t, e) {
      n.o(r, t) || Object.defineProperty(r, t, {
        configurable: !1,
        enumerable: !0,
        get: e
      });
    }, n.n = function (r) {
      var t = r && r.__esModule ? function () {
        return r["default"];
      } : function () {
        return r;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (r, n) {
      return Object.prototype.hasOwnProperty.call(r, n);
    }, n.p = "", n(n.s = 0);
  }([function (r, n) {
    Array.from || (Array.from = function () {
      var r = Object.prototype.toString,
          n = function n(_n) {
        return "function" == typeof _n || "[object Function]" === r.call(_n);
      },
          t = function t(r) {
        var n = Number(r);
        return isNaN(n) ? 0 : 0 !== n && isFinite(n) ? (n > 0 ? 1 : -1) * Math.floor(Math.abs(n)) : n;
      },
          e = Math.pow(2, 53) - 1,
          o = function o(r) {
        var n = t(r);
        return Math.min(Math.max(n, 0), e);
      };

      return function (r) {
        var t = this,
            e = Object(r);
        if (null == r) throw new TypeError("Array.from requires an array-like object - not null or undefined");
        var u,
            i = arguments.length > 1 ? arguments[1] : void 0;

        if (void 0 !== i) {
          if (!n(i)) throw new TypeError("Array.from: when provided, the second argument must be a function");
          arguments.length > 2 && (u = arguments[2]);
        }

        for (var a, c = o(e.length), f = n(t) ? Object(new t(c)) : new Array(c), l = 0; l < c;) {
          a = e[l], f[l] = i ? void 0 === u ? i(a, l) : i.call(u, a, l) : a, l += 1;
        }

        return f.length = c, f;
      };
    }());
  }]);

  var ProductGrid =
  /*#__PURE__*/
  function () {
    function ProductGrid(element) {
      _classCallCheck(this, ProductGrid);

      this.c = _C;
      this.isDesktop = this.c.isDesktop;
      this.isMobile = this.c.isMobile;
      r.BM(this, ['down', 'up', 'filterOpen', 'filterClose', 'filterOptionClick', 'addFilter', 'removeFilter', 'filterItems']);
      this.filterOptions = r.G["class"]('product-grid-nav-list', element)[0];
      this.filterDrag = r.G["class"]('product-grid-nav-price-drag', element)[0];
      this.filterPriceWrapper = r.G["class"]('product-grid-nav-price-list', element)[0];
      this.filterMaxPriceElement = r.G.tag('li', this.filterPriceWrapper)[1];
      this.progressW = r.G["class"]('progress-w', this.filterDrag)[0];
      this.progress = r.G["class"]('progress', this.filterDrag)[0];
      this.filter = r.G["class"]('product-grid-header-filter', element)[0];
      this.navWrap = r.G["class"]('product-grid-nav-wrap', element)[0];
      this.navW = r.G["class"]('product-grid-nav-w', element)[0];
      this.bg = r.G["class"]('product-grid-nav-bg', element)[0];
      this.close = r.G["class"]('product-grid-nav-close', element)[0];
      this.navOpen = new r.TL();
      this.navOpen.from({
        el: this.bg,
        p: {
          opacity: [0, 0.7]
        },
        d: 1000,
        e: 'o3'
      });
      this.navOpen.from({
        el: this.navW,
        p: {
          x: [-100, 0]
        },
        d: 1000,
        e: 'o6'
      });
      this.isDown = false;
      this.priceFilterValue = 1;
      this.maxPrice = parseInt(this.filterDrag.dataset.maxPrice);
      var maxPriceString = this.filterMaxPriceElement.innerHTML;
      var maxPriceSubstring = maxPriceString.match(/\d+(?:\.\d+)?/)[0];
      this.maxPriceDisplay = parseFloat(maxPriceSubstring);
      this.maxPriceDecorators = maxPriceString.split(maxPriceSubstring);
      this.gridWrapper = r.G["class"]('product-grid-list-w', element)[0];
      var items = [];
      Array.from(r.G["class"]('product-grid-list', element)).forEach(function (el) {
        items.push({
          element: el,
          price: parseInt(el.dataset.price),
          collections: el.dataset.collections.split(','),
          tags: el.dataset.tags.split(',')
        });
      });
      this.items = items; // Debouncer function to debounce the filter items function

      this.filterItemsDebouncer = debounce(this.filterItems, 250);
    }

    _createClass(ProductGrid, [{
      key: "resize",
      value: function resize() {
        if (this.noGrid) return;
        this.progressWidth = this.progressW.offsetWidth;
        this.min = 0;
        this.max = this.progressWidth;
        this.curr = this.priceFilterValue * this.max;
        this.targ = this.curr;
        var progressX = r.R(r.Lerp(-100, 0, this.curr / this.max));
        r.T(this.progress, progressX, 0);
      }
    }, {
      key: "on",
      value: function on() {
        this.downL('a');
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.downL('r');
        this.l('r');
      }
    }, {
      key: "filterOpen",
      value: function filterOpen() {
        TouchDisable$1.on();
        r.PE.all(this.navWrap);
        this.navOpen.play();
      }
    }, {
      key: "filterClose",
      value: function filterClose() {
        this.navOpen.play({
          reverse: true
        });
        r.PE.none(this.navWrap);
        TouchDisable$1.off();
      }
    }, {
      key: "down",
      value: function down(e) {
        this.downL('r');
        document.body.classList.add('dragging');
        this.isDown = true;

        if (this.isDesktop) ;

        this.progressLeft = this.progressW.getBoundingClientRect().left;
        this.progressRight = this.progressLeft + this.progressWidth;
        var t = this.isDesktop ? e : e.targetTouches[0];
        this.gTarg(t.pageX);
        this.upL('a');
      }
    }, {
      key: "move",
      value: function move(x) {
        if (this.noGrid || !this.isDown) return;
        this.gTarg(x);
      }
    }, {
      key: "gTarg",
      value: function gTarg(x) {
        if (x >= this.progressLeft && x <= this.progressRight) {
          this.targ = x - this.progressLeft;
        } else if (x < this.progressLeft) {
          this.targ = this.min;
        } else {
          this.targ = this.max;
        }

        this.priceFilterValue = this.targ / this.max;
        this.filterPriceWrapper.style.width = Math.max(Math.round(this.priceFilterValue * 10000) / 100, 33) + '%';
        this.filterMaxPriceElement.innerHTML = this.maxPriceDecorators[0] + Math.ceil(this.maxPriceDisplay * this.priceFilterValue) + this.maxPriceDecorators[1];
        this.filterItemsDebouncer();
      }
    }, {
      key: "up",
      value: function up(e) {
        this.upL('r');
        document.body.classList.remove('dragging');
        this.isDown = false;

        if (this.isDesktop) ;

        this.downL('a');
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.noGrid) return;

        if (Math.abs(r.R(this.curr) - this.targ) > 0.01) {
          this.curr += (this.targ - this.curr) * 0.2;
          var progressX = r.R(r.Lerp(-100, 0, this.curr / this.max));
          r.T(this.progress, progressX, 0);
        } else {
          this.curr = this.targ;

          var _progressX = r.R(r.Lerp(-100, 0, this.curr / this.max));

          r.T(this.progress, _progressX, 0);
        }
      }
    }, {
      key: "downL",
      value: function downL(a) {
        var type = this.isDesktop ? 'mousedown' : 'touchstart';
        r.L(this.filterDrag, a, type, this.down);
      }
    }, {
      key: "upL",
      value: function upL(a) {
        var type = this.isDesktop ? 'mouseup' : 'touchend';
        r.L(document, a, type, this.up);
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.filter, a, 'click', this.filterOpen);
        r.L(this.bg, a, 'click', this.filterClose);
        r.L(this.close, a, 'click', this.filterClose);
        var options = r.G.tag('a', this.filterOptions);

        for (var i = 0; i < options.length; i++) {
          r.L(options[i], a, 'click', this.filterOptionClick);
        }
      }
    }, {
      key: "filterOptionClick",
      value: function filterOptionClick(e) {
        var alreadyActive = e.target.classList.contains('active');
        var hasSublinks = e.target.classList.contains('has-sublinks');
        var isSublink = e.target.classList.contains('sublink');
        var alreadyOpen = e.target.parentNode.classList.contains('open');

        for (var i = 0; i < this.filterOptions.children.length; i++) {
          this.filterOptions.children[i].classList.remove('open');
        }

        var removeActive = function () {
          var activeLinks = r.G["class"]('active', this.filterOptions);

          for (var _i = activeLinks.length - 1; _i >= 0; _i--) {
            activeLinks[_i].classList.remove('active');
          }

          this.filterOptions.classList.remove('has-active');
        }.bind(this);

        if (!alreadyActive && !hasSublinks && !isSublink) {
          // select top option
          removeActive();
          e.target.classList.add('active');
          this.filterOptions.classList.add('has-active');
        } else if (alreadyActive && !hasSublinks && !isSublink) {
          // unselect top option
          removeActive();
        } else if (hasSublinks && !alreadyOpen) {
          // expand option
          if (!alreadyActive) {
            if (r.G["class"]('active', this.filterOptions).length > 1) removeActive();
          }

          e.target.parentNode.classList.add('open');
        } else if (hasSublinks && alreadyOpen) {
          // collapse option
          if (alreadyActive) removeActive();
        } else if (isSublink && !alreadyActive) {
          // select nested option
          removeActive();
          var container = e.target.parentNode.parentNode.parentNode;
          container.classList.add('open');
          r.G.tag('a', container)[0].classList.add('active');
          e.target.classList.add('active');
          this.filterOptions.classList.add('has-active');
        } else if (isSublink && alreadyActive) {
          // unselect nested option
          removeActive();
          var _container = e.target.parentNode.parentNode.parentNode;

          _container.classList.add('open');
        }

        var stillOpen = r.G["class"]('active', this.filterOptions);
        var index = stillOpen.length - 1;

        if (index >= 0) {
          this.addFilter(stillOpen[index].href);
        } else {
          this.removeFilter();
        }
      }
    }, {
      key: "addFilter",
      value: function addFilter(href) {
        var remaining = href.split('/collections/')[1];

        if (remaining) {
          var components = remaining.split('/');
          this.collectionFilter = components[0];
          this.tagFilter = components[1];
          this.filterItems();
        } else {
          this.removeFilter();
        }
      }
    }, {
      key: "removeFilter",
      value: function removeFilter() {
        this.collectionFilter = undefined;
        this.tagFilter = undefined;
        this.filterItems();
      }
    }, {
      key: "filterItems",
      value: function filterItems() {
        var _this = this;

        var price = Math.ceil(this.maxPrice * this.priceFilterValue / 100) * 100;
        var collection = this.collectionFilter;
        var tag = this.tagFilter;
        var visible = this.items.filter(function (item) {
          if (tag) {
            return item.price <= price && item.collections.includes(collection) && item.tags.includes(tag);
          } else if (collection) {
            return item.price <= price && item.collections.includes(collection);
          } else {
            return item.price <= price;
          }
        });
        var hidden = this.items.filter(function (item) {
          return !visible.includes(item);
        });
        visible.forEach(function (v) {
          v.element.style.display = 'list-item';

          _this.gridWrapper.appendChild(v.element);
        });
        hidden.forEach(function (h) {
          h.element.style.display = 'none';

          _this.gridWrapper.appendChild(h.element);
        });

        if (this.c.scroll) ;
      }
    }]);

    return ProductGrid;
  }();

  var marked = createCommonjsModule(function (module, exports) {

    (function (root) {
      /**
       * Block-Level Grammar
       */

      var block = {
        newline: /^\n+/,
        code: /^( {4}[^\n]+\n*)+/,
        fences: /^ {0,3}(`{3,}|~{3,})([^`~\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
        hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6}) +([^\n]*?)(?: +#+)? *(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
        html: '^ {0,3}(?:' // optional indentation
        + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
        + '|comment[^\\n]*(\\n+|$)' // (2)
        + '|<\\?[\\s\\S]*?\\?>\\n*' // (3)
        + '|<![A-Z][\\s\\S]*?>\\n*' // (4)
        + '|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*' // (5)
        + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)' // (6)
        + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) open tag
        + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) closing tag
        + ')',
        def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
        nptable: noop,
        table: noop,
        lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html)[^\n]+)*)/,
        text: /^[^\n]+/
      };
      block._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
      block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
      block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
      block.bullet = /(?:[*+-]|\d{1,9}\.)/;
      block.item = /^( *)(bull) ?[^\n]*(?:\n(?!\1bull ?)[^\n]*)*/;
      block.item = edit(block.item, 'gm').replace(/bull/g, block.bullet).getRegex();
      block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
      block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
      block._comment = /<!--(?!-?>)[\s\S]*?-->/;
      block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
      block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} +').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
      .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}|~{3,})[^`\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
      .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
      .getRegex();
      block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
      /**
       * Normal Block Grammar
       */

      block.normal = merge({}, block);
      /**
       * GFM Block Grammar
       */

      block.gfm = merge({}, block.normal, {
        nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
        table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
      });
      /**
       * Pedantic grammar (original John Gruber's loose markdown specification)
       */

      block.pedantic = merge({}, block.normal, {
        html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
        + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
        fences: noop,
        // fences not supported
        paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
      });
      /**
       * Block Lexer
       */

      function Lexer(options) {
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options || marked.defaults;
        this.rules = block.normal;

        if (this.options.pedantic) {
          this.rules = block.pedantic;
        } else if (this.options.gfm) {
          this.rules = block.gfm;
        }
      }
      /**
       * Expose Block Rules
       */


      Lexer.rules = block;
      /**
       * Static Lex Method
       */

      Lexer.lex = function (src, options) {
        var lexer = new Lexer(options);
        return lexer.lex(src);
      };
      /**
       * Preprocessing
       */


      Lexer.prototype.lex = function (src) {
        src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ').replace(/\u00a0/g, ' ').replace(/\u2424/g, '\n');
        return this.token(src, true);
      };
      /**
       * Lexing
       */


      Lexer.prototype.token = function (src, top) {
        src = src.replace(/^ +$/gm, '');
        var next, loose, cap, bull, b, item, listStart, listItems, t, space, i, tag, l, isordered, istask, ischecked;

        while (src) {
          // newline
          if (cap = this.rules.newline.exec(src)) {
            src = src.substring(cap[0].length);

            if (cap[0].length > 1) {
              this.tokens.push({
                type: 'space'
              });
            }
          } // code


          if (cap = this.rules.code.exec(src)) {
            var lastToken = this.tokens[this.tokens.length - 1];
            src = src.substring(cap[0].length); // An indented code block cannot interrupt a paragraph.

            if (lastToken && lastToken.type === 'paragraph') {
              lastToken.text += '\n' + cap[0].trimRight();
            } else {
              cap = cap[0].replace(/^ {4}/gm, '');
              this.tokens.push({
                type: 'code',
                codeBlockStyle: 'indented',
                text: !this.options.pedantic ? rtrim(cap, '\n') : cap
              });
            }

            continue;
          } // fences


          if (cap = this.rules.fences.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'code',
              lang: cap[2] ? cap[2].trim() : cap[2],
              text: cap[3] || ''
            });
            continue;
          } // heading


          if (cap = this.rules.heading.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'heading',
              depth: cap[1].length,
              text: cap[2]
            });
            continue;
          } // table no leading pipe (gfm)


          if (cap = this.rules.nptable.exec(src)) {
            item = {
              type: 'table',
              header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
              align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
              cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
            };

            if (item.header.length === item.align.length) {
              src = src.substring(cap[0].length);

              for (i = 0; i < item.align.length; i++) {
                if (/^ *-+: *$/.test(item.align[i])) {
                  item.align[i] = 'right';
                } else if (/^ *:-+: *$/.test(item.align[i])) {
                  item.align[i] = 'center';
                } else if (/^ *:-+ *$/.test(item.align[i])) {
                  item.align[i] = 'left';
                } else {
                  item.align[i] = null;
                }
              }

              for (i = 0; i < item.cells.length; i++) {
                item.cells[i] = splitCells(item.cells[i], item.header.length);
              }

              this.tokens.push(item);
              continue;
            }
          } // hr


          if (cap = this.rules.hr.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'hr'
            });
            continue;
          } // blockquote


          if (cap = this.rules.blockquote.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'blockquote_start'
            });
            cap = cap[0].replace(/^ *> ?/gm, ''); // Pass `top` to keep the current
            // "toplevel" state. This is exactly
            // how markdown.pl works.

            this.token(cap, top);
            this.tokens.push({
              type: 'blockquote_end'
            });
            continue;
          } // list


          if (cap = this.rules.list.exec(src)) {
            src = src.substring(cap[0].length);
            bull = cap[2];
            isordered = bull.length > 1;
            listStart = {
              type: 'list_start',
              ordered: isordered,
              start: isordered ? +bull : '',
              loose: false
            };
            this.tokens.push(listStart); // Get each top-level item.

            cap = cap[0].match(this.rules.item);
            listItems = [];
            next = false;
            l = cap.length;
            i = 0;

            for (; i < l; i++) {
              item = cap[i]; // Remove the list item's bullet
              // so it is seen as the next token.

              space = item.length;
              item = item.replace(/^ *([*+-]|\d+\.) */, ''); // Outdent whatever the
              // list item contains. Hacky.

              if (~item.indexOf('\n ')) {
                space -= item.length;
                item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
              } // Determine whether the next list item belongs here.
              // Backpedal if it does not belong in this list.


              if (i !== l - 1) {
                b = block.bullet.exec(cap[i + 1])[0];

                if (bull.length > 1 ? b.length === 1 : b.length > 1 || this.options.smartLists && b !== bull) {
                  src = cap.slice(i + 1).join('\n') + src;
                  i = l - 1;
                }
              } // Determine whether item is loose or not.
              // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
              // for discount behavior.


              loose = next || /\n\n(?!\s*$)/.test(item);

              if (i !== l - 1) {
                next = item.charAt(item.length - 1) === '\n';
                if (!loose) loose = next;
              }

              if (loose) {
                listStart.loose = true;
              } // Check for task list items


              istask = /^\[[ xX]\] /.test(item);
              ischecked = undefined;

              if (istask) {
                ischecked = item[1] !== ' ';
                item = item.replace(/^\[[ xX]\] +/, '');
              }

              t = {
                type: 'list_item_start',
                task: istask,
                checked: ischecked,
                loose: loose
              };
              listItems.push(t);
              this.tokens.push(t); // Recurse.

              this.token(item, false);
              this.tokens.push({
                type: 'list_item_end'
              });
            }

            if (listStart.loose) {
              l = listItems.length;
              i = 0;

              for (; i < l; i++) {
                listItems[i].loose = true;
              }
            }

            this.tokens.push({
              type: 'list_end'
            });
            continue;
          } // html


          if (cap = this.rules.html.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: this.options.sanitize ? 'paragraph' : 'html',
              pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
              text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
            });
            continue;
          } // def


          if (top && (cap = this.rules.def.exec(src))) {
            src = src.substring(cap[0].length);
            if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
            tag = cap[1].toLowerCase().replace(/\s+/g, ' ');

            if (!this.tokens.links[tag]) {
              this.tokens.links[tag] = {
                href: cap[2],
                title: cap[3]
              };
            }

            continue;
          } // table (gfm)


          if (cap = this.rules.table.exec(src)) {
            item = {
              type: 'table',
              header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
              align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
              cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
            };

            if (item.header.length === item.align.length) {
              src = src.substring(cap[0].length);

              for (i = 0; i < item.align.length; i++) {
                if (/^ *-+: *$/.test(item.align[i])) {
                  item.align[i] = 'right';
                } else if (/^ *:-+: *$/.test(item.align[i])) {
                  item.align[i] = 'center';
                } else if (/^ *:-+ *$/.test(item.align[i])) {
                  item.align[i] = 'left';
                } else {
                  item.align[i] = null;
                }
              }

              for (i = 0; i < item.cells.length; i++) {
                item.cells[i] = splitCells(item.cells[i].replace(/^ *\| *| *\| *$/g, ''), item.header.length);
              }

              this.tokens.push(item);
              continue;
            }
          } // lheading


          if (cap = this.rules.lheading.exec(src)) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'heading',
              depth: cap[2].charAt(0) === '=' ? 1 : 2,
              text: cap[1]
            });
            continue;
          } // top-level paragraph


          if (top && (cap = this.rules.paragraph.exec(src))) {
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'paragraph',
              text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
            });
            continue;
          } // text


          if (cap = this.rules.text.exec(src)) {
            // Top-level should never reach here.
            src = src.substring(cap[0].length);
            this.tokens.push({
              type: 'text',
              text: cap[0]
            });
            continue;
          }

          if (src) {
            throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
          }
        }

        return this.tokens;
      };
      /**
       * Inline-Level Grammar
       */


      var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noop,
        tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
        + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
        + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
        + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
        + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
        nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
        strong: /^__([^\s_])__(?!_)|^\*\*([^\s*])\*\*(?!\*)|^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/,
        em: /^_([^\s_])_(?!_)|^\*([^\s*<\[])\*(?!\*)|^_([^\s<][\s\S]*?[^\s_])_(?!_|[^\spunctuation])|^_([^\s_<][\s\S]*?[^\s])_(?!_|[^\spunctuation])|^\*([^\s<"][\s\S]*?[^\s\*])\*(?!\*|[^\spunctuation])|^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noop,
        text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n))|(?= {2,}\n))/
      }; // list of punctuation marks from common mark spec
      // without ` and ] to workaround Rule 17 (inline code blocks/links)

      inline._punctuation = '!"#$%&\'()*+,\\-./:;<=>?@\\[^_{|}~';
      inline.em = edit(inline.em).replace(/punctuation/g, inline._punctuation).getRegex();
      inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
      inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
      inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
      inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
      inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
      inline.tag = edit(inline.tag).replace('comment', block._comment).replace('attribute', inline._attribute).getRegex();
      inline._label = /(?:\[[^\[\]]*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
      inline._href = /<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*/;
      inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
      inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
      inline.reflink = edit(inline.reflink).replace('label', inline._label).getRegex();
      /**
       * Normal Inline Grammar
       */

      inline.normal = merge({}, inline);
      /**
       * Pedantic Inline Grammar
       */

      inline.pedantic = merge({}, inline.normal, {
        strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
      });
      /**
       * GFM Inline Grammar
       */

      inline.gfm = merge({}, inline.normal, {
        escape: edit(inline.escape).replace('])', '~|])').getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
        del: /^~+(?=\S)([\s\S]*?\S)~+/,
        text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
      });
      inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
      /**
       * GFM + Line Breaks Inline Grammar
       */

      inline.breaks = merge({}, inline.gfm, {
        br: edit(inline.br).replace('{2,}', '*').getRegex(),
        text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
      });
      /**
       * Inline Lexer & Compiler
       */

      function InlineLexer(links, options) {
        this.options = options || marked.defaults;
        this.links = links;
        this.rules = inline.normal;
        this.renderer = this.options.renderer || new Renderer();
        this.renderer.options = this.options;

        if (!this.links) {
          throw new Error('Tokens array requires a `links` property.');
        }

        if (this.options.pedantic) {
          this.rules = inline.pedantic;
        } else if (this.options.gfm) {
          if (this.options.breaks) {
            this.rules = inline.breaks;
          } else {
            this.rules = inline.gfm;
          }
        }
      }
      /**
       * Expose Inline Rules
       */


      InlineLexer.rules = inline;
      /**
       * Static Lexing/Compiling Method
       */

      InlineLexer.output = function (src, links, options) {
        var inline = new InlineLexer(links, options);
        return inline.output(src);
      };
      /**
       * Lexing/Compiling
       */


      InlineLexer.prototype.output = function (src) {
        var out = '',
            link,
            text,
            href,
            title,
            cap,
            prevCapZero;

        while (src) {
          // escape
          if (cap = this.rules.escape.exec(src)) {
            src = src.substring(cap[0].length);
            out += escape(cap[1]);
            continue;
          } // tag


          if (cap = this.rules.tag.exec(src)) {
            if (!this.inLink && /^<a /i.test(cap[0])) {
              this.inLink = true;
            } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
              this.inLink = false;
            }

            if (!this.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
              this.inRawBlock = true;
            } else if (this.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
              this.inRawBlock = false;
            }

            src = src.substring(cap[0].length);
            out += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
            continue;
          } // link


          if (cap = this.rules.link.exec(src)) {
            var lastParenIndex = findClosingBracket(cap[2], '()');

            if (lastParenIndex > -1) {
              var linkLen = 4 + cap[1].length + lastParenIndex;
              cap[2] = cap[2].substring(0, lastParenIndex);
              cap[0] = cap[0].substring(0, linkLen).trim();
              cap[3] = '';
            }

            src = src.substring(cap[0].length);
            this.inLink = true;
            href = cap[2];

            if (this.options.pedantic) {
              link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

              if (link) {
                href = link[1];
                title = link[3];
              } else {
                title = '';
              }
            } else {
              title = cap[3] ? cap[3].slice(1, -1) : '';
            }

            href = href.trim().replace(/^<([\s\S]*)>$/, '$1');
            out += this.outputLink(cap, {
              href: InlineLexer.escapes(href),
              title: InlineLexer.escapes(title)
            });
            this.inLink = false;
            continue;
          } // reflink, nolink


          if ((cap = this.rules.reflink.exec(src)) || (cap = this.rules.nolink.exec(src))) {
            src = src.substring(cap[0].length);
            link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
            link = this.links[link.toLowerCase()];

            if (!link || !link.href) {
              out += cap[0].charAt(0);
              src = cap[0].substring(1) + src;
              continue;
            }

            this.inLink = true;
            out += this.outputLink(cap, link);
            this.inLink = false;
            continue;
          } // strong


          if (cap = this.rules.strong.exec(src)) {
            src = src.substring(cap[0].length);
            out += this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1]));
            continue;
          } // em


          if (cap = this.rules.em.exec(src)) {
            src = src.substring(cap[0].length);
            out += this.renderer.em(this.output(cap[6] || cap[5] || cap[4] || cap[3] || cap[2] || cap[1]));
            continue;
          } // code


          if (cap = this.rules.code.exec(src)) {
            src = src.substring(cap[0].length);
            out += this.renderer.codespan(escape(cap[2].trim(), true));
            continue;
          } // br


          if (cap = this.rules.br.exec(src)) {
            src = src.substring(cap[0].length);
            out += this.renderer.br();
            continue;
          } // del (gfm)


          if (cap = this.rules.del.exec(src)) {
            src = src.substring(cap[0].length);
            out += this.renderer.del(this.output(cap[1]));
            continue;
          } // autolink


          if (cap = this.rules.autolink.exec(src)) {
            src = src.substring(cap[0].length);

            if (cap[2] === '@') {
              text = escape(this.mangle(cap[1]));
              href = 'mailto:' + text;
            } else {
              text = escape(cap[1]);
              href = text;
            }

            out += this.renderer.link(href, null, text);
            continue;
          } // url (gfm)


          if (!this.inLink && (cap = this.rules.url.exec(src))) {
            if (cap[2] === '@') {
              text = escape(cap[0]);
              href = 'mailto:' + text;
            } else {
              // do extended autolink path validation
              do {
                prevCapZero = cap[0];
                cap[0] = this.rules._backpedal.exec(cap[0])[0];
              } while (prevCapZero !== cap[0]);

              text = escape(cap[0]);

              if (cap[1] === 'www.') {
                href = 'http://' + text;
              } else {
                href = text;
              }
            }

            src = src.substring(cap[0].length);
            out += this.renderer.link(href, null, text);
            continue;
          } // text


          if (cap = this.rules.text.exec(src)) {
            src = src.substring(cap[0].length);

            if (this.inRawBlock) {
              out += this.renderer.text(this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]);
            } else {
              out += this.renderer.text(escape(this.smartypants(cap[0])));
            }

            continue;
          }

          if (src) {
            throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
          }
        }

        return out;
      };

      InlineLexer.escapes = function (text) {
        return text ? text.replace(InlineLexer.rules._escapes, '$1') : text;
      };
      /**
       * Compile Link
       */


      InlineLexer.prototype.outputLink = function (cap, link) {
        var href = link.href,
            title = link.title ? escape(link.title) : null;
        return cap[0].charAt(0) !== '!' ? this.renderer.link(href, title, this.output(cap[1])) : this.renderer.image(href, title, escape(cap[1]));
      };
      /**
       * Smartypants Transformations
       */


      InlineLexer.prototype.smartypants = function (text) {
        if (!this.options.smartypants) return text;
        return text // em-dashes
        .replace(/---/g, "\u2014") // en-dashes
        .replace(/--/g, "\u2013") // opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018") // closing singles & apostrophes
        .replace(/'/g, "\u2019") // opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C") // closing doubles
        .replace(/"/g, "\u201D") // ellipses
        .replace(/\.{3}/g, "\u2026");
      };
      /**
       * Mangle Links
       */


      InlineLexer.prototype.mangle = function (text) {
        if (!this.options.mangle) return text;
        var out = '',
            l = text.length,
            i = 0,
            ch;

        for (; i < l; i++) {
          ch = text.charCodeAt(i);

          if (Math.random() > 0.5) {
            ch = 'x' + ch.toString(16);
          }

          out += '&#' + ch + ';';
        }

        return out;
      };
      /**
       * Renderer
       */


      function Renderer(options) {
        this.options = options || marked.defaults;
      }

      Renderer.prototype.code = function (code, infostring, escaped) {
        var lang = (infostring || '').match(/\S*/)[0];

        if (this.options.highlight) {
          var out = this.options.highlight(code, lang);

          if (out != null && out !== code) {
            escaped = true;
            code = out;
          }
        }

        if (!lang) {
          return '<pre><code>' + (escaped ? code : escape(code, true)) + '</code></pre>';
        }

        return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
      };

      Renderer.prototype.blockquote = function (quote) {
        return '<blockquote>\n' + quote + '</blockquote>\n';
      };

      Renderer.prototype.html = function (html) {
        return html;
      };

      Renderer.prototype.heading = function (text, level, raw, slugger) {
        if (this.options.headerIds) {
          return '<h' + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + '</h' + level + '>\n';
        } // ignore IDs


        return '<h' + level + '>' + text + '</h' + level + '>\n';
      };

      Renderer.prototype.hr = function () {
        return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
      };

      Renderer.prototype.list = function (body, ordered, start) {
        var type = ordered ? 'ol' : 'ul',
            startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
        return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
      };

      Renderer.prototype.listitem = function (text) {
        return '<li>' + text + '</li>\n';
      };

      Renderer.prototype.checkbox = function (checked) {
        return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
      };

      Renderer.prototype.paragraph = function (text) {
        return '<p>' + text + '</p>\n';
      };

      Renderer.prototype.table = function (header, body) {
        if (body) body = '<tbody>' + body + '</tbody>';
        return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
      };

      Renderer.prototype.tablerow = function (content) {
        return '<tr>\n' + content + '</tr>\n';
      };

      Renderer.prototype.tablecell = function (content, flags) {
        var type = flags.header ? 'th' : 'td';
        var tag = flags.align ? '<' + type + ' align="' + flags.align + '">' : '<' + type + '>';
        return tag + content + '</' + type + '>\n';
      }; // span level renderer


      Renderer.prototype.strong = function (text) {
        return '<strong>' + text + '</strong>';
      };

      Renderer.prototype.em = function (text) {
        return '<em>' + text + '</em>';
      };

      Renderer.prototype.codespan = function (text) {
        return '<code>' + text + '</code>';
      };

      Renderer.prototype.br = function () {
        return this.options.xhtml ? '<br/>' : '<br>';
      };

      Renderer.prototype.del = function (text) {
        return '<del>' + text + '</del>';
      };

      Renderer.prototype.link = function (href, title, text) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);

        if (href === null) {
          return text;
        }

        var out = '<a href="' + escape(href) + '"';

        if (title) {
          out += ' title="' + title + '"';
        }

        out += '>' + text + '</a>';
        return out;
      };

      Renderer.prototype.image = function (href, title, text) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);

        if (href === null) {
          return text;
        }

        var out = '<img src="' + href + '" alt="' + text + '"';

        if (title) {
          out += ' title="' + title + '"';
        }

        out += this.options.xhtml ? '/>' : '>';
        return out;
      };

      Renderer.prototype.text = function (text) {
        return text;
      };
      /**
       * TextRenderer
       * returns only the textual part of the token
       */


      function TextRenderer() {} // no need for block level renderers


      TextRenderer.prototype.strong = TextRenderer.prototype.em = TextRenderer.prototype.codespan = TextRenderer.prototype.del = TextRenderer.prototype.text = function (text) {
        return text;
      };

      TextRenderer.prototype.link = TextRenderer.prototype.image = function (href, title, text) {
        return '' + text;
      };

      TextRenderer.prototype.br = function () {
        return '';
      };
      /**
       * Parsing & Compiling
       */


      function Parser(options) {
        this.tokens = [];
        this.token = null;
        this.options = options || marked.defaults;
        this.options.renderer = this.options.renderer || new Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.slugger = new Slugger();
      }
      /**
       * Static Parse Method
       */


      Parser.parse = function (src, options) {
        var parser = new Parser(options);
        return parser.parse(src);
      };
      /**
       * Parse Loop
       */


      Parser.prototype.parse = function (src) {
        this.inline = new InlineLexer(src.links, this.options); // use an InlineLexer with a TextRenderer to extract pure text

        this.inlineText = new InlineLexer(src.links, merge({}, this.options, {
          renderer: new TextRenderer()
        }));
        this.tokens = src.reverse();
        var out = '';

        while (this.next()) {
          out += this.tok();
        }

        return out;
      };
      /**
       * Next Token
       */


      Parser.prototype.next = function () {
        this.token = this.tokens.pop();
        return this.token;
      };
      /**
       * Preview Next Token
       */


      Parser.prototype.peek = function () {
        return this.tokens[this.tokens.length - 1] || 0;
      };
      /**
       * Parse Text Tokens
       */


      Parser.prototype.parseText = function () {
        var body = this.token.text;

        while (this.peek().type === 'text') {
          body += '\n' + this.next().text;
        }

        return this.inline.output(body);
      };
      /**
       * Parse Current Token
       */


      Parser.prototype.tok = function () {
        switch (this.token.type) {
          case 'space':
            {
              return '';
            }

          case 'hr':
            {
              return this.renderer.hr();
            }

          case 'heading':
            {
              return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, unescape(this.inlineText.output(this.token.text)), this.slugger);
            }

          case 'code':
            {
              return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
            }

          case 'table':
            {
              var header = '',
                  body = '',
                  i,
                  row,
                  cell,
                  j; // header

              cell = '';

              for (i = 0; i < this.token.header.length; i++) {
                cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), {
                  header: true,
                  align: this.token.align[i]
                });
              }

              header += this.renderer.tablerow(cell);

              for (i = 0; i < this.token.cells.length; i++) {
                row = this.token.cells[i];
                cell = '';

                for (j = 0; j < row.length; j++) {
                  cell += this.renderer.tablecell(this.inline.output(row[j]), {
                    header: false,
                    align: this.token.align[j]
                  });
                }

                body += this.renderer.tablerow(cell);
              }

              return this.renderer.table(header, body);
            }

          case 'blockquote_start':
            {
              body = '';

              while (this.next().type !== 'blockquote_end') {
                body += this.tok();
              }

              return this.renderer.blockquote(body);
            }

          case 'list_start':
            {
              body = '';
              var ordered = this.token.ordered,
                  start = this.token.start;

              while (this.next().type !== 'list_end') {
                body += this.tok();
              }

              return this.renderer.list(body, ordered, start);
            }

          case 'list_item_start':
            {
              body = '';
              var loose = this.token.loose;
              var checked = this.token.checked;
              var task = this.token.task;

              if (this.token.task) {
                body += this.renderer.checkbox(checked);
              }

              while (this.next().type !== 'list_item_end') {
                body += !loose && this.token.type === 'text' ? this.parseText() : this.tok();
              }

              return this.renderer.listitem(body, task, checked);
            }

          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              return this.renderer.html(this.token.text);
            }

          case 'paragraph':
            {
              return this.renderer.paragraph(this.inline.output(this.token.text));
            }

          case 'text':
            {
              return this.renderer.paragraph(this.parseText());
            }

          default:
            {
              var errMsg = 'Token with "' + this.token.type + '" type was not found.';

              if (this.options.silent) {
                console.log(errMsg);
              } else {
                throw new Error(errMsg);
              }
            }
        }
      };
      /**
       * Slugger generates header id
       */


      function Slugger() {
        this.seen = {};
      }
      /**
       * Convert string to unique id
       */


      Slugger.prototype.slug = function (value) {
        var slug = value.toLowerCase().trim().replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');

        if (this.seen.hasOwnProperty(slug)) {
          var originalSlug = slug;

          do {
            this.seen[originalSlug]++;
            slug = originalSlug + '-' + this.seen[originalSlug];
          } while (this.seen.hasOwnProperty(slug));
        }

        this.seen[slug] = 0;
        return slug;
      };
      /**
       * Helpers
       */


      function escape(html, encode) {
        if (encode) {
          if (escape.escapeTest.test(html)) {
            return html.replace(escape.escapeReplace, function (ch) {
              return escape.replacements[ch];
            });
          }
        } else {
          if (escape.escapeTestNoEncode.test(html)) {
            return html.replace(escape.escapeReplaceNoEncode, function (ch) {
              return escape.replacements[ch];
            });
          }
        }

        return html;
      }

      escape.escapeTest = /[&<>"']/;
      escape.escapeReplace = /[&<>"']/g;
      escape.replacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      escape.escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
      escape.escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;

      function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function (_, n) {
          n = n.toLowerCase();
          if (n === 'colon') return ':';

          if (n.charAt(0) === '#') {
            return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
          }

          return '';
        });
      }

      function edit(regex, opt) {
        regex = regex.source || regex;
        opt = opt || '';
        return {
          replace: function replace(name, val) {
            val = val.source || val;
            val = val.replace(/(^|[^\[])\^/g, '$1');
            regex = regex.replace(name, val);
            return this;
          },
          getRegex: function getRegex() {
            return new RegExp(regex, opt);
          }
        };
      }

      function cleanUrl(sanitize, base, href) {
        if (sanitize) {
          try {
            var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
          } catch (e) {
            return null;
          }

          if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
            return null;
          }
        }

        if (base && !originIndependentUrl.test(href)) {
          href = resolveUrl(base, href);
        }

        try {
          href = encodeURI(href).replace(/%25/g, '%');
        } catch (e) {
          return null;
        }

        return href;
      }

      function resolveUrl(base, href) {
        if (!baseUrls[' ' + base]) {
          // we can ignore everything in base after the last slash of its path component,
          // but we might need to add _that_
          // https://tools.ietf.org/html/rfc3986#section-3
          if (/^[^:]+:\/*[^/]*$/.test(base)) {
            baseUrls[' ' + base] = base + '/';
          } else {
            baseUrls[' ' + base] = rtrim(base, '/', true);
          }
        }

        base = baseUrls[' ' + base];

        if (href.slice(0, 2) === '//') {
          return base.replace(/:[\s\S]*/, ':') + href;
        } else if (href.charAt(0) === '/') {
          return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
        } else {
          return base + href;
        }
      }

      var baseUrls = {};
      var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

      function noop() {}

      noop.exec = noop;

      function merge(obj) {
        var i = 1,
            target,
            key;

        for (; i < arguments.length; i++) {
          target = arguments[i];

          for (key in target) {
            if (Object.prototype.hasOwnProperty.call(target, key)) {
              obj[key] = target[key];
            }
          }
        }

        return obj;
      }

      function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function (match, offset, str) {
          var escaped = false,
              curr = offset;

          while (--curr >= 0 && str[curr] === '\\') {
            escaped = !escaped;
          }

          if (escaped) {
            // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
          } else {
            // add space before unescaped |
            return ' |';
          }
        }),
            cells = row.split(/ \|/),
            i = 0;

        if (cells.length > count) {
          cells.splice(count);
        } else {
          while (cells.length < count) {
            cells.push('');
          }
        }

        for (; i < cells.length; i++) {
          // leading or trailing whitespace is ignored per the gfm spec
          cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        }

        return cells;
      } // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
      // /c*$/ is vulnerable to REDOS.
      // invert: Remove suffix of non-c chars instead. Default falsey.


      function rtrim(str, c, invert) {
        if (str.length === 0) {
          return '';
        } // Length of suffix matching the invert condition.


        var suffLen = 0; // Step left until we fail to match the invert condition.

        while (suffLen < str.length) {
          var currChar = str.charAt(str.length - suffLen - 1);

          if (currChar === c && !invert) {
            suffLen++;
          } else if (currChar !== c && invert) {
            suffLen++;
          } else {
            break;
          }
        }

        return str.substr(0, str.length - suffLen);
      }

      function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) {
          return -1;
        }

        var level = 0;

        for (var i = 0; i < str.length; i++) {
          if (str[i] === '\\') {
            i++;
          } else if (str[i] === b[0]) {
            level++;
          } else if (str[i] === b[1]) {
            level--;

            if (level < 0) {
              return i;
            }
          }
        }

        return -1;
      }

      function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) {
          console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
        }
      }
      /**
       * Marked
       */


      function marked(src, opt, callback) {
        // throw error in case of non string input
        if (typeof src === 'undefined' || src === null) {
          throw new Error('marked(): input parameter is undefined or null');
        }

        if (typeof src !== 'string') {
          throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
        }

        if (callback || typeof opt === 'function') {
          if (!callback) {
            callback = opt;
            opt = null;
          }

          opt = merge({}, marked.defaults, opt || {});
          checkSanitizeDeprecation(opt);
          var highlight = opt.highlight,
              tokens,
              pending,
              i = 0;

          try {
            tokens = Lexer.lex(src, opt);
          } catch (e) {
            return callback(e);
          }

          pending = tokens.length;

          var done = function done(err) {
            if (err) {
              opt.highlight = highlight;
              return callback(err);
            }

            var out;

            try {
              out = Parser.parse(tokens, opt);
            } catch (e) {
              err = e;
            }

            opt.highlight = highlight;
            return err ? callback(err) : callback(null, out);
          };

          if (!highlight || highlight.length < 3) {
            return done();
          }

          delete opt.highlight;
          if (!pending) return done();

          for (; i < tokens.length; i++) {
            (function (token) {
              if (token.type !== 'code') {
                return --pending || done();
              }

              return highlight(token.text, token.lang, function (err, code) {
                if (err) return done(err);

                if (code == null || code === token.text) {
                  return --pending || done();
                }

                token.text = code;
                token.escaped = true;
                --pending || done();
              });
            })(tokens[i]);
          }

          return;
        }

        try {
          if (opt) opt = merge({}, marked.defaults, opt);
          checkSanitizeDeprecation(opt);
          return Parser.parse(Lexer.lex(src, opt), opt);
        } catch (e) {
          e.message += '\nPlease report this to https://github.com/markedjs/marked.';

          if ((opt || marked.defaults).silent) {
            return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
          }

          throw e;
        }
      }
      /**
       * Options
       */


      marked.options = marked.setOptions = function (opt) {
        merge(marked.defaults, opt);
        return marked;
      };

      marked.getDefaults = function () {
        return {
          baseUrl: null,
          breaks: false,
          gfm: true,
          headerIds: true,
          headerPrefix: '',
          highlight: null,
          langPrefix: 'language-',
          mangle: true,
          pedantic: false,
          renderer: new Renderer(),
          sanitize: false,
          sanitizer: null,
          silent: false,
          smartLists: false,
          smartypants: false,
          xhtml: false
        };
      };

      marked.defaults = marked.getDefaults();
      /**
       * Expose
       */

      marked.Parser = Parser;
      marked.parser = Parser.parse;
      marked.Renderer = Renderer;
      marked.TextRenderer = TextRenderer;
      marked.Lexer = Lexer;
      marked.lexer = Lexer.lex;
      marked.InlineLexer = InlineLexer;
      marked.inlineLexer = InlineLexer.output;
      marked.Slugger = Slugger;
      marked.parse = marked;

      {
        module.exports = marked;
      }
    })();
  });

  var CollapsibleCopy =
  /*#__PURE__*/
  function () {
    function CollapsibleCopy(element) {
      _classCallCheck(this, CollapsibleCopy);

      this.c = _C;
      this.isDesktop = this.c.isDesktop;
      this.element = element;
      r.BM(this, ['fn']);
      var baseC = 'collapsible-copy';
      this.liC = baseC + '-li';
      this.li = r.G["class"](this.liC, this.element);
      this.noCollapsible = r.Is.und(this.li[0]);
      this.liL = this.li.length;
      this.container = this.element;
      this.ul = r.G["class"](baseC, this.element)[0];
      this.contentW = r.G["class"](baseC + '-content-w', this.element);
      this.content = r.G["class"](baseC + '-content', this.element);
      this.cross = r.G["class"](baseC + '-cross', this.element);
      this.crossPoly = r.G["class"](baseC + '-cross-poly', this.element);
      this.firstTime = true;
      this.isOpen = [];

      for (var i = 0; i < this.liL; i++) {
        this.isOpen[i] = false;
      }

      this.titles = Array.from(this.element.getElementsByClassName('collapsible-copy-title'));
      this.collapsibleBodyList = this.element.getElementsByClassName('collapsible-copy-content');
      this.collapsibleBodyElements = Array.from(this.collapsibleBodyList);
      this.collapsibleBodyElements.forEach(function (element) {
        var rawElement = element;
        var modifiedElement = marked(rawElement.innerHTML);
        rawElement.innerHTML = modifiedElement;
      });
    }

    _createClass(CollapsibleCopy, [{
      key: "resize",
      value: function resize() {
        if (this.noCollapsible) return;
        this.liH = [];
        this.liY = [];
        this.contentH = [];

        for (var i = 0; i < this.liL; i++) {
          this.contentH[i] = this.contentW[i].offsetHeight;
          this.liH[i] = this.li[i].offsetHeight;

          if (i === 0) {
            this.liY[i] = 0;
          } else {
            var prev = i - 1;
            this.liY[i] = this.liH[prev] + this.liY[prev];

            if (this.isOpen[prev]) {
              this.liY[i] += this.contentH[prev];
            }
          }

          r.T(this.li[i], 0, this.liY[i], 'px');
        }

        this.ulHUp();
      }
    }, {
      key: "ulHUp",
      value: function ulHUp() {
        var lastIndex = this.liL - 1;
        var lastH = this.isOpen[lastIndex] ? this.contentH[lastIndex] : 0;
        var ulH = this.liY[lastIndex] + this.liH[lastIndex] + lastH;
        this.ul.style.height = ulH + 'px';

        if (this.isDesktop) {
          // Container min height
          if (this.firstTime) {
            this.firstTime = false;
            this.containerH = ulH + 400; // this.container.style.minHeight = this.containerH + 'px'
            // this.c.scroll.resize()
          }
        }
      }
    }, {
      key: "fn",
      value: function fn(e) {
        e.preventDefault();
        this.off();

        if (this.isDesktop) ;

        var index = r.Index["class"](e.target.parentNode, this.liC);
        var isOpen = this.isOpen[index];
        this.isOpen[index] = !isOpen;
        var direction = this.isOpen[index] ? 1 : -1; // Cross Morphing

        var poly = isOpen ? '9,7 9,0 7,0 7,7 0,7 0,9 7,9 7,16 9,16 9,9 16,9 16,7' : '9,7 9,7 7,7 7,7 0,7 0,9 7,9 7,9 9,9 9,9 16,9 16,7';
        var crossMorph = new r.M({
          el: this.crossPoly[index],
          svg: {
            type: 'polygon',
            end: poly
          },
          d: 300,
          e: 'o3'
        }); // Cross Rotation

        var rotateCurr = isOpen ? -180 : 0;
        var rotateTarg = isOpen ? 0 : -180;
        var crossRotation = new r.M({
          el: this.cross[index],
          p: {
            rotate: [rotateCurr, rotateTarg]
          },
          d: 300,
          e: 'o3'
        }); // Li translation Y

        var liTrY = new r.TL();

        for (var i = index + 1; i < this.liL; i++) {
          var currY = this.liY[i];
          this.liY[i] = this.liY[i] + this.contentH[index] * direction;
          liTrY.from({
            el: this.li[i],
            p: {
              y: [currY, this.liY[i], 'px']
            },
            d: 300,
            e: 'o3'
          });
        } // Content translation Y


        var contentYCurr = isOpen ? 0 : -100;
        var contentYTarg = isOpen ? -100 : 0;
        var contentOpacityCurr = isOpen ? 1 : 0;
        var contentOpacityTarg = isOpen ? 0 : 1;
        var contentAnim = new r.TL();
        contentAnim.from({
          el: this.content[index],
          p: {
            y: [contentYCurr, contentYTarg]
          },
          d: 300,
          e: 'o3'
        });
        contentAnim.from({
          el: this.content[index],
          p: {
            opacity: [contentOpacityCurr, contentOpacityTarg]
          },
          d: 300,
          e: 'o6'
        }); // ---------------------------------------------
        // Go

        if (!isOpen) {
          this.ulHUp();
        }

        crossMorph.play();
        crossRotation.play();
        contentAnim.play();
        liTrY.play(); // Is Open up
        // new R.Delay(_ => {

        if (isOpen) {
          this.ulHUp();
        }

        if (this.isDesktop) ;

        this.on(); // }, 300).run()
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        var _this = this;

        if (this.noCollapsible) return;
        this.titles.forEach(function (element) {
          if (a === 'a') {
            element.addEventListener('click', _this.fn);
          } else {
            element.removeEventListener('click', _this.fn);
          }
        });
      }
    }]);

    return CollapsibleCopy;
  }();

  var Search =
  /*#__PURE__*/
  function () {
    function Search() {
      _classCallCheck(this, Search);

      this.c = _C;
      this.isDesktop = this.c.isDesktop;
      this.isMobile = this.c.isMobile;
      r.BM(this, ['openFn', 'closeFn', 'keyFn', 'submitFn', 'focusFn', 'cancelFn']);
    }

    _createClass(Search, [{
      key: "init",
      value: function init() {
        // Elements
        this.searchW = r.G.id('search-w');
        this.topNavSearch = r.G["class"]('top-nav-link-search')[0];
        this.form = r.G.id('search-form');
        this.line = r.G.id('search-form-line');
        this.input = r.G.id('search-form-input');
        this.label = r.G.id('search-form-label');
        this.submit = r.G.id('search-form-submit');
        this.close = r.G.id('search-close');
        this.cancel = r.G.id('search-cancel'); // Anim

        this.navSearchHide = new r.M({
          el: this.topNavSearch,
          p: {
            opacity: [1, 0]
          },
          d: 500,
          e: 'o3'
        });
        this.formShow = new r.M({
          el: '#search-form',
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3'
        });
        this.submitShow = new r.M({
          el: this.submit,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3'
        });
        this.closeShow = new r.M({
          el: this.close,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3'
        });
        this.cancelShow = new r.M({
          el: this.cancel,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3'
        }); // Property

        this.submitIsVisible = false;
        this.isFocus = false;
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.isMobile) return;
        if (!this.topNavSearch) return;
        var rect = this.topNavSearch.getBoundingClientRect();
        var top = rect.top + pageYOffset;
        var left = rect.left;
        var closeStyle = this.close.style;
        closeStyle.top = top + 'px';
        closeStyle.left = left + 'px';
      }
    }, {
      key: "openFn",
      value: function openFn() {
        var _this = this;

        this.off();

        if (this.isDesktop) ; else {
          TouchDisable$1.on();
        }

        this.c.smoothScroll.disableScrolling();
        r.T(this.searchW, 0, 0);
        this.input.value = '';
        this.input.focus();
        this.isFocus = true;

        if (r.Is.def(this.tl)) {
          this.tl.pause();
        }

        this.tl = new r.TL();
        this.tl.from({
          el: this.line,
          p: {
            scaleX: [0, 1]
          },
          d: 1200,
          e: 'o6'
        });
        this.tl.from({
          el: this.input,
          p: {
            x: [20, 0, 'px'],
            opacity: [0, 1]
          },
          d: 1200,
          e: 'o6'
        });
        this.tl.from({
          el: this.label,
          p: {
            x: [20, 0, 'px'],
            opacity: [0, 1]
          },
          d: 1200,
          e: 'o6'
        }); // Go

        if (this.isDesktop) {
          this.c.overPage.show();
          this.closeShow.play({
            d: 500
          });
        } else {
          this.closeShow.play({
            d: 0
          });
          this.cancelShow.play({
            d: 500
          });
        }

        this.navSearchHide.play();
        this.formShow.play();
        this.tl.play();
        this.lFocus('a'); // Cb

        new r.Delay(function (_) {
          _this.on();
        }, 500).run();
      }
    }, {
      key: "closeFn",
      value: function closeFn() {
        var _this2 = this;

        this.c.smoothScroll.enableScrolling();
        this.off();
        this.lFocus('r');

        if (this.submitIsVisible) {
          this.submitIsVisible = false;
          r.PE.none(this.submit);
          this.submitShow.play({
            reverse: true
          });
        }

        this.c.overPage.hide();
        this.closeShow.play({
          d: 200,
          reverse: true
        });

        if (this.isMobile) {
          this.cancelShow.play({
            d: 200,
            reverse: true
          });
        }

        this.navSearchHide.play({
          reverse: true
        });
        this.formShow.play({
          reverse: true
        });

        if (this.c.scroll) ; // this.c.scroll.on({reset: false})
        // Cb


        new r.Delay(function (_) {
          r.T(_this2.searchW, -100, 0);

          _this2.on();

          if (!_this2.isDesktop) {
            TouchDisable$1.off();
          }
        }, 500).run();
      }
    }, {
      key: "keyFn",
      value: function keyFn(e) {
        if (!this.submitIsVisible && this.isFocus && this.input.value.length) {
          this.submitIsVisible = true;
          r.PE.all(this.submit);
          this.submitShow.play();
        } else if (this.input.value.length === 0 && this.submitIsVisible) {
          this.submitIsVisible = false;
          this.submitShow.play({
            reverse: true
          });
        }
      }
    }, {
      key: "submitFn",
      value: function submitFn(e) {
        e.preventDefault();
        this.closeFn();
        this.c.eventDelegation.ajaxHref('/search?type=product&q=' + this.input.value.replace(' ', '+'));
      }
    }, {
      key: "focusFn",
      value: function focusFn(e) {
        this.isFocus = e.type === 'focus';
      }
    }, {
      key: "on",
      value: function on() {
        if (!this.topNavSearch) return;
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (!this.topNavSearch) return;
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.topNavSearch, a, 'click', this.openFn);
        r.L(this.close, a, 'click', this.closeFn);
        r.L(this.submit, a, 'click', this.submitFn);
        r.L(this.form, a, 'submit', this.submitFn);
      }
    }, {
      key: "cancelFn",
      value: function cancelFn() {
        this.input.value = '';
      }
    }, {
      key: "lFocus",
      value: function lFocus(a) {
        r.L(this.input, a, 'focus', this.focusFn);
        r.L(this.input, a, 'blur', this.focusFn);

        if (this.isDesktop) {
          r.L(document, a, 'keyup', this.keyFn);
        } else {
          r.L(this.cancel, a, 'click', this.cancelFn);
        }
      }
    }]);

    return Search;
  }();

  var Popin =
  /*#__PURE__*/
  function () {
    function Popin() {
      _classCallCheck(this, Popin);

      this.c = _C;
      r.BM(this, ['openFn', 'closeFn']);
    }

    _createClass(Popin, [{
      key: "init",
      value: function init() {
        this.creditCard = r.G["class"]('credit-card')[0];
        this.noPopin = r.Is.und(this.creditCard);
        if (this.noPopin) return; // Elements

        this.popinWrap = r.G.id('popin-wrap');
        this.popinW = r.G.id('popin-w');
        this.popin = r.G.id('popin');
        this.close = r.G.id('popin-close'); // Anim
        // opacity when desktop
        // slide when mobile

        this.popinShow = new r.TL();

        if (this.c.isDesktop) {
          this.popinShow.from({
            el: this.popin,
            p: {
              opacity: [0, 1]
            },
            d: 500,
            e: 'o2'
          });
        } else {
          this.popinShow.from({
            el: this.popinWrap,
            p: {
              x: [100, 0]
            },
            d: 1200,
            e: 'o5'
          });
        }
      }
    }, {
      key: "openFn",
      value: function openFn(e) {
        var _this = this;

        this.off(); // Scroll

        this.c.overPage.sOn({
          el: this.popinW
        }); // Prepare

        this.type = e.target.dataset.type;
        var cb = new r.Delay(function (_) {
          _this.on();
        }, 500); // Go

        if (this.c.isDesktop) {
          r.T(this.popinWrap, 0, 0);
        }

        var delay = this.c.isDesktop ? 300 : 0;
        this.popinShow.play({
          delay: delay
        });
        this.c.overPage.show();
        cb.run();
      }
    }, {
      key: "closeFn",
      value: function closeFn() {
        var _this2 = this;

        this.c.overPage.sOff();
        this.off(); // Prepare

        var cb = new r.Delay(function (_) {
          if (_this2.c.isDesktop) {
            r.T(_this2.popinWrap, -100, 0);
          }

          _this2.c.overPage.sDestroy();

          _this2.on();
        }, 500); // Go

        this.c.overPage.hide();
        this.popinShow.play({
          delay: 0,
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (this.noPopin) return;
        r.L('.credit-card', a, 'click', this.openFn);
        r.L(this.close, a, 'click', this.closeFn);
      }
    }]);

    return Popin;
  }();

  var MobileMenu =
  /*#__PURE__*/
  function () {
    function MobileMenu() {
      _classCallCheck(this, MobileMenu);

      this.c = _C;
      this.c.mobileMenuIsOpen = false;
      this.c.mobileMenu = this;
      r.BM(this, ['openFn', 'closeFn', 'mobileSignFn', 'mobileSearchFn']);
      this.burger = r.G["class"]('top-nav-link-burger')[0];
      this.close = r.G.id('mobile-menu-close');
      this.menuW = r.G.id('mobile-menu-w');
      this.linkW = r.G.id('mobile-menu-link-w');
      this.link = r.G["class"]('mobile-menu-link');
      this.linkL = this.link.length;
      this.mobileSign = r.G.id('mobile-menu-sign');
      this.mobileSearch = r.G.id('mobile-menu-search');
      this.isOpen = false; // Anim

      this.closeShow = new r.M({
        el: this.close,
        p: {
          opacity: [0, 1]
        },
        d: 500
      });
      this.burgerHide = new r.M({
        el: this.burger,
        p: {
          opacity: [1, 0]
        },
        d: 500
      });
    }

    _createClass(MobileMenu, [{
      key: "on",
      value: function on() {
        if (!this.burger) return;
        this.lOpen('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (!this.burger) return;
        this.lOpen('r');
      }
    }, {
      key: "openFn",
      value: function openFn() {
        var _this = this;

        this.off();
        r.T(this.menuW, 0, 0); // Scroll

        this.c.overPage.sOn({
          el: '#mobile-menu'
        });
        this.c.mobileMenuIsOpen = true; // Prepare

        var cb = new r.Delay(function (_) {
          _this.lClose('a');

          _this.lSign('a');

          _this.lSearch('a');
        }, 500);

        if (r.Is.def(this.linkShow)) {
          this.linkShow.pause();
        }

        this.linkShow = new r.TL();

        for (var i = 0; i < this.linkL; i++) {
          var del = i === 0 ? 200 : 60;
          this.linkShow.from({
            el: this.link[i],
            p: {
              opacity: [0, 1],
              y: [60, 0]
            },
            d: 1200,
            e: 'o6',
            delay: del
          });
        } // Reset


        for (var _i = 0; _i < this.linkL; _i++) {
          this.link[_i].style.opacity = 0;
        }

        this.linkW.style.opacity = 1; // Go

        this.c.overPage.show();
        this.linkShow.play();
        this.burgerHide.play({
          d: 500,
          e: 'o2',
          delay: 0
        });
        this.closeShow.play({
          d: 1000,
          e: 'o2',
          delay: 0
        });
        cb.run();
        this.isOpen = true;
      }
    }, {
      key: "closeFn",
      value: function closeFn() {
        var _this2 = this;

        this.c.overPage.sOff();
        this.lClose('r');
        this.lSign('r');
        this.lSearch('r'); // Prepare

        var cb = new r.Delay(function (_) {
          r.T(_this2.menuW, -100, 0);
          _this2.c.mobileMenuIsOpen = false;

          _this2.c.overPage.sDestroy();

          _this2.on();
        }, 500);
        this.linkHide = new r.M({
          el: this.linkW,
          p: {
            opacity: [1, 0]
          },
          d: 500,
          e: 'o3'
        }); // Go

        this.linkHide.play();
        this.closeShow.play({
          d: 500,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        this.burgerHide.play({
          d: 500,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        this.c.overPage.hide();
        cb.run();
        this.isOpen = false;
      }
    }, {
      key: "mobileSignFn",
      value: function mobileSignFn() {
        var _this3 = this;

        this.c.overPage.sOff();
        this.c.overPage.sDestroy();
        this.lClose('r');
        this.lSign('r');
        this.lSearch('r');
        this.c.signinSidebar.openFn(); // Prepare

        var cb = new r.Delay(function (_) {
          r.T(_this3.menuW, -100, 0);
          _this3.c.mobileMenuIsOpen = false;

          _this3.on();
        }, 300);
        this.linkHide = new r.M({
          el: this.linkW,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o3'
        }); // Go

        this.linkHide.play();
        this.closeShow.play({
          d: 300,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        this.burgerHide.play({
          d: 300,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "mobileSearchFn",
      value: function mobileSearchFn() {
        var _this4 = this;

        this.c.overPage.sOff();
        this.c.overPage.sDestroy();
        this.lClose('r');
        this.lSign('r');
        this.lSearch('r');
        this.c.search.openFn(); // Prepare

        var cb = new r.Delay(function (_) {
          r.T(_this4.menuW, -100, 0);
          _this4.c.mobileMenuIsOpen = false;

          _this4.on();
        }, 300);
        this.linkHide = new r.M({
          el: this.linkW,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o3'
        }); // Go

        this.linkHide.play();
        this.closeShow.play({
          d: 0,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        this.burgerHide.play({
          d: 300,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "closeTransition",
      value: function closeTransition(o) {
        var _this5 = this;

        this.c.overPage.sOff();
        this.lClose('r'); // Prepare

        var cb = new r.Delay(function (_) {
          r.T(_this5.menuW, -100, 0);
          _this5.c.mobileMenuIsOpen = false;

          _this5.c.overPage.sDestroy();

          o.cb();
        }, 300);
        this.linkHide = new r.M({
          el: this.linkW,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o2'
        }); // Go

        this.linkHide.play();
        this.closeShow.play({
          d: 300,
          e: 'o2',
          delay: 0,
          reverse: true
        });
        this.c.overPage.transitionMobileMenu();
        cb.run();
      }
    }, {
      key: "lOpen",
      value: function lOpen(a) {
        r.L(this.burger, a, 'click', this.openFn);
      }
    }, {
      key: "lClose",
      value: function lClose(a) {
        r.L(this.close, a, 'click', this.closeFn);
      }
    }, {
      key: "lSign",
      value: function lSign(a) {
        if (this.mobileSign) {
          r.L(this.mobileSign, a, 'click', this.mobileSignFn);
        }
      }
    }, {
      key: "lSearch",
      value: function lSearch(a) {
        if (this.mobileSearch) {
          r.L(this.mobileSearch, a, 'click', this.mobileSearchFn);
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        // Close menu if open on resize
        if (this.isOpen) {
          this.closeFn();
        }
      }
    }]);

    return MobileMenu;
  }();

  var SideBar =
  /*#__PURE__*/
  function () {
    function SideBar(o) {
      _classCallCheck(this, SideBar);

      this.c = _C;
      this.name = o.moduleName;
      this.triggerClass = o.triggerClass;
      this.isSign = this.name === 'sign';
      this.c.sideBarIsOpen[this.name] = false;
      r.BM(this, ['openFn', 'closeFn', 'switchFn', 'submitLogin', 'submitRegister', 'submitForgot']);
    }

    _createClass(SideBar, [{
      key: "init",
      value: function init() {
        this.overridePreventDefault = false;
        this.trigger = r.G["class"](this.triggerClass)[0];
        var sidebarW = r.G.id(this.name + '-w');
        this.sidebar = r.G.id(this.name);
        this.close = r.G["class"]('sidebar-close', this.sidebar)[0];

        if (this.isSign) {
          this.signIn = r.G.id('sign-in');
          this.signUp = r.G.id('sign-up');
          this.forgot = r.G.id('forgot-password');
          this.input = r.G.tag('input', r.G.id('sign'));
          this.inputL = this.input.length;
        } // Anim


        this.sidebarShow = new r.M({
          el: sidebarW,
          p: {
            x: [100.2, 0]
          },
          d: 1200,
          e: 'o5'
        });
      }
    }, {
      key: "on",
      value: function on() {
        this.lOpen('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.lOpen('r');
      }
    }, {
      key: "openFn",
      value: function openFn() {
        var _this = this;

        this.off();

        if (this.signIn) {
          this.signIn.addEventListener('submit', this.submitLogin);
        }

        if (this.signUp) {
          this.signUp.addEventListener('submit', this.submitRegister);
        }

        if (this.forgot) {
          this.forgot.addEventListener('submit', this.submitForgot);
        }

        this.c.sideBarIsOpen[this.name] = true;
        this.c.overPage.sOn({
          el: this.sidebar
        });

        if (this.isSign) {
          this.signReset();
        } // Prepare


        var cb = new r.Delay(function (_) {
          _this.lClose('a');

          if (_this.isSign) {
            _this.lSwitch('a');
          }
        }, 500); // Go

        if (!this.isSign || this.c.isDesktop) {
          this.c.overPage.show();
        }

        this.sidebarShow.play();
        cb.run();
      }
    }, {
      key: "closeFn",
      value: function closeFn() {
        var _this2 = this;

        if (this.signIn) {
          this.signIn.removeEventListener('submit', this.submitLogin);
        }

        if (this.signUp) {
          this.signUp.removeEventListener('submit', this.submitRegister);
        }

        if (this.forgot) {
          this.forgot.removeEventListener('submit', this.submitForgot);
        }

        this.c.overPage.sOff();
        this.lClose('r');

        if (this.isSign) {
          this.lSwitch('r');
        } // Prepare


        var cb = new r.Delay(function (_) {
          _this2.c.sideBarIsOpen[_this2.name] = false;

          _this2.c.overPage.sDestroy();

          _this2.on();

          if (!_this2.isSign) {
            _C.cart.refresh();
          }
        }, 500); // Go

        this.c.overPage.hide();
        this.sidebarShow.play({
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "closeTransition",
      value: function closeTransition(o) {
        var _this3 = this;

        this.c.overPage.sOff();
        this.lClose('r');

        if (this.isSign) {
          this.lSwitch('r');
        } // Prepare


        var cb = new r.Delay(function (_) {
          _this3.c.sideBarIsOpen[_this3.name] = false;

          _this3.c.overPage.sDestroy();

          o.cb();
        }, 500); // Go

        if (this.c.isDesktop) {
          this.c.overPage.transitionCartDesktop();
        } else {
          this.c.overPage.transitionCartMobile();
        }

        this.sidebarShow.play({
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "lOpen",
      value: function lOpen(a) {
        if (this.trigger) {
          r.L(this.trigger, a, 'click', this.openFn);
        }
      }
    }, {
      key: "lClose",
      value: function lClose(a) {
        r.L(this.close, a, 'click', this.closeFn);
      }
    }, {
      key: "lSwitch",
      value: function lSwitch(a) {
        r.L('.sign-switch', a, 'click', this.switchFn);
        r.L('.forgot-switch', a, 'click', this.switchFn);
      }
    }, {
      key: "submitLogin",
      value: function submitLogin(e) {
        var _this4 = this;

        if (!this.overridePreventDefault) {
          e.preventDefault();
          var form = e.target;
          var params = '';
          var valueCount = 0;
          var inputs = r.G.tag('input', form);

          for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];

            if (input.value) {
              if (params.length) {
                params += '&';
              }

              params += input.name + '=' + input.value;
              valueCount++;
            }
          }

          if (valueCount < 2) {
            var errors = document.createElement('ul');
            errors.className = 'errors';
            errors.innerHTML = '<li>All fields are required</li>';
            var oldErrors = r.G["class"]('errors', form)[0];

            if (oldErrors) {
              var parent = oldErrors.parentNode;
              parent.insertBefore(errors, oldErrors);
              parent.removeChild(oldErrors);
            } else {
              var _parent = form;

              _parent.insertBefore(errors, _parent.children[0]);
            }

            return;
          }

          var xhr = new XMLHttpRequest();
          xhr.open('POST', form.action, true);
          xhr.responseType = 'document';
          xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

          xhr.onreadystatechange = function (_) {
            if (xhr.readyState === 4 && xhr.status === 200) {
              var r$1 = xhr.response;
              var xhrBody = r.G.id('xhr', r$1);
              var login = r.G["class"]('sign-in', xhrBody)[0];
              var challenge = r.G["class"]('shopify-challenge__container', r$1)[0];

              if (login && !challenge) {
                // FAILED; inject error markup into sidebar
                var _errors = r.G["class"]('errors', login)[0];
                var _oldErrors = r.G["class"]('errors', form)[0];

                if (_oldErrors) {
                  var _parent2 = _oldErrors.parentNode;

                  _parent2.insertBefore(_errors, _oldErrors);

                  _parent2.removeChild(_oldErrors);
                } else {
                  var _parent3 = form;

                  _parent3.insertBefore(_errors, _parent3.children[0]);
                }
              } else if (challenge) {
                _this4.overridePreventDefault = true;
                form.submit();
              } else {
                var mobileMenu = r.G.id('mobile-menu-link-w');
                var li = r.G["class"]('not-signed-in', mobileMenu)[0];

                if (li) {
                  li.classList.remove('not-signed-in');
                  li.classList.add('is-signed-in');
                }

                r.G["class"]('top-nav-link')[0].classList.add('has-customer');
                var customerInitial = r.G["class"]('customer-initial')[0];
                var newCustomerInitial = r.G["class"]('customer-initial', r$1)[0];

                if (customerInitial && newCustomerInitial) {
                  customerInitial.innerHTML = newCustomerInitial.innerHTML;
                }

                _this4.closeFn();
              }
            }
          };

          xhr.send(params);
        }
      }
    }, {
      key: "submitRegister",
      value: function submitRegister(e) {
        var _this5 = this;

        if (!this.overridePreventDefault) {
          e.preventDefault();
          var password;
          var confirm;
          var form = e.target;
          var params = '';
          var valueCount = 0;
          var inputs = r.G.tag('input', form);

          for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];

            if (input.value && input.name !== 'customer[confirm]') {
              if (params.length) {
                params += '&';
              }

              params += input.name + '=' + input.value;
              valueCount++;
            }

            if (input.name === 'customer[password]') {
              password = input.value;
            }

            if (input.name === 'customer[confirm]') {
              confirm = input.value;
            }
          }

          var passwordMismatch = password !== confirm;
          var fieldsRequired = valueCount < 4;

          if (fieldsRequired || passwordMismatch) {
            var errors = document.createElement('ul');
            errors.className = 'errors';

            if (passwordMismatch) {
              errors.innerHTML = '<li>Passwords must match</li>';
            } else {
              errors.innerHTML = '<li>All fields are required</li>';
            }

            var oldErrors = r.G["class"]('errors', form)[0];

            if (oldErrors) {
              var parent = oldErrors.parentNode;
              parent.insertBefore(errors, oldErrors);
              parent.removeChild(oldErrors);
            } else {
              var _parent4 = form;

              _parent4.insertBefore(errors, _parent4.children[0]);
            }

            return;
          }

          var xhr = new XMLHttpRequest();
          xhr.open('POST', form.action, true);
          xhr.responseType = 'document';
          xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

          xhr.onreadystatechange = function (_) {
            if (xhr.readyState === 4 && xhr.status === 200) {
              var r$1 = xhr.response;
              console.log(r$1);
              var xhrBody = r.G.id('xhr', r$1);
              console.log(r.G["class"]('sign-up', xhrBody));
              var register = r.G["class"]('sign-up', xhrBody)[0];
              var challenge = r.G["class"]('shopify-challenge__container', r$1)[0];

              if (register && !challenge) {
                // FAILED; inject error markup into sidebar
                var _errors2 = r.G["class"]('errors', register)[0];
                var _oldErrors2 = r.G["class"]('errors', form)[0];

                if (_oldErrors2) {
                  var _parent5 = _oldErrors2.parentNode;

                  _parent5.insertBefore(_errors2, _oldErrors2);

                  _parent5.removeChild(_oldErrors2);
                } else {
                  var _parent6 = form;
                  console.log(_parent6, _errors2, _parent6.children[0]);

                  _parent6.insertBefore(_errors2, _parent6.children[0]);
                }
              } else if (challenge) {
                _this5.overridePreventDefault = true;
                form.submit();
              } else {
                var mobileMenu = r.G.id('mobile-menu-link-w');
                var li = r.G["class"]('not-signed-in', mobileMenu)[0];

                if (li) {
                  li.classList.remove('not-signed-in');
                  li.classList.add('is-signed-in');
                }

                r.G["class"]('top-nav-link')[0].classList.add('has-customer');
                var customerInitial = r.G["class"]('customer-initial')[0];
                var newCustomerInitial = r.G["class"]('customer-initial', r$1)[0];

                if (customerInitial && newCustomerInitial) {
                  customerInitial.innerHTML = newCustomerInitial.innerHTML;
                }

                _this5.closeFn();
              }
            }
          };

          xhr.send(params);
        }
      }
    }, {
      key: "submitForgot",
      value: function submitForgot(e) {
        var _this6 = this;

        if (!this.overridePreventDefault) {
          e.preventDefault();
          var form = e.target;
          var params = '';
          var valueCount = 0;
          var inputs = r.G.tag('input', form);

          for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];

            if (input.value) {
              if (params.length) {
                params += '&';
              }

              params += input.name + '=' + input.value;
              valueCount++;
            }
          }

          if (valueCount < 1) {
            var errors = document.createElement('ul');
            errors.className = 'errors';
            errors.innerHTML = '<li>All fields are required</li>';
            var oldErrors = r.G["class"]('errors', form)[0];

            if (oldErrors) {
              var parent = oldErrors.parentNode;
              parent.insertBefore(errors, oldErrors);
              parent.removeChild(oldErrors);
            } else {
              var _parent7 = form;

              _parent7.insertBefore(errors, _parent7.children[0]);
            }

            return;
          }

          var xhr = new XMLHttpRequest();
          xhr.open('POST', form.action, true);
          xhr.responseType = 'document';
          xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

          xhr.onreadystatechange = function (_) {
            if (xhr.readyState === 4 && xhr.status === 200) {
              var r$1 = xhr.response;
              var xhrBody = r.G.id('xhr', r$1);
              var _errors3 = r.G["class"]('errors', xhrBody)[0];
              var challenge = r.G["class"]('shopify-challenge__container', r$1)[0];

              if (_errors3 && !challenge) {
                // FAILED; inject error markup into sidebar
                var _oldErrors3 = r.G["class"]('errors', form)[0];

                if (_oldErrors3) {
                  var _parent8 = _oldErrors3.parentNode;

                  _parent8.insertBefore(_errors3, _oldErrors3);

                  _parent8.removeChild(_oldErrors3);
                } else {
                  var _parent9 = form;

                  _parent9.insertBefore(_errors3, _parent9.children[0]);
                }
              } else if (challenge) {
                _this6.overridePreventDefault = true;
                form.submit();
              } else {
                _this6.closeFn();
              }
            }
          };

          xhr.send(params);
        }
      }
    }, {
      key: "signReset",
      value: function signReset() {
        r.T(this.signIn, 0, 0);
        r.T(this.signUp, 100, 0);
        r.T(this.forgot, 100, 0);
        this.signIn.style.opacity = 1;
        this.signUp.style.opacity = 0;
        this.forgot.style.opacity = 0;
        var oldErrors = r.G["class"]('errors', this.signIn)[0];

        if (oldErrors) {
          var parent = oldErrors.parentNode;
          parent.removeChild(oldErrors);
        }

        oldErrors = r.G["class"]('errors', this.signUp)[0];

        if (oldErrors) {
          var _parent10 = oldErrors.parentNode;

          _parent10.removeChild(oldErrors);
        }

        oldErrors = r.G["class"]('errors', this.forgot)[0];

        if (oldErrors) {
          var _parent11 = oldErrors.parentNode;

          _parent11.removeChild(oldErrors);
        }

        this.clearForm();
      }
    }, {
      key: "switchFn",
      value: function switchFn(e) {
        var _this7 = this;

        e.preventDefault();
        this.c.outroIsOn = false;
        this.lClose('r');
        this.lSwitch('r');
        this.c.overPage.sOff();
        var signInForm = r.G.tag('form', this.signIn)[0];
        var signUpForm = r.G.tag('form', this.signUp)[0];
        var forgotForm = r.G.tag('form', this.forgot)[0]; // -------------------------------
        // Prepare

        var needSignUp = e.target.id === 'sign-in-register';
        var needForgot = e.target.id === 'sign-in-forgot';
        var fromSignup = e.target.id === 'sign-up-sign-in';
        var toHide;
        var toShow;

        if (needSignUp) {
          toHide = this.signIn;
          toShow = this.signUp;
        } else if (needForgot) {
          toHide = this.signIn;
          toShow = this.forgot;
        } else if (fromSignup) {
          toHide = this.signUp;
          toShow = this.signIn;
        } else {
          toHide = this.forgot;
          toShow = this.signIn;
        }

        var tl = new r.TL();
        tl.from({
          el: toHide,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o3'
        });
        tl.from({
          el: toShow,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3',
          delay: 300
        });
        var scrollCb = new r.Delay(function (_) {
          _this7.c.overPage.sDestroy();

          _this7.c.overPage.sOn({
            el: _this7.sidebar
          });
        }, 300);
        var cb = new r.Delay(function (_) {
          _this7.clearForm();

          r.T(toHide, 100, 0);
          r.PE.all(signInForm);
          r.PE.all(signUpForm);
          r.PE.all(forgotForm);

          _this7.lClose('a');

          _this7.lSwitch('a');

          _this7.c.outroIsOn = true;
        }, 800); // -------------------------------
        // Go

        r.PE.none(signInForm);
        r.PE.none(signUpForm);
        r.PE.none(forgotForm);
        r.T(toShow, 0, 0);
        tl.play();
        scrollCb.run();
        cb.run();
      }
    }, {
      key: "clearForm",
      value: function clearForm() {
        for (var i = 0; i < this.inputL; i++) {
          this.input[i].value = '';
          var parent = this.input[i].parentNode;
          parent.classList.remove('active');
          parent.classList.remove('complete');
        }
      }
    }]);

    return SideBar;
  }();

  var SearchResults =
  /*#__PURE__*/
  function () {
    function SearchResults() {
      _classCallCheck(this, SearchResults);

      this.c = _C;
      r.BM(this, ['resetForm', 'search']);
    }

    _createClass(SearchResults, [{
      key: "init",
      value: function init() {
        this.input = r.G["class"]('search-results-form-input')[0];
        this.noSearchResults = r.Is.und(this.input);
        if (this.noSearchResults) return;
        this.cancel = r.G["class"]('search-results-form-cancel')[0];
        this.label = r.G["class"]('search-results-form-label')[0];
      }
    }, {
      key: "resetForm",
      value: function resetForm() {
        this.input.value = '';
      }
    }, {
      key: "on",
      value: function on() {
        if (this.noSearchResults) return;
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noSearchResults) return;
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.cancel, a, 'click', this.resetForm);
        r.L(this.label, a, 'click', this.search);
      }
    }, {
      key: "search",
      value: function search() {
        var value = this.input.value;
        var url = '/search?view=json&type=product&q=*' + value + '*';
        console.log(url);
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var data = xhr;
            console.log(data);
          }
        };

        xhr.send(null);
      }
    }]);

    return SearchResults;
  }();

  var SearchResults$1 = new SearchResults();

  var LineSplit =
  /*#__PURE__*/
  function () {
    function LineSplit(el, tag) {
      _classCallCheck(this, LineSplit);

      this.el = el;
      this.initialContent = this.el.textContent;
      this.t0 = '<' + tag + '>';
      this.t1 = '</' + tag + '>';
    }

    _createClass(LineSplit, [{
      key: "run",
      value: function run() {
        this.el.setAttribute('style', '');
        this.el.innerHTML = this.initialContent.replace(/\S+/g, '<n>$&</n>');
        var children = this.el.children;
        var childrenL = children.length;
        var top = 0;
        var content = '';

        for (var i = 0; i < childrenL; i++) {
          var childrenTop = children[i].offsetTop;

          if (top < childrenTop) {
            var tag = i === 0 ? this.t0 : this.t1 + this.t0;
            content = content.slice(0, -1) + tag;
          }

          top = childrenTop;
          content += children[i].textContent + ' ';
        }

        content = content.slice(0, -1) + this.t1;
        this.el.innerHTML = content; // tolerance to resolve a newline bug on limit

        this.el.style.width = this.el.offsetWidth + 2 + 'px';
      }
    }]);

    return LineSplit;
  }();

  var MaterialsList =
  /*#__PURE__*/
  function () {
    function MaterialsList(element) {
      var _this = this;

      _classCallCheck(this, MaterialsList);

      this.c = _C;
      r.BM(this, ['extend']);
      this.isDesktop = this.c.isDesktop;
      this.p = r.G["class"]('materials-list-p', element);
      this.pL = this.p.length;
      this.noMaterialsList = this.pL < 1;
      if (this.noMaterialsList) return;
      this.btn = r.G["class"]('materials-list-btn', element)[0];
      if (this.btn) this.btn = this.btn.children[0];
      this.li = r.G["class"]('materials-list-ul', element)[0].children;
      this.liL = this.li.length;

      if (this.isDesktop) {
        this.lineSplit = [];

        for (var i = 0; i < this.pL; i++) {
          this.lineSplit[i] = new LineSplit(this.p[i], 'span');
        }
      }

      setTimeout(function (_) {
        return _this.resize();
      }, 500);
      setTimeout(function (_) {
        return _this.resize();
      }, 1500);
      setTimeout(function (_) {
        return _this.resize();
      }, 5000);
    }

    _createClass(MaterialsList, [{
      key: "resize",
      value: function resize() {
        if (this.noMaterialsList) return;

        if (this.isDesktop) {
          for (var i = 0; i < this.pL; i++) {
            this.lineSplit[i].run();
          } // this.c.scroll.resize(true)

        }
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (this.noMaterialsList) return;
        if (this.btn) r.L(this.btn, a, 'click', this.extend);
      }
    }, {
      key: "extend",
      value: function extend() {
        this.off();

        if (this.isDesktop) ;

        this.btn.style.display = 'none';

        for (var i = 0; i < this.liL; i++) {
          this.li[i].style.opacity = 0;
          this.li[i].style.display = 'flex';
        }

        if (this.isDesktop) {
          this.resize();
        }

        for (var _i = 0; _i < this.liL; _i++) {
          this.li[_i].style.opacity = 1;
        }

        if (this.isDesktop) ;
      }
    }]);

    return MaterialsList;
  }();

  var Dom =
  /*#__PURE__*/
  function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, [{
      key: "sliderImgFade",
      value: function sliderImgFade(o) {
        var url = o.url;
        var qty = o.qty;
        var fullHeight = o.fullHeight;
        var supportsObjectFit = 'objectFit' in document.documentElement.style;
        var ul = r.Cr('ul');
        ul.className = 'slider-img-fade-w';

        for (var i = 0; i < qty; i++) {
          var li = r.Cr('li');
          var img = r.Cr('img');

          if (supportsObjectFit) {
            img.src = "".concat(url[i]);
          } else {
            img.className = 'no-object-fit';
            img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            img.style.backgroundImage = "url(".concat(url[i], ")");
            img.style.backgroundPosition = 'center';
            img.style.backgroundRepeat = 'no-repeat';
            img.style.backgroundSize = 'contain';
          }

          li.className = 'slider-image-wrapper ' + 'slider-img-fade' + (fullHeight[i] ? ' is-full-height' : '');
          li.style.opacity = i === 0 ? 1 : 0;
          li.appendChild(img);
          ul.appendChild(li);
        }

        return ul;
      }
    }, {
      key: "lightboxBtn",
      value: function lightboxBtn(o) {
        var txt = o.txt;
        var noPE = o.noPE; // Btn Wrap

        var btnW = r.Cr('button');
        btnW.className = 'btn-w btn-dark lightbox-btn';

        if (noPE) {
          r.PE.none(btnW);
        } // Btn bg


        var btnBg = r.Cr('span');
        btnBg.className = 'btn-bg';
        btnW.appendChild(btnBg); // Btn

        var btn = r.Cr('span');
        btn.className = 'btn'; // Btn content

        for (var j = 0; j < 4; j++) {
          var spanW = r.Cr('span');
          spanW.className = j === 3 ? 'btn-ref' : 'btn-abs';
          var span = r.Cr('span');
          var spanClass = void 0;

          if (j === 0) {
            spanClass = 'btn-over-0';
          } else if (j === 1) {
            spanClass = 'btn-over-1';
          } else if (j === 2) {
            spanClass = 'btn-curr-1';
          } else {
            spanClass = 'btn-curr-0';
          }

          span.className = spanClass;
          span.textContent = txt;
          spanW.appendChild(span);
          btn.appendChild(spanW);
        } // Add Btn to Btn Wrap


        btnW.appendChild(btn);
        return btnW;
      }
    }, {
      key: "color",
      value: function color(o) {
        var colors = o.colors;
        var noPE = o.noPE; // Ul

        var ul = r.Cr('ul');
        ul.className = 'configurator-left-options-color configurator-left-options-ul'; // Li

        var keys = Object.keys(colors);
        var colorsL = keys.length;

        for (var j = 0; j < colorsL; j++) {
          var color = colors[keys[j]];
          var li = r.Cr('li');
          li.className = 'lightbox-color';

          if (noPE) {
            r.PE.none(li);
          }

          if (j === o.activeColor) {
            li.className = 'lightbox-color active';
          } // Div


          var div = r.Cr('div');
          div.style.backgroundColor = color.hex1;
          div.style.setProperty('--hex2', color.hex2);
          li.appendChild(div); // Add Li to Ul

          ul.appendChild(li);
        }

        return ul;
      }
    }]);

    return Dom;
  }();

  var Dom$1 = new Dom();

  var Lightbox =
  /*#__PURE__*/
  function () {
    function Lightbox() {
      _classCallCheck(this, Lightbox);

      this.c = _C;
      this.c.lightboxIsOn = false;
      r.BM(this, ['hide', 'btnFn', 'colorFn', 'selectFn']); // Elements

      this.lightboxW = r.G.id('lightbox-w');
      this.lightbox = r.G.id('lightbox');
      this.close = r.G.id('lightbox-close');
      this.pagiCurr = r.G["class"]('slider-pagination-curr', this.lightbox)[0];
      this.pagiTotal = r.G["class"]('slider-pagination-total', this.lightbox)[0];
      this.img = r.G.id('lightbox-img');
      this.title = r.G.id('lightbox-title');
      this.info = r.G.id('lightbox-info');
      this.accessoriesList = r.G.id('lightbox-accessories-list'); // Animation

      this.hiddenElementsShow = new r.M({
        el: '.lightbox-hidden',
        p: {
          opacity: [0, 1]
        },
        d: 500,
        e: 'o2'
      });
    }

    _createClass(Lightbox, [{
      key: "show",
      value: function show(o) {
        var _this = this;

        this.sliderCb = o.cb;

        if (this.c.isDesktop) ;

        this.c.smoothScroll.disableScrolling();
        TouchDisable$1.on(); // Content add

        this.addContent(); // Prepare

        var cb = new r.Delay(function (_) {
          // this.c.lightboxSlider1.init()
          _this.c.lightboxSlider1.resize();

          TouchDisable$1.off();

          _this.c.overPage.sOn({
            el: _this.lightbox
          });

          _this.c.lightboxIsOn = true;

          _this.l('a');
        }, 500); // Go

        r.T(this.lightboxW, 0, 0);
        this.c.overPage.lightboxShow();
        this.hiddenElementsShow.play({
          delay: 400
        });
        cb.run(); // Slider
        // Construct Slider once Lightbox is shown to correctly get images for slider

        var sliderElement = r.G.id('lightbox');
        this.c.lightboxSlider1 = new Slider1({
          parent: '#lightbox',
          element: sliderElement
        });
        this.c.lightboxSlider1.slideToIndex(o.index, true);
        this.on();
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this2 = this;

        this.c.smoothScroll.enableScrolling();
        this.c.overPage.sOff();
        this.l('r');
        this.off();
        this.c.lightboxIsOn = false; // Prepare

        var cb = new r.Delay(function (_) {
          r.T(_this2.lightboxW, -100, 0);

          _this2.c.overPage.sDestroy();

          _this2.c.lightboxSlider1.resize();

          _this2.sliderCb();
        }, 500); // Go

        this.c.overPage.hide();
        this.hiddenElementsShow.play({
          delay: 0,
          reverse: true
        });
        cb.run();
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.close, a, 'click', this.hide);
        r.L('.lightbox-btn', a, 'click', this.btnFn);
        r.L('.lightbox-color', a, 'click', this.colorFn);
        r.L('.lightbox-select', a, 'change', this.selectFn);
      }
    }, {
      key: "changeVariant",
      value: function changeVariant(accessory, option, level) {
        accessory.variantOptionSet[level] = true;
        var options = accessory.variant.options.slice();
        options[level] = option;

        if (accessory.variant.option5) {
          accessory.variant = accessory.variantsByValue[options[0]][options[1]][options[2]][options[3]][options[4]];
        } else if (accessory.variant.option4) {
          accessory.variant = accessory.variantsByValue[options[0]][options[1]][options[2]][options[3]];
        } else if (accessory.variant.option3) {
          accessory.variant = accessory.variantsByValue[options[0]][options[1]][options[2]];
        } else if (accessory.variant.option2) {
          accessory.variant = accessory.variantsByValue[options[0]][options[1]];
        } else if (accessory.variant.option1) {
          accessory.variant = accessory.variantsByValue[options[0]];
        }
      }
    }, {
      key: "selectFn",
      value: function selectFn(e) {
        var parent = e.target.parentNode;
        r.G.tag('span', parent)[0].innerHTML = e.target.value;
        var index = e.target.dataset.accessoryIndex;
        var accessory = this.c.backendData.lightbox.packConfiguration[index];

        if (e.target.selectedIndex === 0) {
          accessory.variantOptionSet[e.target.dataset.optionLevel] = false;
          accessory.addVariant(accessory.productId, accessory.variantId, accessory.variantOptionSet.includes(false));
          return;
        }

        this.changeVariant(accessory, e.target.value, e.target.dataset.optionLevel);
        if (accessory.added) accessory.addVariant(accessory.productId, accessory.variant.id, accessory.variantOptionSet.includes(false));
        accessory.variantId = accessory.variant.id;
      }
    }, {
      key: "colorFn",
      value: function colorFn(e) {
        this.l('r');
        var colorLi = e.target;
        var colorIndex = r.Index.list(colorLi);
        var colorUl = colorLi.parentNode;
        var colorLiChildren = colorUl.children;
        var accessoryLi = colorUl.parentNode;
        var accessoryIndex = r.Index["class"](accessoryLi, 'lightbox-accessories-li'); // Take data

        var accessory = this.c.backendData.lightbox.packConfiguration[accessoryIndex];
        var colorNames = accessory.colorNames;
        var colorNamesL = colorNames.length; // Change selected index

        accessory.activeColor = colorIndex;
        console.log(accessory.colorNames[colorIndex]); // Notify delegate of change

        this.changeVariant(accessory, accessory.colorNames[colorIndex], accessory.colorIndex);
        if (accessory.added) accessory.addVariant(accessory.productId, accessory.variant.id, accessory.variantOptionSet.includes(false));
        accessory.variantId = accessory.variant.id; // Update DOM

        if (accessory.variant.featured_image) {
          this.updateImage(accessoryIndex, accessory.variant.featured_image.src);
        }

        for (var i = 0; i < colorNamesL; i++) {
          var isActive = i === colorIndex; // Active class

          var action = isActive ? 'add' : 'remove';
          colorLiChildren[i].classList[action]('active');
        }

        this.l('a');
      }
    }, {
      key: "updateImage",
      value: function updateImage(index, url) {
        var li = r.G["class"]('slider-image-wrapper', this.img)[index];
        var currentHeroImg = li.children[0];
        var img = document.createElement('img');
        img.src = url;
        img.classList.add('fade-in'); // if (this.currentVariant.featured_image.alt) {
        //     img.alt = this.currentVariant.featured_image.alt
        // }

        img.addEventListener('animationend', function () {
          img.classList.remove('fade-in');
          if (currentHeroImg.parentNode) currentHeroImg.parentNode.removeChild(currentHeroImg);
        }, false);
        li.appendChild(img);
      }
    }, {
      key: "btnFn",
      value: function btnFn(e) {
        this.l('r');
        var btn = e.target;
        var accessoryLi = btn.parentNode;
        var accessoryIndex = r.Index["class"](accessoryLi, 'lightbox-accessories-li'); // Update data

        var accessory = this.c.backendData.lightbox.packConfiguration[accessoryIndex];
        var added = accessory.added;
        accessory.added = !added; // Update btn text

        var text = accessory.added ? 'REMOVE' : 'ADD';
        r.G["class"]('btn-over-0', btn)[0].textContent = text;
        r.G["class"]('btn-over-1', btn)[0].textContent = text;
        r.G["class"]('btn-curr-1', btn)[0].textContent = text;
        r.G["class"]('btn-curr-0', btn)[0].textContent = text;

        if (accessory.added) {
          accessory.addVariant(accessory.productId, accessory.variantId, accessory.variantOptionSet.includes(false));
        } else {
          accessory.removeProduct(accessory.productId);
        }

        this.l('a');
      }
    }, {
      key: "addContent",
      value: function addContent() {
        // -----------------------------------------------
        // DETECT IF "Pack Configuration Lightbox" OR "Simple Product Lightbox"
        // this.isPackConfigurationLightbox = true
        var lightboxData = this.c.backendData.lightbox;
        this.data = this.isPackConfigurationLightbox ? lightboxData.packConfiguration : lightboxData.simpleProduct; // -----------------------------------------------
        // Data length

        this.dataL = this.data.length; // -----------------------------------------------
        // Reset

        this.lightboxReset(); // -----------------------------------------------
        // Update
        // Common

        this.classUp();
        this.paginationUp();
        this.imgUp(); // Pack Configuration Lightbox

        if (this.isPackConfigurationLightbox) {
          this.titleUp();
          this.accessoriesListUp();
        } else {
          this.simpleProductUpdate();
        } // -----------------------------------------------

      }
    }, {
      key: "classUp",
      value: function classUp() {
        var c = this.isPackConfigurationLightbox ? 'pack-configuration' : 'simple-product';

        if (this.isPackConfigurationLightbox) {
          this.info.classList.remove('simple-product');
          this.img.classList.remove('simple-product');
        } else {
          this.info.classList.remove('pack-configuration');
          this.img.classList.remove('pack-configuration');
        }

        this.info.classList.add(c);
        this.img.classList.add(c);
      }
    }, {
      key: "titleUp",
      value: function titleUp() {
        this.title.textContent = 'Accessory';
      }
    }, {
      key: "simpleProductUpdate",
      value: function simpleProductUpdate() {
        var ul = r.Cr('ul');

        for (var i = 0; i < this.dataL; i++) {
          // Data
          var data = this.data[i];
          var li = r.Cr('li');
          li.className = 'lightbox-simple-li hidden';
          li.style.opacity = i === 0 ? 1 : 0; // Title

          var title = r.Cr('div');
          title.textContent = data.title;
          title.className = 'lightbox-accessories-title';
          li.appendChild(title); // Description

          var description = r.Cr('div');
          description.textContent = data.description;
          description.className = 'lightbox-accessories-description';

          if (data.description) {
            li.appendChild(description);
          } // Add li in ul


          ul.appendChild(li);
        }

        this.accessoriesList.appendChild(ul);
      }
    }, {
      key: "accessoriesListUp",
      value: function accessoriesListUp() {
        var _this3 = this;

        var ul = r.Cr('ul');

        var _loop = function _loop(i) {
          // Data
          var data = _this3.data[i]; // Li

          var li = r.Cr('li');
          li.className = 'lightbox-accessories-li hidden';
          li.style.opacity = i === 0 ? 1 : 0; // Title

          var title = r.Cr('div');
          title.textContent = data.title;
          title.className = 'lightbox-accessories-title';
          li.appendChild(title); // Description

          var description = r.Cr('div');
          description.textContent = data.description;
          description.className = 'lightbox-accessories-description';
          li.appendChild(description); // Color

          var color = _this3.getColor(i);

          li.appendChild(color); // Other selectors

          var otherSelects = _this3.getOtherSelects(i);

          if (otherSelects) {
            otherSelects.forEach(function (select) {
              if (select) li.appendChild(select);
            });
          } // Btn


          if (data.isAccessory) {
            var btn = _this3.gBtn(i);

            li.appendChild(btn);
          } // Add li in ul


          ul.appendChild(li);
        };

        for (var i = 0; i < this.dataL; i++) {
          _loop(i);
        }

        this.accessoriesList.appendChild(ul);
      }
    }, {
      key: "paginationUp",
      value: function paginationUp() {
        var leadingZero = this.dataL < 10 ? '0' : '';
        this.pagiTotal.textContent = '0' + leadingZero + this.dataL;
      }
    }, {
      key: "lightboxReset",
      value: function lightboxReset() {
        // Pagination
        this.pagiCurr.textContent = '001'; // Type

        this.title.textContent = ''; // Pictures

        while (this.img.firstChild) {
          this.img.removeChild(this.img.firstChild);
        } // Accessories list


        while (this.accessoriesList.firstChild) {
          this.accessoriesList.removeChild(this.accessoriesList.firstChild);
        }
      }
    }, {
      key: "imgUp",
      value: function imgUp() {
        var imgUrl = [];
        var fullHeight = [];

        for (var i = 0; i < this.dataL; i++) {
          imgUrl[i] = this.data[i].url.replace(this.c.s3Domain, this.c.cloudFrontDomain);
          fullHeight[i] = this.data[i].isFullHeight;
        }

        var ul = Dom$1.sliderImgFade({
          qty: this.dataL,
          url: imgUrl,
          fullHeight: fullHeight
        });
        this.img.appendChild(ul);
      }
    }, {
      key: "gBtn",
      value: function gBtn(i) {
        var txt = this.data[i].added ? 'REMOVE' : 'ADD';
        var noPE = i !== 0;
        var btnW = Dom$1.lightboxBtn({
          txt: txt,
          noPE: noPE
        });
        return btnW;
      }
    }, {
      key: "getColor",
      value: function getColor(i) {
        var noPE = i !== 0;
        var ul = Dom$1.color({
          colors: this.data[i].colors,
          activeColor: this.data[i].activeColor,
          noPE: noPE
        });
        return ul;
      }
    }, {
      key: "getOtherSelects",
      value: function getOtherSelects(i) {
        var _this4 = this;

        // <div class="select-w variant-option-size">
        //     <span>Select a Size</span>
        //     <svg>
        //         <use xlink:href="#svg-subpage-nav-arrow"></use>
        //     </svg>
        //     <select data-option="Size" data-option-level="0">
        //         <option data-is-cta="1">Select a Size</option>
        //         <option value="S">S</option>
        //         <option value="M">M</option>
        //         <option value="L">L</option>
        //     </select>
        // </div>
        var options = this.data[i].options;

        if (options.length > 0) {
          if (options.length === 1) {
            if (options[0] === 'Color' || options[0] === 'Title') return;
          }

          var elements = options.map(function (option, index) {
            if (option === 'Color') return;
            var isSelected = _this4.data[i].variantOptionSet[index];
            var div = document.createElement('div');
            div.className = 'select-w variant-option-' + option.toLowerCase();
            var span = document.createElement('span');
            span.innerHTML = isSelected ? _this4.data[i].variant.options[index] : 'Select a ' + option;
            div.appendChild(span);
            var svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            var useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#svg-subpage-nav-arrow');
            svgElem.appendChild(useElem);
            div.appendChild(svgElem);
            var select = document.createElement('select');
            select.className = 'lightbox-select';
            select.dataset.accessoryIndex = i;
            select.dataset.option = option;
            select.dataset.optionLevel = index;
            div.appendChild(select);
            var ctaOption = document.createElement('option');
            ctaOption.dataset.isCta = '1';
            ctaOption.innerHTML = 'Select a ' + option;
            select.appendChild(ctaOption);
            var obj = _this4.data[i].variantsByValue;
            var level = 0;
            var targetLevel = index;

            while (level < targetLevel) {
              obj = obj[Object.keys(obj)[0]];
              level++;
            }

            Object.keys(obj).forEach(function (k) {
              var option = document.createElement('option');
              option.value = k;
              option.innerHTML = k;
              select.appendChild(option);
            });

            if (isSelected) {
              select.value = _this4.data[i].variant.options[index];
            }

            return div;
          });
          return elements;
        }
      }
    }, {
      key: "on",
      value: function on() {
        if (this.c.lightboxSlider1) {
          this.c.lightboxSlider1.on();
        }
      }
    }, {
      key: "off",
      value: function off() {
        if (this.c.lightboxSlider1) {
          this.c.lightboxSlider1.off();
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.c.lightboxSlider1) {
          this.c.lightboxSlider1.resize();
          this.c.lightboxSlider1.setImageMarginTop();
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.c.lightboxSlider1) {
          this.c.lightboxSlider1.loop();
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (this.c.lightboxSlider1) {
          this.c.lightboxSlider1.move(x, y, target);
        }
      }
    }]);

    return Lightbox;
  }();

  var SpanSplit =
  /*#__PURE__*/
  function () {
    function SpanSplit(o) {
      _classCallCheck(this, SpanSplit);

      this.elC = o.elClass;
      this.parent = o.parent;
      this.isProductCarouselHero = this.elC === 'product-carousel-hero-primary';
    }

    _createClass(SpanSplit, [{
      key: "init",
      value: function init() {
        var title = r.G["class"](this.elC, this.parent);
        var titleL = title.length;
        if (titleL < 1) return;

        for (var i = 0; i < titleL; i++) {
          var split = title[i].textContent.split(' ');
          var splitL = this.isProductCarouselHero ? 3 : split.length;
          var dom = '';

          for (var j = 0; j < splitL; j++) {
            dom += '<span>' + split[j] + '</span>';
          }

          title[i].innerHTML = dom;
        }
      }
    }]);

    return SpanSplit;
  }();

  var StickyCursor =
  /*#__PURE__*/
  function () {
    function StickyCursor(o) {
      _classCallCheck(this, StickyCursor);

      this.c = _C;
      this.area = o.area; // Cursor

      this.cursorIsVisible = false;
      this.x = -1;
      this.y = -1;
      this.cursor = {
        x: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        y: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        el: {}
      };
      this.cursor.el.main = r.G["class"]('slider-cursor', this.area)[0];
      this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.area)[0];
      this.cursorShow = new r.M({
        el: this.cursor.el.main,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorScale = new r.M({
        el: this.cursor.el.bg,
        p: {
          scale: [0.9, 1]
        },
        d: 300,
        e: 'o2'
      });
    }

    _createClass(StickyCursor, [{
      key: "resize",
      value: function resize() {
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top; // Area

        this.areaTop = areaRectTop + pageYOffset;
        this.areaLeft = areaRect.left; // Cursor

        this.cursor.w = this.cursor.el.main.offsetWidth;
        this.cursor.wDemi = this.cursor.w / 2;
        this.cursor.x.max = this.area.offsetWidth;
        this.cursor.y.max = this.area.offsetHeight;
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y); // Check if in slider

        var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
        var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
        var cursorIn = xIn && yIn;

        if (cursorIn) {
          cursorIn = this.moveTarget === this.area;
        }

        if (cursorIn) {
          this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
          this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

          if (!this.cursorIsVisible) {
            this.cursorIsVisible = true;
            this.cursor.x.curr = this.cursor.x.targ;
            this.cursor.y.curr = this.cursor.y.targ;
            this.cursorShow.play();
            this.cursorScale.play();
          }
        } else if (!cursorIn && this.cursorIsVisible) {
          this.cursorIsVisible = false;
          this.cursorShow.play({
            reverse: true
          });
          this.cursorScale.play({
            reverse: true
          });
        }

        var cursorXMoving = r.R(this.cursor.x.curr) !== this.cursor.x.targ;
        var cursorYMoving = r.R(this.cursor.y.curr) !== this.cursor.y.targ;
        var cursorMoving = cursorXMoving || cursorYMoving;

        if (cursorMoving || cursorIn) {
          this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
          this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
          r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
        }
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }]);

    return StickyCursor;
  }();

  var MaterialFeatures =
  /*#__PURE__*/
  function () {
    function MaterialFeatures(element) {
      var _this = this;

      _classCallCheck(this, MaterialFeatures);

      this.c = _C;
      this.liC = 'material-features-li';
      this.li = r.G["class"](this.liC, element);
      this.liL = this.li.length;
      this.noCursor = this.liL < 1 || this.c.isMobile;
      if (this.noCursor) return;
      this.imgHide = [];
      var img = r.G["class"](this.liC + '-img', element);

      for (var i = 0; i < this.liL; i++) {
        this.imgHide[i] = new r.M({
          el: img[i],
          p: {
            opacity: [1, 0.3]
          },
          d: 300,
          e: 'linear'
        });
      }

      this.txtShow = [];
      var txt = r.G["class"](this.liC + '-txt', element);

      for (var _i = 0; _i < this.liL; _i++) {
        this.txtShow[_i] = new r.M({
          el: txt[_i],
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
      }

      this.stickyCursor = [];

      for (var _i2 = 0; _i2 < this.liL; _i2++) {
        this.stickyCursor[_i2] = new StickyCursor({
          area: this.li[_i2]
        });
      }

      r.BM(this, ['over']);
      setTimeout(function (_) {
        return _this.resize();
      }, 500);
      setTimeout(function (_) {
        return _this.resize();
      }, 1500);
      setTimeout(function (_) {
        return _this.resize();
      }, 5000);
    }

    _createClass(MaterialFeatures, [{
      key: "on",
      value: function on() {
        if (this.noCursor) return;
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noCursor) return;
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L('.' + this.liC, a, 'mouseenter', this.over);
        r.L('.' + this.liC, a, 'mouseleave', this.over);
      }
    }, {
      key: "over",
      value: function over(e) {
        var index = r.Index["class"](e.target, this.liC);
        var reverse = e.type === 'mouseleave' ? {
          reverse: true
        } : false;

        for (var i = 0; i < this.liL; i++) {
          if (i !== index) {
            this.imgHide[i].play(reverse);
          }
        }

        this.txtShow[index].play(reverse);
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.noCursor) return;

        for (var i = 0; i < this.liL; i++) {
          this.stickyCursor[i].resize();
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (this.noCursor) return;

        for (var i = 0; i < this.liL; i++) {
          this.stickyCursor[i].move(x, y, target);
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.noCursor) return;

        for (var i = 0; i < this.liL; i++) {
          this.stickyCursor[i].loop();
        }
      }
    }]);

    return MaterialFeatures;
  }();

  var SimpleProductBuy =
  /*#__PURE__*/
  function () {
    function SimpleProductBuy(element) {
      var _this = this;

      _classCallCheck(this, SimpleProductBuy);

      this.c = _C;
      this.onReviewsLoaded = this.onReviewsLoaded.bind(this);
      this.onReviewsClick = this.onReviewsClick.bind(this);
      this.onColorChange = this.onColorChange.bind(this);
      this.onSelectChange = this.onSelectChange.bind(this);
      this.addToBag = this.addToBag.bind(this);
      this.videoClick = this.videoClick.bind(this);
      this.onBackorderClick = this.onBackorderClick.bind(this);
      var colorHolder = r.G["class"]('configurator-left-options-color', element)[0];
      this.colors = colorHolder ? colorHolder.children : [];
      this.images = [];

      for (var i = 0; i < this.colors.length; i++) {
        this.colors[i].addEventListener('click', this.onColorChange);
      }

      this.variantSelects = r.G.tag('select', element);

      for (var _i = 0; _i < this.variantSelects.length; _i++) {
        this.variantSelects[_i].addEventListener('change', this.onSelectChange);
      }

      this.currentVariant = JSON.parse(element.dataset.variant);
      var optionData = JSON.parse(element.dataset.options || '[]');
      var options = optionData.map(function (o) {
        return o.name;
      });

      if (element.dataset.umbrellaSubProducts) {
        var subProducts = JSON.parse(element.dataset.umbrellaSubProducts);
        var variantsObj = {};
        var subProductHandles = [];
        subProducts.forEach(function (subProduct, index) {
          var dataHandle = subProduct.product.handle.replace(/-/g, '_');
          subProductHandles.push(dataHandle);
          var vv1 = subProduct.variantValue1;
          variantsObj[vv1] = variantsObj[vv1] || {};
          var vv2 = subProduct.variantValue2;
          var additionalLevels = vv2 && vv2.length ? 2 : 1;

          var nativeVariantsObj = _this.buildVariantsObj(JSON.parse(element.dataset[dataHandle]), vv1, vv2);

          if (vv2 && vv2.length) {
            variantsObj[vv1][vv2] = nativeVariantsObj;

            if (index === 0) {
              options.unshift(subProduct.variantOption2);
              options.unshift(subProduct.variantOption1);
            }
          } else {
            variantsObj[vv1] = nativeVariantsObj;
            if (index === 0) options.unshift(subProduct.variantOption1);
          }
        });
        this.variants = variantsObj;
      } else {
        var variantData = JSON.parse(element.dataset.variants);
        this.variants = this.buildVariantsObj(variantData);
      }

      this.variantOptionSet = [];

      for (var _i2 = 0; _i2 < options.length; _i2++) {
        this.variantOptionSet.push(options[_i2] === 'Color');
      }

      var productName = element.dataset.productName;
      this.productName = productName;
      this.productId = element.dataset.productId;
      var productLightboxDescription = element.dataset.lightboxDescription;
      var heroIsFullHeight = JSON.parse(element.dataset.heroIsFullHeight).heroIsFullHeight;
      this.images = this.images.map(function (i) {
        return {
          url: i,
          isFullHeight: heroIsFullHeight,
          title: productName,
          description: productLightboxDescription
        };
      });
      var productDetailImages = JSON.parse(element.dataset.productDetailImages).images;
      this.images = this.images.concat(productDetailImages.filter(function (i) {
        return i.desktopProductImage;
      }).map(function (i) {
        return {
          url: i.desktopProductImage.url.replace(_this.c.s3Domain, _this.c.cloudFrontDomain),
          isFullHeight: i.isFullHeight,
          title: productName,
          description: i.lightboxDescription
        };
      }));
      this.populateLightbox();
      this.addToBagButton = r.G["class"]('btn-add', element)[0];
      this.addToBagButton.addEventListener('click', this.addToBag);
      this.buyForm = r.G["class"]('shopify-product-form', element)[0];
      var isValid = this.checkIsValidVariant();
      this.checkIsAvailable(isValid);
      this.slider = new Slider1({
        parent: '.simple-product-left',
        element: element
      });
      this.variantHeroLi = r.G["class"]('product-detail-image', element)[0];
      this.priceElement = r.G["class"]('simple-product-right-price', element)[0];
      this.video = r.G["class"]('video-click', element)[0];
      if (this.video) this.video.addEventListener('click', this.videoClick);
      this.rating = r.G["class"]('configurator-left-rating', element)[0];
      this.rating.addEventListener('click', this.onReviewsClick);
      window.addEventListener('reviewsloaded', this.onReviewsLoaded);
      this.backorderCta = r.G["class"]('backorder-cta', element)[0];
      if (this.backorderCta) this.backorderCta.addEventListener('click', this.onBackorderClick);
    }

    _createClass(SimpleProductBuy, [{
      key: "deinit",
      value: function deinit() {
        for (var i = 0; i < this.colors.length; i++) {
          this.colors[i].removeEventListener('click', this.onColorChange);
        }

        for (var _i3 = 0; _i3 < this.variantSelects.length; _i3++) {
          this.variantSelects[_i3].removeEventListener('change', this.onSelectChange);
        }

        this.addToBagButton.removeEventListener('click', this.addToBag);
        if (this.video) this.video.removeEventListener('click', this.videoClick);
        window.removeEventListener('reviewsloaded', this.onReviewsLoaded);
        this.rating.removeEventListener('click', this.onReviewsClick);
        if (this.backorderCta) this.backorderCta.removeEventListener('click', this.onBackorderClick);
      } //
      // ARI LIFECYCLE
      //

    }, {
      key: "on",
      value: function on() {
        this.slider.on();
      }
    }, {
      key: "off",
      value: function off() {
        this.slider.off();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.slider.resize();
      }
    }, {
      key: "loop",
      value: function loop() {
        if (!this.c.isTouch) {
          this.slider.loop();
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.slider.move(x, y, target);
      } //
      // LISTENERS
      //

    }, {
      key: "onReviewsLoaded",
      value: function onReviewsLoaded(e) {
        if (e.detail.count > 0) {
          var qty = r.G["class"]('configurator-left-rating-qty', this.rating)[0];
          qty.innerHTML = '(' + e.detail.count + ')';
          var stars = r.G["class"]('stars-color')[0];
          var averageRating = e.detail.averageRating;
          if (averageRating > 0.25) stars.classList.remove('stars-color-0');

          if (averageRating > 4.75) {
            stars.classList.add('stars-color-5');
          } else if (averageRating > 4.25) {
            stars.classList.add('stars-color-4-5');
          } else if (averageRating > 3.75) {
            stars.classList.add('stars-color-4');
          } else if (averageRating > 3.25) {
            stars.classList.add('stars-color-3-5');
          } else if (averageRating > 2.75) {
            stars.classList.add('stars-color-3');
          } else if (averageRating > 2.25) {
            stars.classList.add('stars-color-2-5');
          } else if (averageRating > 1.75) {
            stars.classList.add('stars-color-2');
          } else if (averageRating > 1.25) {
            stars.classList.add('stars-color-1-5');
          } else if (averageRating > 0.75) {
            stars.classList.add('stars-color-1');
          } else if (averageRating > 0.25) {
            stars.classList.add('stars-color-0-5');
          }

          this.rating.classList.remove('hidden');
        }
      }
    }, {
      key: "onReviewsClick",
      value: function onReviewsClick(e) {
        var reviews = r.G["class"]('reviews-questions-w')[0];

        if (reviews) {
          var y = reviews.getBoundingClientRect().top + pageYOffset;
          this.c.smoothScroll.scrollToY(y, true);
        }
      }
    }, {
      key: "onColorChange",
      value: function onColorChange(e) {
        for (var i = 0; i < this.colors.length; i++) {
          this.colors[i].classList.remove('active');
        }

        e.target.classList.add('active');
        this.changeVariant(e.target.dataset.value, e.target.dataset.optionLevel);
      }
    }, {
      key: "onSelectChange",
      value: function onSelectChange(e) {
        var parent = e.target.parentNode;
        r.G.tag('span', parent)[0].innerHTML = e.target.value;

        if (e.target.selectedIndex === 0) {
          this.variantOptionSet[e.target.dataset.optionLevel] = false;
          this.checkIsValidVariant();
          return;
        }

        this.changeVariant(e.target.value, e.target.dataset.optionLevel);
      }
    }, {
      key: "addToBag",
      value: function addToBag(e) {
        var _this2 = this;

        e.preventDefault();
        this.addToBagButton.classList.add('submitting');
        var data = {
          quantity: 1,
          id: this.currentVariant.id
        };
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          var oldQty = _C.cart.variants[_this2.currentVariant.id] || 0;
          r.G["class"]('num-added', _this2.addToBagButton)[0].innerHTML = oldQty + 1;

          _this2.addToBagButton.classList.add('submitted');

          _this2.addToBagButton.classList.remove('submitting');

          setTimeout(function (_) {
            return _this2.addToBagButton.classList.remove('submitted');
          }, 3000);

          _C.cart.refresh();

          return res.json();
        }).then(function (response) {
          return console.log('Success:', JSON.stringify(response));
        })["catch"](function (error) {
          return console.error('Error:', error);
        });

        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            content_name: this.productName,
            // content_category: 'Apparel & Accessories > Shoes',
            // content_ids: ['shopify_' + this.productId + '_' + this.currentVariant.id],
            content_category: 'Travel',
            content_ids: [this.productId],
            content_type: 'product',
            value: (this.currentVariant.price / 100).toFixed(2),
            currency: 'USD'
          });
        }
      }
    }, {
      key: "videoClick",
      value: function videoClick() {
        var video = r.G.id('simple-product-video');
        var src = video.children[0].src;
        this.c.videoLightbox.populateSource(src);
        this.c.videoLightbox.open();
      }
    }, {
      key: "onBackorderClick",
      value: function onBackorderClick() {
        var description = JSON.parse(this.backorderCta.dataset.description);
        this.c.textModal.populate(description.title, description.body);
        this.c.textModal.open();
      } //
      // DATA MUTATION
      //

    }, {
      key: "buildVariantsObj",
      value: function buildVariantsObj(variantData, addValue1, addValue2) {
        var _this3 = this;

        var variantsObj = {};
        variantData.forEach(function (variant) {
          var featuredImage = variant.featured_image ? variant.featured_image.src : undefined;

          if (!_this3.images.includes(featuredImage)) {
            _this3.images.push(featuredImage);
          }

          var modifiedVariant = _this3.modifyVariant(variant, addValue1, addValue2);

          if (variant.option1) {
            var vo1 = variant.option1;
            variantsObj[vo1] = variantsObj[vo1] || {};

            if (variant.option2) {
              var vo2 = variant.option2;
              variantsObj[vo1][vo2] = variantsObj[vo1][vo2] || {};

              if (variant.option3) {
                var vo3 = variant.option3;
                variantsObj[vo1][vo2][vo3] = modifiedVariant;
              } else {
                variantsObj[vo1][vo2] = modifiedVariant;
              }
            } else {
              variantsObj[vo1] = modifiedVariant;
            }
          }
        });
        return variantsObj;
      }
    }, {
      key: "modifyVariant",
      value: function modifyVariant(variant, addValue1, addValue2) {
        var modifiedVariant = Object.assign({}, variant);
        modifiedVariant.options = modifiedVariant.options.slice();

        if (addValue1 && addValue1.length) {
          if (addValue2 && addValue2.length) {
            modifiedVariant.option5 = modifiedVariant.option3;
            modifiedVariant.option4 = modifiedVariant.option2;
            modifiedVariant.option3 = modifiedVariant.option1;
            modifiedVariant.option2 = addValue2;
            modifiedVariant.option1 = addValue1;
            modifiedVariant.options.unshift(addValue1, addValue2);
          } else {
            modifiedVariant.option4 = modifiedVariant.option3;
            modifiedVariant.option3 = modifiedVariant.option2;
            modifiedVariant.option2 = modifiedVariant.option1;
            modifiedVariant.option1 = addValue1;
            modifiedVariant.options.unshift(addValue1);
          }
        }

        if (this.currentVariant.id === modifiedVariant.id) {
          this.currentVariant = modifiedVariant;
        }

        return modifiedVariant;
      }
    }, {
      key: "populateLightbox",
      value: function populateLightbox() {
        this.c.lightbox.isPackConfigurationLightbox = false;
        this.c.backendData.lightbox.simpleProduct = this.images;
      }
    }, {
      key: "changeVariant",
      value: function changeVariant(option, level) {
        this.variantOptionSet[level] = true;
        var options = this.currentVariant.options.slice();
        options[level] = option;

        if (this.currentVariant.option5) {
          this.currentVariant = this.variants[options[0]][options[1]][options[2]][options[3]][options[4]];
        } else if (this.currentVariant.option4) {
          this.currentVariant = this.variants[options[0]][options[1]][options[2]][options[3]];
        } else if (this.currentVariant.option3) {
          this.currentVariant = this.variants[options[0]][options[1]][options[2]];
        } else if (this.currentVariant.option2) {
          this.currentVariant = this.variants[options[0]][options[1]];
        } else if (this.currentVariant.option1) {
          this.currentVariant = this.variants[options[0]];
        }

        var price = '$' + this.currentVariant.price / 100;
        if (price.split('.').length !== 2) price += '.00';
        var currentPrice = r.G["class"]('current-price', this.priceElement);
        currentPrice.innerHTML = price;

        if (this.currentVariant.compare_at_price !== this.currentVariant.price && this.currentVariant.compare_at_price > 0) {
          var comparePrice = '$' + this.currentVariant.compare_at_price / 100;
          if (comparePrice.split('.').length !== 2) comparePrice += '.00';
          var comparePriceEl = r.G["class"]('discounted-from', this.priceElement);
          comparePriceEl.innerHTML = comparePrice;
        }

        r.G.id('hidden-variant-id').value = this.currentVariant.id;
        var isValid = this.checkIsValidVariant();
        this.checkIsAvailable(isValid);
        this.changeVariantHero();
      }
    }, {
      key: "changeVariantHero",
      value: function changeVariantHero() {
        var currentHeroImg = this.variantHeroLi.lastElementChild;
        if (currentHeroImg.src === this.currentVariant.featured_image.src) return;

        if (currentHeroImg.classList.contains('no-object-fit')) {
          if (currentHeroImg.style.backgroundImage.indexOf(this.currentVariant.featured_image.src) > -1) {
            return;
          }
        }

        var img = document.createElement('img');
        img.src = this.currentVariant.featured_image.src;
        var supportsObjectFit = 'objectFit' in document.documentElement.style;

        if (!supportsObjectFit) {
          if (!img.classList.contains('no-object-fit')) {
            img.classList.add('no-object-fit');
            img.style.backgroundImage = "url(".concat(img.src, ")");
            img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            img.style.backgroundPosition = 'center';
            img.style.backgroundRepeat = 'no-repeat';
            img.style.backgroundSize = 'contain';
          }
        }

        img.classList.add('fade-in');
        currentHeroImg.classList.add('fade-out');

        if (this.currentVariant.featured_image.alt) {
          img.alt = this.currentVariant.featured_image.alt;
        }

        this.variantHeroLi.appendChild(img);
        img.addEventListener('animationend', function () {
          img.classList.remove('fade-in');
          if (currentHeroImg.parentNode) currentHeroImg.parentNode.removeChild(currentHeroImg);
          img.removeEventListener('animationend', function () {}, false);
        }, false);

        if (this.slider.no !== 0) {
          this.slider.slideToIndex(0);
        }
      }
    }, {
      key: "checkIsValidVariant",
      value: function checkIsValidVariant() {
        if (!this.variantOptionSet.includes(false)) {
          this.addToBagButton.classList.remove('disabled');
          this.buyForm.classList.remove('disabled');
          return true;
        } else {
          this.addToBagButton.classList.add('disabled');
          this.buyForm.classList.add('disabled');
          return false;
        }
      }
    }, {
      key: "checkIsAvailable",
      value: function checkIsAvailable(isValid) {
        var buttonText = r.G["class"]('btn-text', this.addToBagButton);
        var cta;

        if (this.currentVariant.available || !isValid) {
          cta = 'Add to Bag';
        } else {
          cta = 'Not available';
          this.addToBagButton.classList.add('disabled');
          this.buyForm.classList.add('disabled');
        }

        if (buttonText[0].innerHTML !== cta) {
          for (var i = 0; i < buttonText.length; i++) {
            buttonText[i].innerHTML = cta;
          }
        }
      }
    }]);

    return SimpleProductBuy;
  }();

  var EditorialCopy = function EditorialCopy(element) {
    _classCallCheck(this, EditorialCopy);

    var copyBodyList = document.getElementsByClassName('editorial-copy-body');
    var copyBodyListElements = Array.from(copyBodyList);
    copyBodyListElements.forEach(function (element) {
      var rawElement = element;
      var modifiedElement = marked(rawElement.innerHTML);
      rawElement.innerHTML = modifiedElement;
    });
  };

  function debounce$1 (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  var GlobalCart =
  /*#__PURE__*/
  function () {
    function GlobalCart() {
      _classCallCheck(this, GlobalCart);

      this.c = _C;
      this.minusOne = this.minusOne.bind(this);
      this.plusOne = this.plusOne.bind(this);
      this.inputBlur = this.inputBlur.bind(this);
      this.buildVariantsObj = this.buildVariantsObj.bind(this);
      this.refreshSidebar = debounce$1(this.refreshSidebar, 250);
      this.refreshIndicator = debounce$1(this.refreshIndicator, 250);
      this.buildVariantsObj();
      this.rollupLineItemDiscounts();
      this.addListeners();
      this.cart = r.G.id('cart');
    }

    _createClass(GlobalCart, [{
      key: "addListeners",
      value: function addListeners() {
        var cart = r.G.id('cart');
        var elements = r.G["class"]('cart-li-qty', cart);

        for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          r.G["class"]('cart-li-qty-minus', element)[0].addEventListener('click', this.minusOne);
          r.G["class"]('cart-li-qty-plus', element)[0].addEventListener('click', this.plusOne);
          r.G["class"]('cart-li-qty-no', element)[0].addEventListener('blur', this.inputBlur);
        }
      }
    }, {
      key: "removeListeners",
      value: function removeListeners() {
        var cart = r.G.id('cart');
        var elements = r.G["class"]('cart-li-qty', cart);

        for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          r.G["class"]('cart-li-qty-minus', element)[0].removeEventListener('click', this.minusOne);
          r.G["class"]('cart-li-qty-plus', element)[0].removeEventListener('click', this.plusOne);
          r.G["class"]('cart-li-qty-no', element)[0].removeEventListener('blur', this.inputBlur);
        }
      }
    }, {
      key: "plusOne",
      value: function plusOne(e) {
        e.preventDefault();
        var element = e.target.parentNode;
        var quantity = r.G["class"]('cart-li-qty-no', element)[0];
        var q = Math.min(parseInt(quantity.value) + 1, 999);
        quantity.value = q;

        this._cartUpdate(element.dataset.variant, q);
      }
    }, {
      key: "minusOne",
      value: function minusOne(e) {
        e.preventDefault();
        var element = e.target.parentNode;
        var quantity = r.G["class"]('cart-li-qty-no', element)[0];
        var q = Math.max(parseInt(quantity.value) - 1, 0);
        quantity.value = q;

        this._cartUpdate(element.dataset.variant, q);
      }
    }, {
      key: "inputBlur",
      value: function inputBlur(e) {
        console.log(e);
        var element = e.target.parentNode;
        var quantity = e.target;
        var q = Math.min(Math.max(parseInt(quantity.value), 0), 999);
        quantity.value = q;

        this._cartUpdate(element.dataset.variant, q);
      }
    }, {
      key: "_cartUpdate",
      value: function _cartUpdate(id, quantity) {
        var _this = this;

        r.G.id('cart-w').classList.add('updating');
        var updates = {};
        updates[id] = quantity; // console.log(JSON.stringify({updates}))

        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates: updates
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          _this.refreshSidebar();

          return res.json();
        }).then(function (response) {
          _C.topNav.updateCartCount(response.item_count);

          if (response.item_count === 0) {
            _this.cart.classList.add('empty-cart');
          }
        })["catch"](function (error) {
          return console.error('Error:', error);
        });
      }
    }, {
      key: "refresh",
      value: function refresh() {
        this.refreshSidebar();
        this.refreshIndicator();
      }
    }, {
      key: "refreshSidebar",
      value: function refreshSidebar() {
        var _this2 = this;

        this.latestDate = new Date();
        var xhr = new XMLHttpRequest();
        xhr.date = this.latestDate;
        xhr.open('GET', '/cart', true);
        xhr.responseType = 'document';

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (_this2.latestDate !== xhr.date) return;
            var r$1 = xhr.response;
            var close = r.G["class"]('sidebar-close', r.G.id('cart-w'))[0];
            var parent = close ? close.parentNode : r.G.id('cart-standalone');
            var cart = r.G.id('cart', r$1) || r.G.id('cart-standalone', r$1);
            var xhrContent = cart.children;

            _this2.removeListeners();

            Array.from(parent.children).forEach(function (child) {
              if (child !== close) {
                parent.removeChild(child);
              }
            });
            Array.from(xhrContent).forEach(function (child, index) {
              if (child.classList) {
                if (!child.classList.contains('sidebar-close')) {
                  parent.appendChild(child);
                }
              } else if (index !== 0) {
                parent.appendChild(child);
              }
            });

            _this2.buildVariantsObj();

            _this2.rollupLineItemDiscounts();

            _this2.addListeners();

            if (window.presentAfterpay && window.afterpayCartConfig) {
              new window.presentAfterpay(window.afterpayCartConfig).init(); // eslint-disable-line new-cap
            }

            r.G.id('cart-w').classList.remove('updating');
          }
        };

        xhr.send(null);
      }
    }, {
      key: "refreshIndicator",
      value: function refreshIndicator() {
        var _this3 = this;

        fetch('/cart.js').then(function (res) {
          return res.json();
        }).then(function (response) {
          _C.topNav.updateCartCount(response.item_count);

          if (response.item_count > 0) {
            _this3.cart.classList.remove('empty-cart');
          }
        })["catch"](function (error) {
          return console.error('Error:', error);
        });
      }
    }, {
      key: "rollupLineItemDiscounts",
      value: function rollupLineItemDiscounts() {
        var lineItemDiscounts = r.G["class"]('cart-li-discount');
        if (lineItemDiscounts.length === 0) return;
        var matching = true;
        var prevString = lineItemDiscounts[0].innerHTML;

        for (var i = 1; i < lineItemDiscounts.length; i++) {
          var currentString = lineItemDiscounts[i].innerHTML;
          matching = matching && prevString === currentString;
          prevString = currentString;
        }

        if (matching) {
          for (var _i = lineItemDiscounts.length - 1; _i >= 0; _i--) {
            lineItemDiscounts[_i].parentNode.removeChild(lineItemDiscounts[_i]);
          }

          r.G.id('cart-extra').innerHTML = prevString;
        }
      }
    }, {
      key: "buildVariantsObj",
      value: function buildVariantsObj() {
        this.variants = {};
        var cart = r.G.id('cart');
        var qtyElements = r.G["class"]('cart-li-qty', cart);

        for (var i = 0; i < qtyElements.length; i++) {
          var qtyEl = qtyElements[i];
          var input = r.G["class"]('cart-li-qty-no')[0];
          this.variants[qtyEl.dataset.variant] = parseInt(input.value);
        }
      }
    }]);

    return GlobalCart;
  }();

  var ShopSubmenu =
  /*#__PURE__*/
  function () {
    function ShopSubmenu(element) {
      _classCallCheck(this, ShopSubmenu);

      r.BM(this, ['fn']);
      this.open = false;
      this.shopW = element;
      this.subW = element.getElementsByTagName('ul')[0];
    }

    _createClass(ShopSubmenu, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "fn",
      value: function fn(e) {
        var action = e.type === 'mouseenter' ? 'add' : 'remove';
        this.shopW.classList[action]('open');

        if (action === 'add') {
          this.shopW.style.height = this.subW.offsetTop + this.subW.offsetHeight + 'px';
        } else {
          this.shopW.style.height = 'auto';
        }
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.shopW, a, 'mouseenter', this.fn);
        r.L(this.shopW, a, 'mouseleave', this.fn);
      }
    }]);

    return ShopSubmenu;
  }();

  var TopNav =
  /*#__PURE__*/
  function () {
    function TopNav() {
      var _this = this;

      _classCallCheck(this, TopNav);

      this.c = _C;
      this.subnavs = [];
      var links = Array.from(document.getElementsByClassName('top-nav-link-shop-w'));
      links.forEach(function (link) {
        if (link.getElementsByTagName('ul').length) {
          _this.subnavs.push(new ShopSubmenu(link));
        }
      });
    }

    _createClass(TopNav, [{
      key: "on",
      value: function on() {
        this.subnavs.forEach(function (subnav) {
          subnav.on();
        });
      }
    }, {
      key: "off",
      value: function off() {
        this.subnavs.forEach(function (subnav) {
          subnav.off();
        });
      }
    }, {
      key: "updateCartCount",
      value: function updateCartCount(count) {
        var cartIndicator = r.G["class"]('top-nav-cart-indicator')[0];
        r.G.tag('div', cartIndicator)[0].innerHTML = count;

        if (count) {
          cartIndicator.classList.remove('hidden');
        } else {
          cartIndicator.classList.add('hidden');
        }
      }
    }]);

    return TopNav;
  }();

  var Addresses =
  /*#__PURE__*/
  function () {
    function Addresses(element, popinInstance) {
      var _this = this;

      _classCallCheck(this, Addresses);

      this.popinInstance = popinInstance;
      this.addressTitle = document.getElementById('edit-address-title');
      this.formElement = document.getElementById('address_form_new');
      this.formFields = document.getElementsByClassName('form-field-w');
      this.formFieldsArray = Array.from(this.formFields);
      this.firstName = document.getElementById('edit-address-form-firstname');
      this.lastName = document.getElementById('edit-address-form-lastname');
      this.address1 = document.getElementById('edit-address-form-address');
      this.address2 = document.getElementById('edit-address-form-address-optional');
      this.city = document.getElementById('edit-address-form-city');
      this.country = document.getElementById('address_country_new');
      this.province = document.getElementById('address_province_new');
      this.zip = document.getElementById('edit-address-form-zip');
      this.isDefault = document.getElementById('address_default_address_new');
      this.deleteFormElement = document.getElementsByClassName('address-delete-form')[0];
      this.deleteFormButton = document.getElementsByClassName('delete-button')[0];
      this.confirmDeleteContainer = document.getElementsByClassName('confirm-delete')[0];
      this.contactAccountFields = document.getElementsByClassName('contact-field');
      this.contactAccountFieldsArray = Array.from(this.contactAccountFields);
      this.contactAccountFieldsArray.forEach(function (field) {
        field.classList.add('complete');
      });
      this.deleteThisAddressButton = document.getElementsByClassName('delete-button')[0];
      r.L(this.deleteThisAddressButton, 'a', 'click', function () {
        _this.onDeleteThisAddressClick();
      });
      this.formCancelButton = document.getElementsByClassName('form-cancel')[0];
      r.L(this.formCancelButton, 'a', 'click', function () {
        _this.handleFormCancel();
      });
      r.BM(this, ['handleFormSubmit', 'handleFormDelete', 'handleFormCancel']);
      r.L(this.country, 'a', 'change', function () {
        var selection = _this.country.selectedOptions[0];

        _this.onCountrySelectionChange(selection);
      });
      this.isEdit = null;
      this.toggleAddressClickListeners(true);
    }

    _createClass(Addresses, [{
      key: "deinit",
      value: function deinit() {
        this.toggleAddressClickListeners(false);
      }
    }, {
      key: "toggleAddressClickListeners",
      value: function toggleAddressClickListeners(add) {
        var _this2 = this;

        var addressesArray = Array.from(document.getElementsByClassName('credit-card'));
        addressesArray.forEach(function (address) {
          if (address.dataset.id) {
            r.L(address, add ? 'a' : 'r', 'click', function () {
              _this2.showEditAddressForm(address);
            });
          } else {
            r.L(address, add ? 'a' : 'r', 'click', function () {
              _this2.showAddAddressForm();
            });
          }
        });
      }
    }, {
      key: "on",
      value: function on() {
        if (this.formElement) {
          this.formElement.addEventListener('submit', this.handleFormSubmit);
        }

        if (this.deleteFormElement) {
          this.deleteFormElement.addEventListener('submit', this.handleFormDelete);
        }
      }
    }, {
      key: "off",
      value: function off() {
        if (this.formElement) {
          this.formElement.removeEventListener('submit', this.handleFormSubmit);
        }

        if (this.deleteFormElement) {
          this.deleteFormElement.addEventListener('submit', this.handleFormDelete);
        }
      }
    }, {
      key: "onCountrySelectionChange",
      value: function onCountrySelectionChange(countryOptionElement) {
        var _this3 = this;

        this.province.innerHTML = '';
        var provincesDataset = JSON.parse(countryOptionElement.dataset.provinces);
        var provincesArray = Array.from(provincesDataset);
        provincesArray.forEach(function (province) {
          var provinceOptionEl = document.createElement('option');
          provinceOptionEl.value = province[0];
          provinceOptionEl.innerHTML = province[1];

          _this3.province.append(provinceOptionEl);
        });
      }
    }, {
      key: "showEditAddressForm",
      value: function showEditAddressForm(address) {
        this.isEdit = true;
        var data = JSON.parse(address.dataset.address);
        this.addressTitle.innerHTML = 'Edit <br/>Address';
        this.formElement.id = "address_form_".concat(data.id);
        this.formElement.action = "/account/addresses/".concat(data.id);
        this.formElement.dataset.id = data.id;
        this.editInput = document.createElement('input');
        this.editInput.type = 'hidden';
        this.editInput.name = '_method';
        this.editInput.value = 'put';
        this.formElement.append(this.editInput);
        this.formFieldsArray.forEach(function (field) {
          field.classList.add('complete');
        });
        this.firstName.value = data.first_name ? "".concat(data.first_name) : '';
        this.lastName.value = data.last_name ? "".concat(data.last_name) : '';
        this.address1.value = data.address1 ? "".concat(data.address1) : '';
        this.address2.value = data.address2 ? "".concat(data.address2) : '';
        this.city.value = data.city ? "".concat(data.city) : '';
        this.country.value = data.country ? "".concat(data.country) : '';
        this.isDefault.checked = address.dataset.isDefault === 'true'; // Needs to happen after country value is set and before province is set.

        this.onCountrySelectionChange(this.country.selectedOptions[0]);
        this.province.value = "".concat(data.province);
        this.zip.value = "".concat(data.zip);
        this.deleteFormElement.action = "/account/addresses/".concat(data.id);
        this.deleteFormElement.dataset.id = data.id;
        this.handleFormCancel();
      }
    }, {
      key: "showAddAddressForm",
      value: function showAddAddressForm() {
        this.isEdit = false;
        this.addressTitle.innerHTML = 'Add <br/>Address';
        this.formElement.id = 'address_form_new';
        this.formElement.action = '/account/addresses/';
        this.formFieldsArray.forEach(function (field) {
          field.classList.remove('complete');
        });
        this.firstName.value = '';
        this.lastName.value = '';
        this.address1.value = '';
        this.address2.value = '';
        this.city.value = '';
        this.country.value = '';
        this.province.value = '';
        this.zip.value = '';
        this.isDefault.checked = false;
        this.deleteThisAddressButton.style.display = 'none';
      }
    }, {
      key: "handleFormSubmit",
      value: function handleFormSubmit(e) {
        var _this4 = this;

        e.preventDefault();
        var form = e.target;
        var params = '';
        var inputs = r.G.tag('input', form);

        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];

          if (input.value) {
            if (params.length) {
              params += '&';
            }

            params += input.name + '=' + input.value;
          }
        }

        var selects = r.G.tag('select', form);

        for (var _i = 0; _i < selects.length; _i++) {
          var select = selects[_i];

          if (select.value) {
            if (params.length) {
              params += '&';
            }

            params += select.name + '=' + select.value;
          }
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', form.action, true);
        xhr.responseType = 'document';
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = xhr.response;
            var addressCards = response.getElementsByClassName('address-card');
            console.log(addressCards);

            _this4.updateAddressCards(addressCards);
          }
        };

        xhr.send(params);
      }
    }, {
      key: "onDeleteThisAddressClick",
      value: function onDeleteThisAddressClick() {
        this.deleteThisAddressButton.style.display = 'none';
        this.confirmDeleteContainer.style.display = 'flex';
      }
    }, {
      key: "handleFormDelete",
      value: function handleFormDelete(e) {
        var _this5 = this;

        e.preventDefault();
        var form = e.target;
        var params = '';
        var inputs = r.G.tag('input', form);

        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];

          if (input.value) {
            if (params.length) {
              params += '&';
            }

            params += input.name + '=' + input.value;
          }
        }

        var selects = r.G.tag('select', form);

        for (var _i2 = 0; _i2 < selects.length; _i2++) {
          var select = selects[_i2];

          if (select.value) {
            if (params.length) {
              params += '&';
            }

            params += select.name + '=' + select.value;
          }
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', form.action, true);
        xhr.responseType = 'document';
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = xhr.response;
            var addressCards = response.getElementsByClassName('address-card');
            console.log(addressCards);

            _this5.updateAddressCards(addressCards);
          }
        };

        xhr.send(params);
      }
    }, {
      key: "updateAddressCards",
      value: function updateAddressCards(addressCards) {
        this.toggleAddressClickListeners(false);
        var holder = document.getElementById('address-card-list');
        var cards = Array.from(addressCards);
        holder.innerHTML = '';

        for (var i = 0; i < cards.length; i++) {
          holder.appendChild(cards[i]);
        }

        this.toggleAddressClickListeners(true);
        this.popinInstance.closeFn();
      }
    }, {
      key: "handleFormCancel",
      value: function handleFormCancel() {
        this.deleteThisAddressButton.style.display = 'block';
        this.confirmDeleteContainer.style.display = 'none';
      }
    }]);

    return Addresses;
  }();

  var AccountSettings =
  /*#__PURE__*/
  function () {
    function AccountSettings(element) {
      _classCallCheck(this, AccountSettings);

      r.BM(this, ['onFormSubmit', 'displaySentMessage']);
      var customerSettings = r.G["class"]('customer-info', element)[0];
      this.resetForm = r.G.tag('form', customerSettings)[0];
      this.resetMessage = r.G["class"]('reset-message', element)[0];
      this.resetMessage.classList.add('hidden');
      this.resetForm.addEventListener('submit', this.onFormSubmit);
    }

    _createClass(AccountSettings, [{
      key: "deinit",
      value: function deinit() {
        this.resetForm.removeEventListener('submit', this.onFormSubmit);
      }
    }, {
      key: "onFormSubmit",
      value: function onFormSubmit(e) {
        var _this = this;

        e.preventDefault();
        var form = e.target;
        var params = '';
        var inputs = r.G.tag('input', form);

        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];

          if (input.value) {
            if (params.length) {
              params += '&';
            }

            params += input.name + '=' + input.value;
          }
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', form.action, true);
        xhr.responseType = 'document';
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        xhr.onreadystatechange = function (_) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            _this.displaySentMessage();
          }
        };

        xhr.send(params);
      }
    }, {
      key: "displaySentMessage",
      value: function displaySentMessage() {
        this.resetMessage.innerHTML = 'Reset email sent; check your inbox';
        this.resetMessage.classList.remove('hidden');
      }
    }]);

    return AccountSettings;
  }();

  var Orders =
  /*#__PURE__*/
  function () {
    function Orders(element) {
      var _this = this;

      _classCallCheck(this, Orders);

      this.c = _C;
      this.element = element;
      var orders = r.G["class"]('order', element);

      var _loop = function _loop(i) {
        var order = orders[i];
        var trackingUrls = JSON.parse(order.dataset.trackingUrls).filter(function (u) {
          return u.length;
        });
        trackingUrls = trackingUrls.filter(function (u, index) {
          return trackingUrls.indexOf(u) === index;
        });

        if (trackingUrls.length > 1) {
          var existingLinks = r.G["class"]('track-order-link', order);
          var parent;
          var existing;

          if (existingLinks[0]) {
            parent = existingLinks[0].parentNode;
            existing = existingLinks[0];
          } else {
            parent = r.G["class"]('orders-nav-desktop', order)[0];
            existing = parent.children[Math.max(parent.children.length - 2, 0)];
          }

          for (var _i = trackingUrls.length - 1; _i >= 0; _i--) {
            var newLink = _this.createDesktopLink('Track Shipment ' + (_i + 1), trackingUrls[_i]);

            parent.insertBefore(newLink, existing);
          }

          if (existing === existingLinks[0]) {
            parent.removeChild(existing);
          }

          if (existingLinks[1]) {
            parent = existingLinks[1].parentNode;
            existing = existingLinks[1];
          } else {
            parent = r.G["class"]('orders-nav-mobile', order)[0];
            existing = parent.children[Math.max(parent.children.length - 2, 0)];
          }

          for (var _i2 = trackingUrls.length - 1; _i2 >= 0; _i2--) {
            var _newLink = _this.createMobileLink('Track Shipment ' + (_i2 + 1), trackingUrls[_i2]);

            parent.insertBefore(_newLink, existing);
          }

          if (existing === existingLinks[1]) {
            parent.removeChild(existing);
          }
        }
      };

      for (var i = 0; i < orders.length; i++) {
        _loop(i);
      }
    }

    _createClass(Orders, [{
      key: "createDesktopLink",
      value: function createDesktopLink(text, url) {
        var a = document.createElement('a');
        a.href = url;
        a.className = 'line-wrap track-order-link _tb';
        a.innerHTML = '<span>' + text + '<span class="line line-1 line-h1"><span></span><span></span></span></span>';
        return a;
      }
    }, {
      key: "createMobileLink",
      value: function createMobileLink(text, url) {
        var a = document.createElement('a');
        a.href = url;
        a.className = 'btn-w btn-grey _p track-order-link';
        var bg = document.createElement('span');
        bg.className = 'btn-bg';
        a.appendChild(bg);
        var btn = document.createElement('span');
        btn.className = 'btn';
        a.appendChild(btn);
        var btnAbs0 = document.createElement('span');
        btnAbs0.className = 'btn-abs';
        btnAbs0.innerHTML = '<span class="btn-over-0">' + text + '</span>';
        btn.appendChild(btnAbs0);
        var btnAbs1 = document.createElement('span');
        btnAbs1.className = 'btn-abs';
        btnAbs1.innerHTML = '<span class="btn-over-1">' + text + '</span>';
        btn.appendChild(btnAbs1);
        var btnAbs2 = document.createElement('span');
        btnAbs2.className = 'btn-abs';
        btnAbs2.innerHTML = '<span class="btn-curr-1">' + text + '</span>';
        btn.appendChild(btnAbs2);
        var btnRef = document.createElement('span');
        btnRef.className = 'btn-ref';
        btnRef.innerHTML = '<span class="btn-curr-0">' + text + '</span>';
        btn.appendChild(btnRef);
        return a;
      }
    }]);

    return Orders;
  }();

  var Rewards =
  /*#__PURE__*/
  function () {
    function Rewards(element) {
      _classCallCheck(this, Rewards);

      this.c = _C;
      this.element = element;
      r.BM(this, ['loop', 'setSmileValues']);
      this.smile = window.Smile;
      this.valuesSet = false;
      this.container = r.G["class"]('rewards', element)[0];
      this.mobileLogo = r.G["class"]('rewards-logo', element)[0];
      this.status = r.G.id('rewards-status');
      this.nextTierWrap = r.G.id('rewards-next-tier-w');
      this.nextTier = r.G.id('rewards-next-tier');
      this.lifeSpend = r.G.id('rewards-life-spend');
      this.dollarsToNextTier = r.G.id('rewards-dollars-to-next-tier');
      this.dollarsToNextTierWrap = r.G.id('rewards-dollars-to-next-tier-w');
      this.orders = r.G.id('rewards-orders');
      this.referrals = r.G.id('rewards-referrals');
      this.referrals.classList.add('hidden');
      this.progressWrap = r.G["class"]('rewards-activity-progress', element)[0];
      this.progressBar = r.G["class"]('rewards-activity-progress-bar', element)[0];
      this.progressText = r.G["class"]('rewards-activity-progress-txt', element)[0];
      this.progressAmounts = r.G["class"]('progress-amounts', this.progressText)[0];
      this.benefitsUl = r.G.tag('ul', r.G["class"]('rewards-benefits')[0])[0];
    }

    _createClass(Rewards, [{
      key: "on",
      value: function on() {}
    }, {
      key: "off",
      value: function off() {}
    }, {
      key: "loop",
      value: function loop() {
        if (!this.smile) {
          this.smile = window.Smile;
        }

        if (this.smile && this.smile.customer && !this.valuesSet) {
          this.setSmileValues();
        }
      }
    }, {
      key: "setSmileValues",
      value: function setSmileValues() {
        var _this = this;

        // console.log(this.smile.customer)
        var customer = this.smile.customer; // this.smile.fetchAllPointsProducts().then(r => console.log('fetchAllPointsProducts', r))
        // this.smile.fetchAllPointsPurchases().then(r => console.log('fetchAllPointsPurchases', r))
        // this.smile.fetchAllReferrals().then(r => console.log('fetchAllReferrals', r))
        // this.smile.fetchAllRewardFulfillments().then(r => console.log('fetchAllRewardFulfillments', r))
        // this.smile.fetchCustomer().then(r => console.log('fetchCustomer', r))

        /* this.smile.fetchPointsProduct().then(r => console.log('fetchPointsProduct', r))
        this.smile.fetchPointsPurchase().then(r => console.log('fetchPointsPurchase', r))
        this.smile.fetchReferral().then(r => console.log('fetchReferral', r))
        this.smile.fetchRewardFulfillment().then(r => console.log('fetchRewardFulfillment', r)) */
        // this.smile.fetchAllPointsPointsTransactions().then(r => console.log('fetchAllPointsPointsTransactions', r))

        /* this.smile.fetchPointsTransaction().then(r => console.log('fetchPointsTransaction', r)) */

        this.smile.fetchAllReferrals().then(function (r) {
          var referralsLength = r.length;

          if (referralsLength > 99) {
            _this.referrals.innerHTML = referralsLength;
          } else if (referralsLength > 9) {
            _this.referrals.innerHTML = '0' + referralsLength;
          } else {
            _this.referrals.innerHTML = '00' + referralsLength;
          }

          _this.referrals.classList.remove('hidden');
        });
        var vipData = this.getVipData(customer.vip_tier_id);
        var mobileImg = r.G.tag('img', this.mobileLogo)[0];
        mobileImg.src = mobileImg.dataset[vipData.name.toLowerCase()];
        var desktopImg = r.G.id('account-nav-badge');
        desktopImg.src = desktopImg.dataset[vipData.name.toLowerCase()];
        this.status.innerHTML = vipData.name;

        if (vipData.next) {
          this.nextTier.innerHTML = vipData.next;
          var toNext = r.G["class"]('next-tier', this.dollarsToNextTierWrap)[0];
          toNext.innerHTML = vipData.next;
          var progressNext = r.G["class"]('next-tier', this.progressText)[0];
          progressNext.innerHTML = vipData.next;
        } else {
          this.nextTierWrap.classList.add('hidden');
          this.dollarsToNextTierWrap.classList.add('hidden');
          this.progressWrap.classList.add('hidden');
        }

        this.lifeSpend.innerHTML = this.dollarString(customer.vip_metric);

        if (customer.delta_to_next_vip_tier) {
          var remaining = parseFloat(customer.delta_to_next_vip_tier);
          this.dollarsToNextTier.innerHTML = this.dollarString(remaining);

          if (vipData.nextValue) {
            var translate = Math.round(-100 * remaining / vipData.nextValue);
            this.progressBar.style.transform = "translate3d(".concat(translate, "%,0,0)");
            var progressAmount = Math.round(vipData.nextValue - remaining);
            var span1 = r.G.tag('span', this.progressAmounts)[0];
            span1.innerHTML = '$' + progressAmount;
            var span2 = r.G.tag('span', this.progressAmounts)[1];
            span2.innerHTML = '$' + Math.round(vipData.nextValue);
          }
        }

        vipData.rewards.forEach(function (reward) {
          _this.benefitsUl.appendChild(_this.makeRewardLi(reward));
        });
        this.valuesSet = true;
        this.container.classList.add('loaded');
      }
    }, {
      key: "dollarString",
      value: function dollarString(dollars) {
        var dollarComponents = "".concat(dollars).split('.');
        var displayDollars;

        if (dollarComponents[1]) {
          if (dollarComponents[1].length === 1) {
            displayDollars = dollarComponents[0] + '.' + dollarComponents[1] + '0';
          } else {
            displayDollars = dollarComponents[0] + '.' + dollarComponents[1];
          }
        } else {
          displayDollars = dollarComponents[0] + '.00';
        }

        return '$' + displayDollars;
      }
    }, {
      key: "getVipData",
      value: function getVipData(id) {
        switch (parseInt(id)) {
          case 10171:
          case 10256:
            return {
              name: 'Elite',
              rewards: ['free-shipping', 'free-returns', 'first-dibs', '10-off', 'birthday-gift']
            };

          case 10170:
          case 10255:
            return {
              name: 'Gold',
              next: 'Elite',
              nextValue: 1500,
              rewards: ['free-shipping', 'free-returns', 'first-dibs', '5-off']
            };

          case 10169:
          case 10254:
            return {
              name: 'VIP',
              next: 'Gold',
              nextValue: 1000,
              rewards: ['first-dibs', 'free-returns']
            };

          case 10168:
          case 10253:
          default:
            return {
              name: 'Member',
              next: 'VIP',
              nextValue: 500,
              rewards: ['locked']
            };
        }
      }
    }, {
      key: "makeRewardLi",
      value: function makeRewardLi(handle) {
        var li = document.createElement('li');
        var div1 = document.createElement('div');
        div1.className = 'rewards-benefits-li';
        li.appendChild(div1);
        var div2 = document.createElement('div');
        div2.className = 'rewards-benefits-svg';
        div1.appendChild(div2);
        var svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', this.getRewardSvgId(handle));
        svgElem.appendChild(useElem);
        div2.appendChild(svgElem);
        var div3 = document.createElement('div');
        div3.className = 'rewards-benefits-title';
        div3.innerHTML = this.getRewardText(handle);
        div1.appendChild(div3);
        return li;
      }
    }, {
      key: "getRewardText",
      value: function getRewardText(handle) {
        switch (handle) {
          case 'free-shipping':
            return 'Free Shipping';

          case 'first-dibs':
            return 'First Dibs';

          case 'free-returns':
            return 'Free Returns';

          case '10-off':
            return '10% Discount';

          case 'birthday-gift':
            return 'Birthday Gift';

          case '5-off':
            return '5% Discount';

          case 'locked':
            return 'Unlock at VIP';
        }
      }
    }, {
      key: "getRewardSvgId",
      value: function getRewardSvgId(handle) {
        switch (handle) {
          case 'free-shipping':
            return '#svg-rewards-free-shipping';

          case 'first-dibs':
            return '#svg-rewards-first-dibs';

          case 'free-returns':
            return '#svg-rewards-free-returns';

          case '10-off':
            return '#svg-rewards-10-off';

          case 'birthday-gift':
            return '#svg-rewards-birthday-gift';

          case '5-off':
            return '#svg-rewards-5-off';

          case 'locked':
            return '#svg-rewards-locked';
        }
      }
    }]);

    return Rewards;
  }();

  var AccountPage =
  /*#__PURE__*/
  function () {
    function AccountPage(element, popin) {
      _classCallCheck(this, AccountPage);

      this.c = _C;
      r.BM(this, ['subnavClick']);
      this.addresses = new Addresses(element, popin);
      this.accountSettings = new AccountSettings(element);
      this.orders = new Orders(element);
      this.rewards = new Rewards(element);
    }

    _createClass(AccountPage, [{
      key: "init",
      value: function init() {}
    }, {
      key: "deinit",
      value: function deinit() {
        this.addresses.deinit();
        this.accountSettings.deinit();
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
        this.addresses.on();
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
        this.addresses.off();
      }
    }, {
      key: "loop",
      value: function loop() {
        this.rewards.loop();
      }
    }, {
      key: "l",
      value: function l(a) {
        var subnav = r.G["class"]('subpage-nav')[0];
        var links = r.G.tag('a', subnav);

        for (var i = 0; i < links.length; i++) {
          r.L(links[i], a, 'click', this.subnavClick);
        }
      }
    }, {
      key: "subnavClick",
      value: function subnavClick(e) {
        if (e.target.href.replace(/^.*\/\/[^/]+/, '') === '/account/logout') {
          var mobileMenu = r.G.id('mobile-menu-link-w');
          var li = r.G["class"]('is-signed-in', mobileMenu)[0];

          if (li) {
            li.classList.remove('is-signed-in');
            li.classList.add('not-signed-in');
          }
        } else {
          var subnav = r.G["class"]('subpage-nav')[0];
          r.G["class"]('active', subnav)[0].classList.remove('active');
          e.target.classList.add('active');
          subnav.classList.remove('open');
          var subpageId = e.target.href.split('#')[1];
          var subpage = r.G.id(subpageId);
          r.G["class"]('active', subpage.parentNode)[0].classList.remove('active');
          subpage.classList.add('active');
          if (this.c.scroll) this.c.scroll.resize();
        }
      }
    }]);

    return AccountPage;
  }();

  var LazyLoader =
  /*#__PURE__*/
  function () {
    function LazyLoader(img) {
      _classCallCheck(this, LazyLoader);

      this.c = _C;
      this.img = img;
      this.load = this.load.bind(this);
      this.onload = this.onload.bind(this);
      this.img.onload = this.onload;
      this.img.classList.add('unloaded');
    }

    _createClass(LazyLoader, [{
      key: "load",
      value: function load(src) {
        var _this = this;

        requestAnimationFrame(function () {
          _this.img.src = src;
        });
      }
    }, {
      key: "onload",
      value: function onload() {
        this.img.classList.remove('unloaded');
      }
    }]);

    return LazyLoader;
  }();

  var BundleFlatlay =
  /*#__PURE__*/
  function () {
    function BundleFlatlay(element, masterDataset, callback) {
      _classCallCheck(this, BundleFlatlay);

      this.c = _C;
      this.element = element;
      this.masterDataset = masterDataset;
      this.callback = callback;
      this.handle = element.dataset.handle;
      this.bundleImages = {}; // this.onElementTransitionEnd = this.onElementTransitionEnd.bind(this)

      this.click = this.click.bind(this);
      this.area = r.G["class"]('bundle-interaction-area', this.element)[0];
      this.cursorIsVisible = false;
      this.x = -1;
      this.y = -1;
      this.cursor = {
        x: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        y: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        el: {}
      };
      this.cursor.el.main = r.G["class"]('slider-cursor', this.element)[0];
      this.cursor.el.center = r.G["class"]('slider-cursor-center', this.element)[0];
      this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.element)[0];
      this.cursorShow = new r.M({
        el: this.cursor.el.main,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorScale = new r.M({
        el: this.cursor.el.bg,
        p: {
          scale: [0.9, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorCenterShow = new r.M({
        el: this.cursor.el.center,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
    }

    _createClass(BundleFlatlay, [{
      key: "setBundle",
      value: function setBundle(bundle, color) {
        this.bundle = bundle;
        this.productImagery = {};
        if (!this.bundleImages[bundle.handle]) this.bundleImages[bundle.handle] = {};
        this.setColor(color);
      }
    }, {
      key: "setColor",
      value: function setColor(color) {
        var _this = this;

        if (!this.bundle) return;
        if (this.color === color) return;
        this.color = color;
        var existing = r.G["class"]('bundle-flatlay-w', this.element);

        for (var _i = 0; _i < existing.length; _i++) {
          var _el = existing[_i];

          if (!_el.classList.contains('transitioning-out')) {
            _el.addEventListener('transitionend', this.onElementTransitionEnd);

            _el.classList.add('transitioning-out');
          }
        } // populate new DOM elements


        var el = document.createElement('ul');
        el.className = 'bundle-flatlay-w';
        this.lazyLoaders = [];
        this.bundle.products.forEach(function (product) {
          var li = document.createElement('li');
          var img = document.createElement('img');
          li.appendChild(img);
          var ll = new LazyLoader(img);

          _this.lazyLoaders.push(ll);

          el.appendChild(li);
          _this.productImagery[product.id] = img;
        });
        this.element.appendChild(el); // load correct images

        if (!this.bundleImages[this.bundle.handle][color]) {
          this.bundleImages[this.bundle.handle][color] = {};
        }

        var imagesForColor = this.bundleImages[this.bundle.handle][color];

        for (var i = 0; i < this.bundle.products.length; i++) {
          var product = this.bundle.products[i];
          this.fetchData(product, color);

          if (imagesForColor[product.id]) {
            var src = imagesForColor[product.id];
            this.lazyLoaders[i].load(src);
          }
        }
      }
    }, {
      key: "setSelectedVariants",
      value: function setSelectedVariants(selectedVariants) {
        var _this2 = this;

        var oldVariantsIds = selectedVariants.map(function (v) {
          return v.id;
        });
        this.bundle.products.forEach(function (product) {
          var variantIndex = product.variants.findIndex(function (v) {
            return oldVariantsIds.includes(v.id);
          });
          var isAdded = variantIndex > -1;
          var imagery = _this2.productImagery[product.id];
          isAdded ? imagery.classList.remove('removed') : imagery.classList.add('removed');
          var color = _this2.color;

          if (variantIndex > -1) {
            var variant = product.variants[variantIndex];
            color = variant.color || _this2.color;

            _this2.fetchData(product, color);
          }

          var imagesForColor = _this2.bundleImages[_this2.bundle.handle][color];

          if (imagesForColor[product.id]) {
            _this2.productImagery[product.id].src = imagesForColor[product.id];
          }
        });
      }
    }, {
      key: "fetchData",
      value: function fetchData(product, color) {
        var _this3 = this;

        if (!this.bundleImages[this.bundle.handle][color]) {
          this.bundleImages[this.bundle.handle][color] = {};
        }

        var imagesForColor = this.bundleImages[this.bundle.handle][color];

        if (!imagesForColor[product.id]) {
          var variant = this.findVariantForColor(product, color);
          var metadata = this.masterDataset['metadata_' + variant.id];

          if (!metadata) {
            console.log('failed on', variant.id, product);
            return;
          }

          var data = JSON.parse(metadata);

          if (data) {
            var bundleMetadata = data.bundles.filter(function (bundle) {
              return bundle.handle === _this3.bundle.handle;
            })[0];

            if (bundleMetadata) {
              if (bundleMetadata.image && bundleMetadata.image.url) {
                imagesForColor[product.id] = bundleMetadata.image.url.replace(this.c.s3Domain, this.c.cloudFrontDomain);
              } else {
                console.log('! Missing image for', this.bundle.handle, product);
              }
            }
          }
        }
      }
    }, {
      key: "findVariantForColor",
      value: function findVariantForColor(product, color) {
        var firstVariant = product.variants[0];
        var options = firstVariant.options.slice();
        options[product.colorIndex] = color;
        var foundVariant = firstVariant;

        if (product.variantsByValue) {
          var obj = {};

          if (product.colorIndex === 0) {
            obj = product.variantsByValue[options[0]];
          } else if (product.colorIndex === 1) {
            obj = product.variantsByValue[options[0]][options[1]];
          } else if (product.colorIndex === 2) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]];
          } else if (product.colorIndex === 3) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]][options[3]];
          } else if (product.colorIndex === 4) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]][options[3]][options[4]];
          }

          if (obj) {
            while (obj && !obj.id) {
              obj = obj[Object.keys(obj)[0]];
            }

            foundVariant = obj;
          }
        }

        return foundVariant;
      }
    }, {
      key: "onElementTransitionEnd",
      value: function onElementTransitionEnd(e) {
        var el = e.target;
        el.removeEventListener('transitionend', this.onElementTransitionEnd);
        el.parentNode.removeChild(el);
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.area, a, 'click', this.click);
      }
    }, {
      key: "resize",
      value: function resize() {
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top;
        this.areaTop = areaRectTop + pageYOffset;
        this.areaLeft = areaRect.left;
        this.cursor.w = this.cursor.el.main.offsetWidth;
        this.cursor.wDemi = this.cursor.w / 2;
        this.cursor.x.max = this.area.offsetWidth;
        this.cursor.y.max = this.area.offsetHeight;
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y); // Check if over video

        var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
        var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
        var cursorIn = xIn && yIn;

        if (cursorIn) {
          cursorIn = !this.c.overPageIsOn;
        }

        if (cursorIn) {
          this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
          this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

          if (!this.cursorIsVisible) {
            this.cursorIsVisible = true;
            this.cursor.x.curr = this.cursor.x.targ;
            this.cursor.y.curr = this.cursor.y.targ;
            this.cursorShow.play();
            this.cursorScale.play();
            this.cursorCenterShow.play({
              d: 0
            });
          }
        } else if (!cursorIn && this.cursorIsVisible) {
          this.cursorIsVisible = false;
          this.cursorShow.play({
            reverse: true
          });
          this.cursorScale.play({
            reverse: true
          });
          this.cursorCenterShow.play({
            d: 0,
            reverse: true
          });
        }

        this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
        this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
        r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.moveDesktop(x, y, target);
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }, {
      key: "click",
      value: function click(e) {
        this.callback(e);
      }
    }]);

    return BundleFlatlay;
  }();

  var CustomBundleHero =
  /*#__PURE__*/
  function () {
    function CustomBundleHero(element, callback) {
      _classCallCheck(this, CustomBundleHero);

      this.c = _C;
      this.element = element;
      this.callback = callback;
      this.click = this.click.bind(this);
      this.variantHeroLi = r.G["class"]('product-detail-image', element)[0];
      var currentHeroImg = this.variantHeroLi.lastElementChild;
      this.imgSrc = currentHeroImg.src;
      this.area = r.G["class"]('custom-bundle-interaction-area', this.element)[0];
      this.cursorIsVisible = false;
      this.x = -1;
      this.y = -1;
      this.cursor = {
        x: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        y: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        el: {}
      };
      this.cursor.el.main = r.G["class"]('slider-cursor', this.element)[0];
      this.cursor.el.center = r.G["class"]('slider-cursor-center', this.element)[0];
      this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.element)[0];
      this.cursorShow = new r.M({
        el: this.cursor.el.main,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorScale = new r.M({
        el: this.cursor.el.bg,
        p: {
          scale: [0.9, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorCenterShow = new r.M({
        el: this.cursor.el.center,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
    }

    _createClass(CustomBundleHero, [{
      key: "showVariant",
      value: function showVariant(variant) {
        if (!variant.featured_image) return;
        var currentHeroImg = this.variantHeroLi.lastElementChild;
        if (currentHeroImg.src === variant.featured_image.src) return;
        var img = document.createElement('img');
        img.src = variant.featured_image.src;
        this.imgSrc = img.src;
        img.classList.add('fade-in');

        if (variant.featured_image.alt) {
          img.alt = variant.featured_image.alt;
        }

        img.addEventListener('animationend', function () {
          img.classList.remove('fade-in');
          if (currentHeroImg.parentNode) currentHeroImg.parentNode.removeChild(currentHeroImg);
        }, false);
        this.variantHeroLi.appendChild(img);
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (!this.c.isTouch) {
          r.L(this.area, a, 'click', this.click);
        } else {
          r.L(this.area, a, 'touchend', this.click);
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top;
        this.areaTop = areaRectTop + pageYOffset;
        this.areaLeft = areaRect.left;
        this.cursor.w = this.cursor.el.main.offsetWidth;
        this.cursor.wDemi = this.cursor.w / 2;
        this.cursor.x.max = this.area.offsetWidth;
        this.cursor.y.max = this.area.offsetHeight;
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y); // Check if over video

        var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
        var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
        var cursorIn = xIn && yIn;

        if (cursorIn) {
          cursorIn = !this.c.overPageIsOn;
        }

        if (cursorIn) {
          this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
          this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

          if (!this.cursorIsVisible) {
            this.cursorIsVisible = true;
            this.cursor.x.curr = this.cursor.x.targ;
            this.cursor.y.curr = this.cursor.y.targ;
            this.cursorShow.play();
            this.cursorScale.play();
            this.cursorCenterShow.play({
              d: 0
            });
          }
        } else if (!cursorIn && this.cursorIsVisible) {
          this.cursorIsVisible = false;
          this.cursorShow.play({
            reverse: true
          });
          this.cursorScale.play({
            reverse: true
          });
          this.cursorCenterShow.play({
            d: 0,
            reverse: true
          });
        }

        this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
        this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
        r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.moveDesktop(x, y, target);
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }, {
      key: "click",
      value: function click(e) {
        this.callback(e);
      }
    }]);

    return CustomBundleHero;
  }();

  var PackConfigurationMobile =
  /*#__PURE__*/
  function () {
    function PackConfigurationMobile(element, bundleCallBack) {
      _classCallCheck(this, PackConfigurationMobile);

      this.c = _C;
      this.element = element;
      this.bundleCallBack = bundleCallBack;
      r.BM(this, ['setTransformOffsets', 'resize', 'on', 'off', 'down', 'up', 'cb', 'click', 'populateBundle', 'mobileDesktopSlide']);
      this.customW = r.G["class"]('pack-config-custom-w', this.element)[0];
      this.noCustom = r.Is.und(this.customW);
      if (this.noCustom) return;
      this.bundleSlidesW = r.G["class"]('bundle-slide-w', this.element)[0];
      this.bundleSlides = r.G["class"]('bundle-slide', this.element);
      this.custom = r.G["class"]('pack-config-custom', this.element)[0];
      this.li = r.G["class"]('pack-config-custom-li', this.element);
      this.galleryCta = r.G["class"]('pack-config-mobile-gallery-cta', this.element)[0];
      this.name = r.G["class"]('pack-config-custom-bundle-name', this.element);
      this.price = r.G["class"]('pack-config-custom-bundle-price-w', this.element);
      this.accessoryW = r.G["class"]('pack-config-custom-accessory-w', this.element);
      this.swipe = r.G["class"]('pack-config-custom-mobile-swipe', this.element)[0];
      this.liL = this.li.length;
      this.limit = this.liL - 1;
      this.liX = [];
      this.bundleX = [];
      this.alreadySlided = false;
      this.swipeIsHidden = false;
      this.start = {
        x: 0,
        y: 0
      };
      this.isDown = false;
      this.index = 0;
      this.area = r.G["class"]('mobile-desktop-interaction-area', this.element)[0];
      this.areaCenter = r.G["class"]('mobile-desktop-interaction-area-center', this.element)[0]; // Cursor

      if (!this.c.isTouch) {
        this.cursorIsCenter = undefined;
        this.cursorIsVisible = false;
        this.x = -1;
        this.y = -1;
        this.cursor = {
          x: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          y: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          el: {}
        };
        this.cursor.el.main = r.G["class"]('slider-cursor', this.area)[0];
        this.cursor.el.arrow = r.G["class"]('slider-cursor-arrow-w', this.area)[0];
        this.cursor.el.center = r.G["class"]('slider-cursor-center', this.area)[0];
        this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.area)[0];
        this.cursorShow = new r.M({
          el: this.cursor.el.main,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorScale = new r.M({
          el: this.cursor.el.bg,
          p: {
            scale: [0.9, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorArrowShow = new r.M({
          el: this.cursor.el.arrow,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorCenterShow = new r.M({
          el: this.cursor.el.center,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.galleryCta.style.display = 'none';
      }
    }

    _createClass(PackConfigurationMobile, [{
      key: "on",
      value: function on() {
        if (this.noCustom) return;
        this.l('a');
        this.lClick('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (this.noCustom) return;
        this.l('r');
        this.lClick('r');
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.c.isMobile) {
          var areaRect = this.area.getBoundingClientRect();
          var areaRectTop = areaRect.top;

          if (!this.c.isTouch) {
            this.areaTop = areaRectTop + pageYOffset;
            this.areaLeft = areaRect.left;
            this.areaCenterLeft = this.areaCenter.getBoundingClientRect().left;
            this.areaCenterRight = this.areaCenterLeft + this.areaCenter.offsetWidth;
            this.cursor.w = this.cursor.el.main.offsetWidth;
            this.cursor.wDemi = this.cursor.w / 2;
            this.cursor.x.max = this.area.offsetWidth;
            this.cursor.y.max = this.area.offsetHeight;
          }

          this.liW = this.li[0].offsetWidth;
          this.bundleWidth = this.bundleSlides[0].offsetWidth;
          this.setTransformOffsets();
        } else {
          this.resetStyles();
        }
      }
    }, {
      key: "resetStyles",
      value: function resetStyles() {
        for (var i = 0; i < this.li.length; i++) {
          r.T(this.li[i], 0, 0, 'px');
        }

        for (var _i = 0; _i < this.bundleSlides.length; _i++) {
          r.T(this.bundleSlides[_i], 0, 0, 'px');
        }

        for (var _i2 = 0; _i2 < this.accessoryW.length; _i2++) {
          this.accessoryW[_i2].style.opacity = null;
        }

        for (var _i3 = 0; _i3 < this.name.length; _i3++) {
          this.name[_i3].style.opacity = null;
        }

        for (var _i4 = 0; _i4 < this.price.length; _i4++) {
          this.price[_i4].style.opacity = null;
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (!this.c.isTouch) {
          this.moveDesktop(x, y, target);
        }

        if (this.noCustom || !this.isDown) return;
        var deltaY = y - this.start.y + pageYOffset;
        var deltaX = x - this.start.x;
        if (Math.abs(deltaX) < 30 || Math.abs(deltaY) > Math.abs(deltaX) || this.alreadySlided) return;
        this.alreadySlided = true;
        this.direction = deltaX > 0 ? -1 : 1;
        this.slide();
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "down",
      value: function down(e) {
        this.isDown = true;
        this.alreadySlided = false;
        var tt = e.targetTouches[0];
        this.start.x = tt.pageX;
        this.start.y = tt.pageY + pageYOffset;
      }
    }, {
      key: "up",
      value: function up(e) {
        this.isDown = false;

        if (!this.alreadySlided && !this.isRunning) {
          var ct = e.changedTouches[0];
          var x = ct.pageX;
          var y = ct.pageY;
          var deltaY = Math.abs(this.start.y - (y + pageYOffset));
          var deltaX = Math.abs(this.start.x - x);

          if (deltaY < 2 && deltaX < 2) {
            this.click(ct);
          }
        }
      }
    }, {
      key: "l",
      value: function l(a) {
        if (!this.c.isTouch) {
          r.L(this.area, a, 'click', this.mobileDesktopSlide);
        } else {
          var tS = 'touchstart';
          var tE = 'touchend'; // R.L(this.customW, a, tS, this.down)

          r.L(this.bundleSlidesW, a, tS, this.down); // R.L(this.customW, a, tE, this.up)

          r.L(this.bundleSlidesW, a, tE, this.up);
        }
      }
    }, {
      key: "lClick",
      value: function lClick(a) {
        if (this.c.isTouch) {
          r.L(this.bundleSlidesW, a, 'click', this.click);
        }
      }
    }, {
      key: "click",
      value: function click(currentTouch) {
        if (currentTouch) {
          var activeLi = r.G["class"]('active', this.custom)[0];
          var lis = Array.from(this.li);
          var activeIndex = lis.indexOf(activeLi);
          var nextLi = lis[0];

          if (activeIndex < lis.length - 1) {
            nextLi = lis[activeIndex + 1];
          }

          var nextRect = nextLi.getBoundingClientRect();

          if (currentTouch.clientX > nextRect.left && currentTouch.clientY > nextRect.top) {
            this.direction = 1;
            this.slide();
          } else {
            this.off();
            this.c.lightbox.show({
              cb: this.on,
              index: 0
            });
          }
        } else {
          this.off();
          this.c.lightbox.show({
            cb: this.on,
            index: 0
          });
        }
      }
    }, {
      key: "mobileDesktopSlide",
      value: function mobileDesktopSlide(e) {
        if (this.direction === 0) {
          this.click();
        } else {
          this.slide();
        }
      }
    }, {
      key: "setTransformOffsets",
      value: function setTransformOffsets() {
        for (var i = 0; i < this.liL; i++) {
          var newI = i < this.index ? i + this.liL : i;
          this.liX[i] = (newI - this.index) * this.liW;
          r.T(this.li[i], this.liX[i], 0, 'px');
        }

        for (var _i5 = 0; _i5 < this.bundleSlides.length; _i5++) {
          var _newI = _i5 < this.index ? _i5 + this.bundleSlides.length : _i5;

          this.bundleX[_i5] = (_newI - this.index) * this.bundleWidth;
          r.T(this.bundleSlides[_i5], this.bundleX[_i5], 0, 'px');
        }
      }
    }, {
      key: "slide",
      value: function slide() {
        var _this = this;

        if (this.isRunning) return;
        this.lClick('r');
        this.isRunning = true;

        if (this.direction > 0) {
          var next = this.index + 1;
          this.newNo = next > this.limit ? 0 : next;
        } else {
          var _next = this.index - 1;

          if (_next < 0) {
            this.newNo = this.limit;
          } else {
            this.newNo = _next;
          }

          this.liX[this.newNo] = -this.liW;
          this.bundleX[this.newNo] = -this.bundleWidth;
        }

        this.populateBundle(this.newNo); // ---------------------------------------------
        // Motion Prepare

        var d0 = 300;
        var d1 = 700;
        var d2 = 1000;
        var tl0 = new r.TL();
        var tl1 = new r.TL();
        var tl2 = new r.TL(); // Li

        for (var i = 0; i < this.liL; i++) {
          // X
          var start = this.liX[i];
          this.liX[i] = this.liX[i] + this.liW * -this.direction; // Delay

          var cb = i === this.limit ? this.cb : false; // TL

          tl0.from({
            el: this.li[i],
            p: {
              x: [start, this.liX[i], 'px']
            },
            d: d2,
            e: 'o4',
            cb: cb
          });
        } // Bundle Slides


        for (var _i6 = 0; _i6 < this.bundleSlides.length; _i6++) {
          // X
          var _start = this.bundleX[_i6];
          this.bundleX[_i6] = this.bundleX[_i6] + this.bundleWidth * -this.direction; // Delay


          var _cb = _i6 === this.limit ? this.cb : false; // TL


          tl0.from({
            el: this.bundleSlides[_i6],
            p: {
              x: [_start, this.bundleX[_i6], 'px']
            },
            d: d2,
            e: 'o4',
            cb: _cb
          });
        }

        var accessoryIndex = this.index - 1;
        var newAccessroyIndex = this.newNo - 1;
        tl1.from({
          el: this.name[this.index],
          p: {
            opacity: [1, 0.3]
          },
          d: d0,
          e: 'o2'
        });
        tl1.from({
          el: this.price[this.index],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: 'o2'
        });
        tl1.from({
          el: this.accessoryW[accessoryIndex],
          p: {
            opacity: [1, 0]
          },
          d: d0,
          e: 'o2'
        });
        tl1.from({
          el: this.name[this.newNo],
          p: {
            opacity: [0.3, 1]
          },
          d: d1,
          e: 'o3',
          delay: d0
        });
        tl1.from({
          el: this.price[this.newNo],
          p: {
            opacity: [0, 1]
          },
          d: d1,
          e: 'o3'
        });
        tl1.from({
          el: this.accessoryW[newAccessroyIndex],
          p: {
            opacity: [0, 1]
          },
          d: d1,
          e: 'o3'
        });

        if (this.swipeIsHidden && this.newNo === 0) {
          this.swipeIsHidden = false;
          tl2.from({
            el: this.swipe,
            p: {
              opacity: [0, 1]
            },
            d: d1,
            e: 'o2',
            delay: d0
          });
        } else if (!this.swipeIsHidden && this.newNo !== 0) {
          this.swipeIsHidden = true;
          tl2.from({
            el: this.swipe,
            p: {
              opacity: [1, 0]
            },
            d: d0,
            e: 'o2'
          });
        } // ---------------------------------------------
        // Go


        new r.Delay(function (_) {
          _this.li[_this.newNo].classList.add('active');

          _this.li[_this.index].classList.remove('active');

          _this.bundleSlides[_this.newNo].classList.remove('inactive');

          _this.bundleSlides[_this.index].classList.add('inactive');
        }, d0).run();
        tl0.play();
        tl1.play();
        tl2.play();
      }
    }, {
      key: "cb",
      value: function cb() {
        this.index = this.newNo;
        this.setTransformOffsets();
        this.isRunning = false;
        this.lClick('a');
      }
    }, {
      key: "populateBundle",
      value: function populateBundle(index) {
        this.bundleCallBack(this.li[index].dataset.handle, index);
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y);

        if (!this.c.isTouch) {
          // Check if in slider
          var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
          var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
          var cursorIn = xIn && yIn;

          if (cursorIn) {
            cursorIn = !this.c.overPageIsOn;
          }

          if (cursorIn) {
            cursorIn = this.moveTarget.classList.contains('mobile-desktop-interaction-area');
          }

          if (cursorIn) {
            this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
            this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

            if (!this.cursorIsVisible) {
              this.cursorIsVisible = true;
              this.cursor.x.curr = this.cursor.x.targ;
              this.cursor.y.curr = this.cursor.y.targ;
              this.cursorShow.play();
              this.cursorScale.play();
            }
          } else if (!cursorIn && this.cursorIsVisible) {
            this.cursorIsVisible = false;
            this.cursorIsCenter = undefined;
            this.cursorShow.play({
              reverse: true
            });
            this.cursorScale.play({
              reverse: true
            });
          }

          var cursorXMoving = r.R(this.cursor.x.curr) !== this.cursor.x.targ;
          var cursorYMoving = r.R(this.cursor.y.curr) !== this.cursor.y.targ;
          var cursorMoving = cursorXMoving || cursorYMoving;

          if (cursorMoving || cursorIn) {
            // Direction
            if (this.x + this.areaLeft > this.areaCenterRight) {
              this.direction = 1;
            } else if (this.x + this.areaLeft <= this.areaCenterLeft) {
              this.direction = -1;
            } else {
              this.direction = 0;
            } // Change cursor


            this.firstTimeDi = r.Is.und(this.cursorIsCenter);
            var d = this.firstTimeDi ? 0 : 300;

            if (this.direction === 0 && (!this.cursorIsCenter || this.firstTimeDi)) {
              this.cursorIsCenter = true;
              this.cursorArrowShow.play({
                d: d,
                reverse: true
              });
              this.cursorCenterShow.play({
                d: d
              });
            } else if (this.direction !== 0) {
              if (this.cursorIsCenter || this.firstTimeDi) {
                this.cursorIsCenter = false;
                this.cursorArrowShow.play({
                  d: d
                });
                this.cursorCenterShow.play({
                  d: d,
                  reverse: true
                });
              }

              if (this.direction === 1) {
                this.cursor.el.arrow.style.transform = 'rotate(0deg)';
              } else {
                this.cursor.el.arrow.style.transform = 'rotate(180deg)';
              }
            }

            this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.09;
            this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.09;
            r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
          }
        }
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }]);

    return PackConfigurationMobile;
  }();

  var PackConfigurationBuy =
  /*#__PURE__*/
  function () {
    function PackConfigurationBuy(element) {
      var _this = this;

      _classCallCheck(this, PackConfigurationBuy);

      this.c = _C;
      this.element = element;
      this.onReviewsLoaded = this.onReviewsLoaded.bind(this);
      this.onReviewsClick = this.onReviewsClick.bind(this);
      this.onColorChange = this.onColorChange.bind(this);
      this.onBundleClick = this.onBundleClick.bind(this);
      this.onCustomBundleHoverOn = this.onCustomBundleHoverOn.bind(this);
      this.onCustomBundleHoverOff = this.onCustomBundleHoverOff.bind(this);
      this.addToBag = this.addToBag.bind(this);
      this.buyItNow = this.buyItNow.bind(this);
      this.on = this.on.bind(this);
      this.bundleCallback = this.bundleCallback.bind(this);
      this.populateBundleMobile = this.populateBundleMobile.bind(this);
      this.onBackorderClick = this.onBackorderClick.bind(this);
      this.addVariant = this.addVariant.bind(this);
      this.removeProduct = this.removeProduct.bind(this);
      this.overFn = this.overFn.bind(this);
      this.mobileConfig = new PackConfigurationMobile(this.element, this.populateBundleMobile);
      this.slider = new Slider1({
        parent: '.simple-product-w',
        element: element
      });
      this.sliderHolder = r.G["class"]('simple-product-w', element)[0];
      this.variantHeroLi = r.G["class"]('product-detail-image', this.sliderHolder)[0];
      var flatlays = r.G["class"]('bundle-flatlay', element);
      this.bundleFlatlays = [];

      for (var i = 0; i < flatlays.length; i++) {
        this.bundleFlatlays.push(new BundleFlatlay(flatlays[i], element.dataset, this.bundleCallback));
      }

      this.customBundleHero = new CustomBundleHero(r.G["class"]('custom-bundle-hero', element)[0], this.bundleCallback);
      this.activeHero = this.slider;
      this.customConfigW = r.G["class"]('pack-config-custom-w', this.element)[0];
      this.customConfig = r.G["class"]('pack-config-custom', this.element)[0];
      this.sCustom = new ScrollSecondary({
        fromConfigCustom: true
      });
      this.sCustom.init({
        el: this.customConfig,
        wrap: this.customConfigW
      });
      var colorHolder = r.G["class"]('configurator-left-options-color', element)[0];
      this.colors = colorHolder ? colorHolder.children : [];

      for (var _i = 0; _i < this.colors.length; _i++) {
        this.colors[_i].addEventListener('click', this.onColorChange);
      }

      this.bundleSlideW = r.G["class"]('bundle-slide-w', this.element)[0];
      this.bundleSlides = r.G["class"]('bundle-slide', this.element);
      this.bundleElements = r.G["class"]('pack-config-custom-li', element);

      for (var _i2 = 0; _i2 < this.bundleElements.length; _i2++) {
        this.bundleElements[_i2].addEventListener('click', this.onBundleClick);
      }

      var customBundleSidebar = r.G.id('bundle-custom');
      var customProductElements = r.G["class"]('pack-config-custom-accessory', customBundleSidebar);

      for (var _i3 = 0; _i3 < customProductElements.length; _i3++) {
        this.toggleCustomBundleHoverListeners(customProductElements[_i3], true);
      }

      this.collectionName = element.dataset.accessoriesCollectionName;
      this.product = JSON.parse(element.dataset.product);
      this.product.metadata = JSON.parse(element.dataset.productMetadata);
      this.currentVariant = JSON.parse(element.dataset.variant);

      if (this.product.options.length === 1 && this.product.options[0] === 'Color') {
        var variantsByValue = {};
        this.product.variants.forEach(function (variant) {
          variant.productId = _this.product.id;
          variant.productName = _this.product.title;
          variant.color = variant.option1;
          variantsByValue[variant.option1] = variant;
        });
        this.product.variantsByValue = variantsByValue;
      }

      this.images = [];
      this.product.variants.forEach(function (variant) {
        var featuredImage = variant.featured_image ? variant.featured_image.src : undefined;

        if (!_this.images.includes(featuredImage)) {
          _this.images.push(featuredImage);
        }
      });
      var heroIsFullHeight = this.product.metadata.heroIsFullHeight;
      this.images = this.images.map(function (i) {
        return {
          url: i,
          isFullHeight: heroIsFullHeight,
          title: _this.product.title,
          description: _this.product.metadata.lightboxDescription || ''
        };
      });
      this.images = this.images.concat(this.product.metadata.productDetailImages.filter(function (i) {
        return i.desktopProductImage;
      }).map(function (i) {
        return {
          url: i.desktopProductImage.url.replace(_this.c.s3Domain, _this.c.cloudFrontDomain),
          isFullHeight: i.isFullHeight,
          title: _this.product.title,
          description: i.lightboxDescription
        };
      }));
      this.populateSimpleLightbox();
      this.accessoryMetadata = {};
      this.accessories = JSON.parse(element.dataset.accessories).filter(function (a) {
        return a.id !== _this.product.id && !a.remove;
      });
      this.accessories.forEach(function (accessory) {
        var dataHandle = accessory.handle.replace(/-/g, '_');
        _this.accessoryMetadata[accessory.handle] = JSON.parse(element.dataset[dataHandle]);
        accessory.metadata = _this.accessoryMetadata[accessory.handle];

        _this.buildVariantsByValue(accessory, element);
      });
      this.bundleHandles = JSON.parse(element.dataset.bundles);
      this.bundles = {};
      this.bundleHandles.forEach(function (handle) {
        var dataHandle = handle.replace(/-/g, '_');
        var bundle = JSON.parse(element.dataset[dataHandle]);
        bundle.products.forEach(function (product) {
          product.metadata = _this.accessoryMetadata[product.handle];

          if (product.id !== _this.product.id && !product.metadata) {
            console.log('MISSING METADATA FOR:', product.title, product.id);
            console.log('LIKELY MISSING FROM COLLECTION', _this.accessoriesCollectionName);
          }

          _this.buildVariantsByValue(product, element);

          if (product.id === _this.product.id) {
            product.metadata = _this.product.metadata;
          }
        });
        _this.bundles[handle] = bundle;

        _this.calculatePriceDisplay(bundle);
      });
      this.product.colorIndex = this.product.options.indexOf('Color');
      this.customBundle = {
        name: 'Custom',
        handle: 'custom',
        products: [this.product]
      };
      this.currentVariant = JSON.parse(element.dataset.variant);
      this.options = JSON.parse(element.dataset.options);
      this.currentVariant.color = this.currentVariant.options[this.product.colorIndex];
      this.addToBagButton = r.G["class"]('btn-add', element)[0];
      this.addToBagButton.addEventListener('click', this.addToBag);
      this.buyForm = r.G["class"]('shopify-product-form', element)[0];
      this.buyItNowButton = r.G.tag('button', element)[0];
      this.buyItNowButton.addEventListener('click', this.buyItNow);
      this.selectBundle(this.bundles[this.bundleHandles[0]]);
      this.updateSidebar();
      this.rating = r.G["class"]('configurator-left-rating', element)[0];
      this.rating.addEventListener('click', this.onReviewsClick);
      window.addEventListener('reviewsloaded', this.onReviewsLoaded);
      this.checkAddEnabled();
      this.backorderCta = r.G["class"]('backorder-cta', element)[0];
      if (this.backorderCta) this.backorderCta.addEventListener('click', this.onBackorderClick);
    }

    _createClass(PackConfigurationBuy, [{
      key: "deinit",
      value: function deinit() {
        for (var i = 0; i < this.colors.length; i++) {
          this.colors[i].removeEventListener('click', this.onColorChange);
        }

        for (var _i4 = 0; _i4 < this.bundleElements.length; _i4++) {
          this.bundleElements[_i4].removeEventListener('click', this.onBundleClick);
        }

        var customBundleSidebar = r.G.id('bundle-custom');
        var customProductElements = r.G["class"]('pack-config-custom-accessory', customBundleSidebar);

        for (var _i5 = 0; _i5 < customProductElements.length; _i5++) {
          this.toggleCustomBundleHoverListeners(customProductElements[_i5], false);
        }

        window.removeEventListener('reviewsloaded', this.onReviewsLoaded);
        this.rating.removeEventListener('click', this.onReviewsClick);
      } //
      // ARI LIFECYCLE
      //

    }, {
      key: "overFn",
      value: function overFn(e) {
        if (e.type === 'mouseenter') {
          // this.c.scroll.off()
          this.sCustom.on({
            reset: false
          });
        } else {
          this.sCustom.off(); // this.c.scroll.on({reset: false})
        }
      }
    }, {
      key: "l",
      value: function l(a) {
        if (!this.c.isMobile) {
          r.L(this.customConfigW, a, 'mouseenter', this.overFn);
          r.L(this.customConfigW, a, 'mouseleave', this.overFn);
        }
      }
    }, {
      key: "on",
      value: function on() {
        this.slider.on();
        this.sCustom.run();
        this.l('a');
        this.bundleFlatlays.forEach(function (f) {
          return f.on();
        });
        this.customBundleHero.on();

        if (this.c.isMobile) {
          this.mobileConfig.on();
        }
      }
    }, {
      key: "off",
      value: function off() {
        this.slider.off();
        this.sCustom.destroy();
        this.l('r');
        this.bundleFlatlays.forEach(function (f) {
          return f.off();
        });
        this.customBundleHero.off();

        if (this.c.isMobile) {
          this.mobileConfig.off();
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        this.slider.resize();
        this.sCustom.resize();
        this.bundleFlatlays.forEach(function (f) {
          return f.resize();
        });
        this.customBundleHero.resize();

        if (this.c.isMobile) {
          this.mobileConfig.on();
        }

        this.mobileConfig.resize();

        if (this.c.isDesktop) {
          this.getImageAspectRatio();
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        this.slider.loop();
        this.bundleFlatlays.forEach(function (f) {
          return f.loop();
        });
        this.customBundleHero.loop();

        if (this.c.isMobile) {
          this.mobileConfig.loop();
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.slider.move(x, y, target);
        this.bundleFlatlays.forEach(function (f) {
          return f.move(x, y, target);
        });
        this.customBundleHero.move(x, y, target);

        if (this.c.isMobile) {
          this.mobileConfig.move(x, y, target);
        }
      }
    }, {
      key: "getImageAspectRatio",
      value: function getImageAspectRatio() {
        var width = this.bundleSlideW.offsetWidth;
        var height = this.bundleSlideW.offsetHeight;
        var aspectRatio = width / height;
        var imageAspectRatio = 1440 / 1080;

        if (aspectRatio > imageAspectRatio) {
          this.bundleSlideW.classList.add('short');
        } else {
          this.bundleSlideW.classList.remove('short');
        }
      } //
      // LISTENERS
      //

    }, {
      key: "onReviewsLoaded",
      value: function onReviewsLoaded(e) {
        if (e.detail.count > 0) {
          var qty = r.G["class"]('configurator-left-rating-qty', this.rating)[0];
          qty.innerHTML = '(' + e.detail.count + ')';
          var stars = r.G["class"]('stars-color')[0];
          var averageRating = e.detail.averageRating;
          if (averageRating > 0.25) stars.classList.remove('stars-color-0');

          if (averageRating > 4.75) {
            stars.classList.add('stars-color-5');
          } else if (averageRating > 4.25) {
            stars.classList.add('stars-color-4-5');
          } else if (averageRating > 3.75) {
            stars.classList.add('stars-color-4');
          } else if (averageRating > 3.25) {
            stars.classList.add('stars-color-3-5');
          } else if (averageRating > 2.75) {
            stars.classList.add('stars-color-3');
          } else if (averageRating > 2.25) {
            stars.classList.add('stars-color-2-5');
          } else if (averageRating > 1.75) {
            stars.classList.add('stars-color-2');
          } else if (averageRating > 1.25) {
            stars.classList.add('stars-color-1-5');
          } else if (averageRating > 0.75) {
            stars.classList.add('stars-color-1');
          } else if (averageRating > 0.25) {
            stars.classList.add('stars-color-0-5');
          }

          this.rating.classList.remove('hidden');
        }
      }
    }, {
      key: "onReviewsClick",
      value: function onReviewsClick(e) {
        var reviews = r.G["class"]('reviews-questions-w')[0];

        if (reviews) {
          var y = reviews.getBoundingClientRect().top + pageYOffset;
          this.c.smoothScroll.scrollToY(y, true);
        }
      }
    }, {
      key: "onColorChange",
      value: function onColorChange(e) {
        for (var i = 0; i < this.colors.length; i++) {
          this.colors[i].classList.remove('active');
        }

        e.target.classList.add('active');
        var color = e.target.dataset.value;
        this.changeBundleColor(color);
        this.bundleFlatlays.forEach(function (f) {
          return f.setColor(color);
        });
        this.customBundleHero.showVariant(this.currentVariant);
        this.updateSidebar();

        if (this.bundleFlatlays.includes(this.activeHero)) {
          this.populateBundleLightbox(this.currentBundle, color);
        } else if (this.activeHero === this.customBundleHero) {
          this.populateBundleLightbox(this.customBundle, color);
        }
      }
    }, {
      key: "onBundleClick",
      value: function onBundleClick(e) {
        if (e.target.classList.contains('pack-config-custom-li')) {
          if (e.target.classList.contains('active')) return;
          var index = 0;
          var length = this.bundleElements.length;

          for (var i = 0; i < length; i++) {
            this.bundleElements[i].classList.remove('active');
            if (this.bundleElements[i] === e.target) index = i;
          }

          e.target.classList.add('active');
          var color = this.currentVariant.option1;

          if (index === length - 1) {
            this.selectBundle(this.customBundle);
            this.populateBundleLightbox(this.customBundle, color);
            this.sliderHolder.classList.add('inactive');
            this.bundleFlatlays.forEach(function (f) {
              return f.element.classList.add('inactive');
            });
            this.customBundleHero.element.classList.remove('inactive');
            this.activeHero = this.customBundleHero;
          } else {
            var bundle = this.bundles[e.target.dataset.handle];
            this.selectBundle(bundle);

            if (bundle.products.length === 1 && bundle.products[0].id === this.product.id) {
              this.populateSimpleLightbox();
              this.sliderHolder.classList.remove('inactive');
              this.bundleFlatlays.forEach(function (f) {
                return f.element.classList.add('inactive');
              });
              this.customBundleHero.element.classList.add('inactive');
              this.activeHero = this.slider;
            } else {
              var bundleFlatlay = this.bundleFlatlays.filter(function (b) {
                return b.handle === e.target.dataset.handle;
              })[0];
              if (!bundleFlatlay.bundle) bundleFlatlay.setBundle(bundle, color);
              this.populateBundleLightbox(bundle, color);
              this.sliderHolder.classList.add('inactive');
              this.bundleFlatlays.forEach(function (f) {
                if (f === bundleFlatlay) {
                  f.element.classList.remove('inactive');
                } else {
                  f.element.classList.add('inactive');
                }
              });
              this.customBundleHero.element.classList.add('inactive');
              this.activeHero = bundleFlatlay;
            }
          }

          this.updateSidebar();
          this.checkAddEnabled();
        } else {
          var _color = this.currentVariant.option1;

          if (this.bundleFlatlays.includes(this.activeHero)) {
            this.populateBundleLightbox(this.currentBundle, _color);
          } else if (this.activeHero === this.customBundleHero) {
            this.populateBundleLightbox(this.customBundle, _color);
          }

          var _index = 0;

          if (this.currentBundle === this.customBundle) {
            _index = [this.product].concat(this.accessories).findIndex(function (p) {
              return p.id === parseInt(e.target.dataset.productId);
            });

            if (_index === -1) {
              var selectedProducts = this.selectedVariants.map(function (v) {
                return v.productId;
              });
              _index = [this.product].concat(this.accessories).findIndex(function (p) {
                return !selectedProducts.includes(p.id);
              });
            }
          } else {
            _index = Array.from(e.target.parentNode.children).indexOf(e.target);
          }

          this.c.lightbox.show({
            cb: this.on,
            index: _index
          });
        } // the ON call will need a delay if above code gets animated


        if (this.c.isDesktop) {
          this.sCustom.off();
          this.sCustom.resize();
          this.sCustom.on({
            reset: false
          });
        }
      }
    }, {
      key: "onCustomBundleHoverOn",
      value: function onCustomBundleHoverOn(e) {
        var productId = parseInt(e.target.dataset.productId);
        var index = this.selectedVariants.findIndex(function (v) {
          return v.productId === productId;
        });
        var variant = this.selectedVariants[index];
        this.customBundleHero.showVariant(variant);
      }
    }, {
      key: "onCustomBundleHoverOff",
      value: function onCustomBundleHoverOff(e) {
        var _this2 = this;

        setTimeout(function (_) {
          var productId = parseInt(e.target.dataset.productId);

          var index = _this2.selectedVariants.findIndex(function (v) {
            return v.productId === productId;
          });

          var variant = _this2.selectedVariants[index];

          if (variant.featured_image && _this2.customBundleHero.imgSrc === variant.featured_image.src) {
            _this2.customBundleHero.showVariant(_this2.currentVariant);
          }
        }, 250);
      }
    }, {
      key: "addToBag",
      value: function addToBag(e) {
        var _this3 = this;

        var updates = {};

        if (this.selectedVariants.length > 1) {
          this.addToBagButton.classList.add('group');
          this.addToBagButton.classList.remove('single');
        } else {
          this.addToBagButton.classList.add('single');
          this.addToBagButton.classList.remove('group');
        }

        this.addToBagButton.classList.add('submitting');
        this.selectedVariants.forEach(function (variant) {
          if (_this3.c.cart.variants[variant.id]) {
            updates[variant.id] = _this3.c.cart.variants[variant.id] + 1;
          } else {
            updates[variant.id] = 1;
          }
        });
        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates: updates
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          if (_this3.selectedVariants.length === 1) {
            var oldQty = _C.cart.variants[_this3.selectedVariants[0].id] || 0;
            r.G["class"]('num-added', _this3.addToBagButton)[0].innerHTML = oldQty + 1;
          }

          _this3.addToBagButton.classList.add('submitted');

          _this3.addToBagButton.classList.remove('submitting');

          setTimeout(function (_) {
            return _this3.addToBagButton.classList.remove('submitted');
          }, 3000);

          _C.cart.refresh();

          return res.json();
        }).then(function (response) {
          return console.log('Success:', JSON.stringify(response));
        })["catch"](function (error) {
          return console.error('Error:', error);
        });

        if (window.fbq) {
          this.selectedVariants.forEach(function (variant) {
            window.fbq('track', 'AddToCart', {
              content_name: variant.productName,
              // content_category: 'Apparel & Accessories > Shoes',
              // content_ids: ['shopify_' + variant.productId + '_' + variant.id],
              content_category: 'Travel',
              content_ids: [variant.productId],
              content_type: 'product',
              value: (variant.price / 100).toFixed(2),
              currency: 'USD'
            });
          });
        }
      }
    }, {
      key: "buyItNow",
      value: function buyItNow(e) {
        var _this4 = this;

        var updates = {};
        this.buyForm.classList.add('submitting');
        this.selectedVariants.forEach(function (variant) {
          if (_this4.c.cart.variants[variant.id]) {
            updates[variant.id] = _this4.c.cart.variants[variant.id] + 1;
          } else {
            updates[variant.id] = 1;
          }
        });
        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates: updates
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          _C.eventDelegation.ajaxHref('/checkout');

          return res.json();
        }).then(function (response) {
          return console.log('Success:', JSON.stringify(response));
        })["catch"](function (error) {
          return console.error('Error:', error);
        });

        if (window.fbq) {
          this.selectedVariants.forEach(function (variant) {
            window.fbq('track', 'AddToCart', {
              content_name: variant.productName,
              // content_category: 'Apparel & Accessories > Shoes',
              // content_ids: ['shopify_' + variant.productId + '_' + variant.id],
              content_category: 'Travel',
              content_ids: [variant.productId],
              content_type: 'product',
              value: (variant.price / 100).toFixed(2),
              currency: 'USD'
            });
          });
        }
      }
    }, {
      key: "onBackorderClick",
      value: function onBackorderClick() {
        var description = JSON.parse(this.backorderCta.dataset.description);
        this.c.textModal.populate(description.title, description.body);
        this.c.textModal.open();
      } //
      // DATA MUTATION
      //

    }, {
      key: "buildVariantsByValue",
      value: function buildVariantsByValue(product, element) {
        var _this5 = this;

        if (product.metadata && product.metadata.isProductUmbrella) {
          var subProducts = product.metadata.subProducts;
          var variantsObj = {};
          var subProductHandles = [];
          var options = [];
          subProducts.forEach(function (subProduct, index) {
            var dataHandle = subProduct.product.handle.replace(/-/g, '_');
            subProductHandles.push(dataHandle);
            var vv1 = subProduct.variantValue1;
            variantsObj[vv1] = variantsObj[vv1] || {};
            var vv2 = subProduct.variantValue2;
            var additionalLevels = vv2 && vv2.length ? 2 : 1;
            var nativeSubProduct = JSON.parse(element.dataset['accessory_' + dataHandle]);
            nativeSubProduct.metadata = JSON.parse(element.dataset[dataHandle]);

            if (index === 0) {
              options = nativeSubProduct.options.slice();

              if (vv2 && vv2.length) {
                options.unshift(subProduct.variantOption2);
              }

              options.unshift(subProduct.variantOption1);
              product.options = options;
            }

            var nativeVariantsObj = _this5.buildVariantsObj(nativeSubProduct, vv1, vv2, product);

            if (vv2 && vv2.length) {
              variantsObj[vv1][vv2] = nativeVariantsObj; // if (index === 0) {
              //     options.unshift(subProduct.variantOption2)
              //     options.unshift(subProduct.variantOption1)
              // }
            } else {
              variantsObj[vv1] = nativeVariantsObj; // if (index === 0) options.unshift(subProduct.variantOption1)
            }
          });
          product.variantsByValue = variantsObj;
          product.variants = this.flattenNestedVariants(variantsObj, product.options);
          var accessoryIndex = this.accessories.findIndex(function (a) {
            return a.id === product.id;
          });
          this.accessories[accessoryIndex] = product;
        } else if (!(product.options.length === 1 && product.options[0] === 'Title')) {
          product.variantsByValue = this.buildVariantsObj(product);
        }
      }
    }, {
      key: "buildVariantsObj",
      value: function buildVariantsObj(product, addOption1, addOption2, umbrellaProduct) {
        var _this6 = this;

        var masterProduct = umbrellaProduct || product;
        masterProduct.colorIndex = masterProduct.options.indexOf('Color');
        masterProduct.variantOptionSet = [];

        for (var i = 0; i < masterProduct.options.length; i++) {
          masterProduct.variantOptionSet.push(masterProduct.options[i] === 'Color');
        }

        var variantsObj = {};
        product.variants.forEach(function (variant) {
          var modifiedVariant = _this6.modifyVariant(product, variant, addOption1, addOption2, umbrellaProduct);

          modifiedVariant.color = modifiedVariant.options[masterProduct.colorIndex];

          if (variant.option1) {
            var vo1 = variant.option1;
            variantsObj[vo1] = variantsObj[vo1] || {};

            if (variant.option2) {
              var vo2 = variant.option2;
              variantsObj[vo1][vo2] = variantsObj[vo1][vo2] || {};

              if (variant.option3) {
                var vo3 = variant.option3;
                variantsObj[vo1][vo2][vo3] = modifiedVariant;
              } else {
                variantsObj[vo1][vo2] = modifiedVariant;
              }
            } else {
              variantsObj[vo1] = modifiedVariant;
            }
          }
        });
        return variantsObj;
      }
    }, {
      key: "modifyVariant",
      value: function modifyVariant(product, variant, addValue1, addValue2, umbrellaProduct) {
        var masterProduct = umbrellaProduct || product;
        variant.productId = masterProduct.id;
        variant.productName = masterProduct.title;

        if (product.colorIndex > -1) {
          variant.color = variant.options[product.colorIndex];
        }

        if (product.options.length > 1) {
          variant.needsAdditionalSelection = true;
        }

        var modifiedVariant = Object.assign({}, variant);
        modifiedVariant.options = modifiedVariant.options.slice(); // TODO: fix for umbrella items? - doesn't appear broken

        if (addValue1 && addValue1.length) {
          if (addValue2 && addValue2.length) {
            modifiedVariant.option5 = modifiedVariant.option3;
            modifiedVariant.option4 = modifiedVariant.option2;
            modifiedVariant.option3 = modifiedVariant.option1;
            modifiedVariant.option2 = addValue2;
            modifiedVariant.option1 = addValue1;
            modifiedVariant.options.unshift(addValue1, addValue2);
          } else {
            modifiedVariant.option4 = modifiedVariant.option3;
            modifiedVariant.option3 = modifiedVariant.option2;
            modifiedVariant.option2 = modifiedVariant.option1;
            modifiedVariant.option1 = addValue1;
            modifiedVariant.options.unshift(addValue1);
          }
        }

        if (this.currentVariant.id === modifiedVariant.id) {
          this.currentVariant = modifiedVariant;
        }

        return modifiedVariant;
      }
    }, {
      key: "flattenNestedVariants",
      value: function flattenNestedVariants(variantsByValue, options) {
        var array = [];

        if (options.length === 5) {
          var keys0 = Object.keys(variantsByValue);
          keys0.forEach(function (k0) {
            var keys1 = Object.keys(variantsByValue[k0]);
            keys1.forEach(function (k1) {
              var keys2 = Object.keys(variantsByValue[k0][k1]);
              keys2.forEach(function (k2) {
                var keys3 = Object.keys(variantsByValue[k0][k1][k2]);
                keys3.forEach(function (k3) {
                  var keys4 = Object.keys(variantsByValue[k0][k1][k2][k3]);
                  keys3.forEach(function (k4) {
                    array.push(variantsByValue[k0][k1][k2][k3][k4]);
                  });
                });
              });
            });
          });
        } else if (options.length === 4) {
          var _keys = Object.keys(variantsByValue);

          _keys.forEach(function (k0) {
            var keys1 = Object.keys(variantsByValue[k0]);
            keys1.forEach(function (k1) {
              var keys2 = Object.keys(variantsByValue[k0][k1]);
              keys2.forEach(function (k2) {
                var keys3 = Object.keys(variantsByValue[k0][k1][k2]);
                keys3.forEach(function (k3) {
                  array.push(variantsByValue[k0][k1][k2][k3]);
                });
              });
            });
          });
        } else if (options.length === 3) {
          var _keys2 = Object.keys(variantsByValue);

          _keys2.forEach(function (k0) {
            var keys1 = Object.keys(variantsByValue[k0]);
            keys1.forEach(function (k1) {
              var keys2 = Object.keys(variantsByValue[k0][k1]);
              keys2.forEach(function (k2) {
                array.push(variantsByValue[k0][k1][k2]);
              });
            });
          });
        } else if (options.length === 2) {
          var _keys3 = Object.keys(variantsByValue);

          _keys3.forEach(function (k0) {
            var keys1 = Object.keys(variantsByValue[k0]);
            keys1.forEach(function (k1) {
              array.push(variantsByValue[k0][k1]);
            });
          });
        } else if (options.length === 1) {
          var _keys4 = Object.keys(variantsByValue);

          _keys4.forEach(function (k0) {
            array.push(variantsByValue[k0]);
          });
        }

        return array;
      }
    }, {
      key: "findVariantForColor",
      value: function findVariantForColor(product, color, variant) {
        var firstVariant = variant || product.variants[0];
        var options = firstVariant.options.slice();
        options[product.colorIndex] = color;
        var foundVariant = firstVariant;

        if (product.variantsByValue) {
          var obj = {};

          if (product.colorIndex === 0) {
            obj = product.variantsByValue[options[0]];
          } else if (product.colorIndex === 1) {
            obj = product.variantsByValue[options[0]][options[1]];
          } else if (product.colorIndex === 2) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]];
          } else if (product.colorIndex === 3) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]][options[3]];
          } else if (product.colorIndex === 4) {
            obj = product.variantsByValue[options[0]][options[1]][options[2]][options[3]][options[4]];
          }

          if (obj) {
            while (obj && !obj.id) {
              obj = obj[Object.keys(obj)[0]];
            }

            foundVariant = obj;
          }
        }

        return foundVariant;
      }
    }, {
      key: "selectBundle",
      value: function selectBundle(bundle) {
        var _this7 = this;

        this.currentBundle = bundle;
        this.selectedVariants = [];
        var color = this.currentVariant.option1;
        bundle.products.forEach(function (product) {
          product.variantOptionSet = [];

          for (var i = 0; i < product.options.length; i++) {
            product.variantOptionSet.push(product.options[i] === 'Color');
          }

          var variant = _this7.findVariantForColor(product, color);

          if (product.options.length > 1) {
            variant.needsAdditionalSelection = true;
          }

          _this7.selectedVariants.push(variant);
        });
        /*
        const inputs = Array.from(R.G.class('hidden-variant-id', this.buyForm))
        if (this.selectedVariants.length === 1 && inputs[0].name === 'id') return
         this.buyForm.action = '/cart'
        inputs.forEach(input => {
            this.buyForm.removeChild(input)
        })
         this.selectedVariants.forEach(variant => {
            // <input type="text" name="updates[]" id="updates_{{ item.id }}" value="{{ item.quantity }}" />
            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = 'updates[' + variant.id + ']'
            input.id = 'updates_' + variant.id
            input.className = 'hidden-variant-id'
            input.value = '1'
            this.buyForm.appendChild(input)
        })
        */

        this.calculatePriceDisplay(bundle);
      }
    }, {
      key: "changeBundleColor",
      value: function changeBundleColor(color) {
        var _this8 = this;

        var oldVariantsIds = this.selectedVariants ? this.selectedVariants.map(function (v) {
          return v.id;
        }) : [];
        this.selectedVariants = [];
        this.currentBundle.products.forEach(function (product) {
          var oldVariantIndex = product.variants.findIndex(function (v) {
            return oldVariantsIds.includes(v.id);
          });

          if (oldVariantIndex > -1) {
            _this8.selectedVariants.push(_this8.findVariantForColor(product, color, product.variants[oldVariantIndex]));
          }
        });
        var variant = this.product.variantsByValue[color];
        if (variant) this.currentVariant = variant;
        this.changeVariantHero();
        this.checkAddEnabled();
      }
    }, {
      key: "addVariant",
      value: function addVariant(productId, variantId, needsAdditionalSelection) {
        var pool = this.currentBundle === this.customBundle ? [this.product].concat(this.accessories) : this.currentBundle.products;
        var product = pool.filter(function (p) {
          return p.id === productId;
        });

        if (product.length) {
          product = product[0];
        } else {
          product = this.accessories.filter(function (p) {
            return p.id === productId;
          })[0];
        }

        this.selectedVariants = this.selectedVariants.filter(function (v) {
          return product.variants.findIndex(function (v0) {
            return v.id === v0.id;
          }) === -1;
        });
        var newVariant = product.variants.filter(function (v) {
          return v.id === variantId;
        })[0];
        newVariant.needsAdditionalSelection = needsAdditionalSelection;
        this.selectedVariants.push(newVariant);

        if (this.currentBundle === this.customBundle && !this.currentBundle.products.includes(product)) {
          this.currentBundle.products.push(product);
        }

        this.updateSidebar();
        this.calculatePriceDisplay(this.currentBundle);
        this.checkAddEnabled();

        if (this.activeHero.setSelectedVariants) {
          this.activeHero.setSelectedVariants(this.selectedVariants);
        }
      }
    }, {
      key: "removeProduct",
      value: function removeProduct(productId) {
        var product = this.currentBundle.products.filter(function (p) {
          return p.id === productId;
        });

        if (product.length) {
          product = product[0];
        } else {
          product = this.accessories.filter(function (p) {
            return p.id === productId;
          })[0];
        }

        this.selectedVariants = this.selectedVariants.filter(function (v) {
          return product.variants.findIndex(function (v0) {
            return v.id === v0.id;
          }) === -1;
        });

        if (this.currentBundle === this.customBundle) {
          this.currentBundle.products.splice(this.currentBundle.products.indexOf(product), 1);
        }

        this.updateSidebar();
        this.calculatePriceDisplay(this.currentBundle);
        this.checkAddEnabled();

        if (this.activeHero.setSelectedVariants) {
          this.activeHero.setSelectedVariants(this.selectedVariants);
        }
      } //
      // DOM MUTATION
      //

    }, {
      key: "calculatePriceDisplay",
      value: function calculatePriceDisplay(bundle) {
        var el = r.G.id('bundle-' + bundle.handle);
        var priceElement = r.G["class"]('pack-config-custom-bundle-price', el)[0];
        var discountElement = r.G["class"]('pack-config-custom-bundle-discount', el)[0];
        var activeProducts = bundle.products.slice();

        if (bundle === this.currentBundle) {
          activeProducts = this.selectedVariants;
        }

        var price = 0;
        activeProducts.forEach(function (product) {
          price += product.price;
        });
        var discount = Math.min((activeProducts.length - 1) * 5, 15);
        var multiplier = (100 - discount) / 100;
        var discountedPrice = Math.floor(price * multiplier);
        var priceString = '$' + discountedPrice / 100;
        if (priceString.split('.').length !== 2) priceString += '.00';
        if (priceString.split('.')[1].length !== 2) priceString += '0';

        if (bundle === this.customBundle && bundle.products.length === 1) {
          priceElement.innerHTML = 'From ' + priceString;
        } else {
          priceElement.innerHTML = priceString;
        }

        if (bundle.products.length === 1) {
          var product = activeProducts[0];

          if (product.compare_at_price !== product.price && product.compare_at_price > 0) {
            var comparePrice = product.compare_at_price;
            var comparePriceString = '$' + comparePrice / 100;
            if (comparePriceString.split('.').length !== 2) comparePriceString += '.00';
            if (comparePriceString.split('.')[1].length !== 2) comparePriceString += '0';
            discountElement.innerHTML = comparePriceString;
            discountElement.classList.add('discounted-from');
          }
        } else {
          discountElement.innerHTML = discount === 0 ? '' : 'Save ' + discount + '%';
        }
      }
    }, {
      key: "changeVariantHero",
      value: function changeVariantHero() {
        var currentHeroImg = this.variantHeroLi.lastElementChild;
        var img = document.createElement('img');
        img.src = this.currentVariant.featured_image.src;
        var supportsObjectFit = 'objectFit' in document.documentElement.style;

        if (!supportsObjectFit) {
          if (!img.classList.contains('no-object-fit')) {
            img.classList.add('no-object-fit');
            img.style.backgroundImage = "url(".concat(img.src, ")");
            img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            img.style.backgroundPosition = 'center';
            img.style.backgroundRepeat = 'no-repeat';
            img.style.backgroundSize = 'contain';
          }
        }

        img.classList.add('fade-in');

        if (this.currentVariant.featured_image.alt) {
          img.alt = this.currentVariant.featured_image.alt;
        }

        img.addEventListener('animationend', function () {
          img.classList.remove('fade-in');
          if (currentHeroImg.parentNode) currentHeroImg.parentNode.removeChild(currentHeroImg);
        }, false);
        this.variantHeroLi.appendChild(img);

        if (this.slider.no !== 0) {
          this.slider.slideToIndex(0);
        }
      }
    }, {
      key: "updateSidebar",
      value: function updateSidebar() {
        var _this9 = this;

        var el = r.G.id('bundle-' + this.currentBundle.handle);
        var productElements = r.G["class"]('pack-config-custom-accessory', el);

        if (this.currentBundle === this.customBundle && productElements.length !== this.currentBundle.products.length) {
          this.constructCustomBundleSidebar();
        }

        var variantIds = this.selectedVariants.map(function (v) {
          return v.id;
        });
        this.currentBundle.products.forEach(function (product, index) {
          var li = productElements[index];
          if (!li) return;
          var img = r.G["class"]('pack-config-custom-accessory-img', li)[0];
          var variantIndex = product.variants.findIndex(function (v) {
            return variantIds.includes(v.id);
          });
          var included = variantIndex > -1;
          var variant = product.variants[variantIndex];
          var color = variant ? variant.color : _this9.currentVariant.color;
          var colorVariant = product.metadata && product.metadata.colorVariants ? product.metadata.colorVariants[color] : null;
          included ? li.classList.remove('removed') : li.classList.add('removed');

          if (variant && variant.needsAdditionalSelection) {
            li.classList.add('needs-selection');
          } else {
            li.classList.remove('needs-selection');
          }

          if (colorVariant && colorVariant.squareProductShot) {
            img.style.backgroundImage = 'url(' + colorVariant.squareProductShot.url.replace(_this9.c.s3Domain, _this9.c.cloudFrontDomain) + ')';
          } else if (product.metadata && product.metadata.squareProductShot) {
            img.style.backgroundImage = 'url(' + product.metadata.squareProductShot.url.replace(_this9.c.s3Domain, _this9.c.cloudFrontDomain) + ')';
          }
        });
      }
    }, {
      key: "checkAddEnabled",
      value: function checkAddEnabled() {
        var isAvailable = this.currentVariant.available;
        var buttonCta;

        if (isAvailable) {
          buttonCta = 'Add to Bag';
          var needSelection = this.selectedVariants.filter(function (v) {
            return v.needsAdditionalSelection;
          });

          if (needSelection.length === 0) {
            this.addToBagButton.classList.remove('disabled');
            this.buyForm.classList.remove('disabled');
          } else {
            this.addToBagButton.classList.add('disabled');
            this.buyForm.classList.add('disabled');
          }
        } else {
          buttonCta = 'Not available';
          this.addToBagButton.classList.add('disabled');
          this.buyForm.classList.add('disabled');
        }

        var buttonText = r.G["class"]('btn-text', this.addToBagButton);

        if (buttonText[0].innerHTML !== buttonCta) {
          for (var i = 0; i < buttonText.length; i++) {
            buttonText[i].innerHTML = buttonCta;
          }
        }
      }
    }, {
      key: "constructCustomBundleSidebar",
      value: function constructCustomBundleSidebar() {
        var _this10 = this;

        var el = r.G.id('bundle-' + this.currentBundle.handle);
        var productElements = r.G["class"]('pack-config-custom-accessory', el);
        var addButton = r.G.id('pack-config-add-to-custom');

        for (var i = productElements.length - 1; i >= 0; i--) {
          this.toggleCustomBundleHoverListeners(productElements[i], false);
          productElements[i].parentNode.removeChild(productElements[i]);
        }

        this.currentBundle.products.forEach(function (product) {
          // <li data-handle="{{ product.handle }}" data-product-id="{{ product.id }}" class="pack-config-custom-accessory product-{{ product.handle }}">
          //     <div class="pack-config-custom-accessory-img" style="background-image: url('')"></div>
          //     <div class="pack-config-custom-accessory-name">{{ product.title }}</div>
          // </li>
          var li = document.createElement('li');
          li.dataset.handle = product.handle;
          li.dataset.productId = product.id;
          li.className = 'pack-config-custom-accessory product-' + product.handle;
          var imgDiv = document.createElement('div');
          imgDiv.className = 'pack-config-custom-accessory-img';
          li.appendChild(imgDiv);
          var nameDiv = document.createElement('div');
          nameDiv.className = 'pack-config-custom-accessory-name';
          nameDiv.innerHTML = product.title;
          li.appendChild(nameDiv);

          _this10.toggleCustomBundleHoverListeners(li, true);

          addButton.parentNode.insertBefore(li, addButton);
        });
      }
    }, {
      key: "toggleCustomBundleHoverListeners",
      value: function toggleCustomBundleHoverListeners(element, isAdding) {
        if (isAdding) {
          element.addEventListener('mouseenter', this.onCustomBundleHoverOn);
          element.addEventListener('mouseleave', this.onCustomBundleHoverOff);
        } else {
          element.removeEventListener('mouseenter', this.onCustomBundleHoverOn);
          element.removeEventListener('mouseleave', this.onCustomBundleHoverOff);
        }
      } //
      // LIGHTBOX POPULATION
      //

    }, {
      key: "populateSimpleLightbox",
      value: function populateSimpleLightbox() {
        this.c.lightbox.isPackConfigurationLightbox = false;
        this.c.backendData.lightbox.simpleProduct = this.images;
      }
    }, {
      key: "populateBundleLightbox",
      value: function populateBundleLightbox(bundle, color) {
        var _this11 = this;

        this.c.lightbox.isPackConfigurationLightbox = true;
        var pool = bundle === this.customBundle ? [this.product].concat(this.accessories) : bundle.products;
        this.c.backendData.lightbox.packConfiguration = pool.map(function (product, index) {
          var variant;
          var isAdded = false;

          var selectedVariants = _this11.selectedVariants.filter(function (v) {
            return v.productId === product.id;
          });

          if (selectedVariants.length) {
            variant = selectedVariants[0];
            isAdded = true;
          } else {
            variant = _this11.findVariantForColor(product, color);
          }

          if (!variant) variant = product.variants[0];
          var colorNames = [];
          var colors = {};
          var activeColor = 0;

          if (product.variantsByValue) {
            var colorLevel = product.variantsByValue;

            for (var i = 0; i < product.colorIndex; i++) {
              colorLevel = colorLevel[Object.keys(colorLevel)[0]];
            }

            colorNames = Object.keys(colorLevel);
          }

          if (product.metadata && product.metadata.colorVariants) {
            colorNames.forEach(function (c, index) {
              colors[c] = {
                name: c
              };

              if (colors[c] && product.metadata.colorVariants[c]) {
                colors[c].hex1 = product.metadata.colorVariants[c].hex1;
                colors[c].hex2 = product.metadata.colorVariants[c].hex2;
              }

              if (c === variant.color) {
                activeColor = index;
              }
            });
          }

          return {
            isAccessory: index !== 0,
            productId: product.id,
            variantId: variant.id,
            variant: variant,
            title: product.title,
            description: product.metadata ? product.metadata.lightboxDescription : '',
            url: variant.featured_image ? variant.featured_image.src : null,
            isFullHeight: product.metadata ? product.metadata.heroIsFullHeight : false,
            added: isAdded,
            activeColor: activeColor,
            colorNames: colorNames,
            colors: colors,
            colorIndex: product.colorIndex,
            variantsByValue: product.variantsByValue,
            variantOptionSet: product.variantOptionSet,
            options: product.options,
            addVariant: _this11.addVariant,
            removeProduct: _this11.removeProduct
          };
        });
      }
    }, {
      key: "bundleCallback",
      value: function bundleCallback(e) {
        var color = this.currentVariant.option1;

        if (this.bundleFlatlays.includes(this.activeHero)) {
          this.populateBundleLightbox(this.currentBundle, color);
        } else if (this.activeHero === this.customBundleHero) {
          this.populateBundleLightbox(this.customBundle, color);
        }

        this.c.lightbox.show({
          cb: this.on,
          index: 0
        });
      }
    }, {
      key: "populateBundleMobile",
      value: function populateBundleMobile(handle, index) {
        var color = this.currentVariant.option1;
        var length = this.bundleElements.length;

        if (index === length - 1) {
          this.selectBundle(this.customBundle);
          this.populateBundleLightbox(this.customBundle, color);
          this.sliderHolder.classList.add('inactive');
          this.bundleFlatlays.forEach(function (f) {
            return f.element.classList.add('inactive');
          });
          this.customBundleHero.element.classList.remove('inactive');
          this.activeHero = this.customBundleHero;
        } else {
          var bundle = this.bundles[handle];
          this.selectBundle(bundle);

          if (bundle.products.length === 1 && bundle.products[0].id === this.product.id) {
            this.populateSimpleLightbox();
            this.sliderHolder.classList.remove('inactive');
            this.bundleFlatlays.forEach(function (f) {
              return f.element.classList.add('inactive');
            });
            this.customBundleHero.element.classList.add('inactive');
            this.activeHero = this.slider;
          } else {
            var bundleFlatlay = this.bundleFlatlays.filter(function (b) {
              return b.handle === handle;
            })[0];
            if (!bundleFlatlay.bundle) bundleFlatlay.setBundle(bundle, color);
            this.populateBundleLightbox(bundle, color);
            this.sliderHolder.classList.add('inactive');
            this.bundleFlatlays.forEach(function (f) {
              if (f === bundleFlatlay) {
                f.element.classList.remove('inactive');
              } else {
                f.element.classList.add('inactive');
              }
            });
            this.customBundleHero.element.classList.add('inactive');
            this.activeHero = bundleFlatlay;
          }
        }

        this.updateSidebar();
        this.checkAddEnabled();
      }
    }]);

    return PackConfigurationBuy;
  }();

  var HomeHero =
  /*#__PURE__*/
  function () {
    function HomeHero(element) {
      var _this = this;

      _classCallCheck(this, HomeHero);

      this.slider = new Slider1({
        parent: '.home-hero',
        element: element
      });
      this.resetTimeout();

      this.slider.onWillSlide = function () {
        _this.resetTimeout();
      };
    }

    _createClass(HomeHero, [{
      key: "on",
      value: function on() {
        this.slider.on();
      }
    }, {
      key: "off",
      value: function off() {
        this.slider.off();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.slider.resize();
      }
    }, {
      key: "loop",
      value: function loop() {
        this.slider.loop();
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.slider.move(x, y, target);
      }
    }, {
      key: "resetTimeout",
      value: function resetTimeout() {
        var _this2 = this;

        // console.log('resetTimeout')
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          // console.log('should slide right')
          _this2.slider.slideRight(true);
        }, 5000);
      }
    }]);

    return HomeHero;
  }();

  var ProductCarouselHero =
  /*#__PURE__*/
  function () {
    function ProductCarouselHero(element) {
      _classCallCheck(this, ProductCarouselHero);

      this.slider = new Slider1({
        parent: '.product-carousel-hero',
        element: element
      });
    }

    _createClass(ProductCarouselHero, [{
      key: "on",
      value: function on() {
        this.slider.on();
      }
    }, {
      key: "off",
      value: function off() {
        this.slider.off();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.slider.resize();
      }
    }, {
      key: "loop",
      value: function loop() {
        this.slider.loop();
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.slider.move(x, y, target);
      }
    }]);

    return ProductCarouselHero;
  }();

  var MediaSlideshow =
  /*#__PURE__*/
  function () {
    function MediaSlideshow(element) {
      _classCallCheck(this, MediaSlideshow);

      this.c = _C;
      this.element = element;
      r.BM(this, ['slide', 'cb', 'down', 'up', 'on', 'click', 'videoEnded', 'mouseEnter']);
      this.isPlaying = false;
      this.isRunning = false;
      this.alreadySlided = false;
      this.start = {
        x: 0,
        y: 0
      };
      this.direction = -1;
      this.no = 0;
      this.areaC = 'slider-1-interaction-area';
      this.area = r.G["class"](this.areaC, this.element)[0];
      this.areaCenter = r.G["class"](this.areaC + '-center', this.element)[0];
      this.noAreaCenter = r.Is.und(this.areaCenter);
      this.imgW = r.G["class"]('slider-img-translate-w', this.element);
      this.img = r.G["class"]('slider-img-translate', this.element);
      this.imgL = this.img.length;
      this.limit = this.imgL - 1;
      this.progress = r.G["class"]('progress', this.parent)[0];
      this.progressW = r.G["class"]('progress-w', this.parent)[0];
      this.hasProgress = r.Is.def(this.progress);
      this.pagination = r.G["class"]('slider-pagination-curr', this.element)[0];
      this.hasPagination = r.Is.def(this.pagination);

      if (!this.c.isTouch) {
        this.cursorIsCenter = undefined;
        this.cursorIsVisible = false;
        this.x = -1;
        this.y = -1;
        this.cursor = {
          x: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          y: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          el: {}
        };
        this.cursor.el.main = r.G["class"]('slider-cursor', this.element)[0];
        this.cursor.el.arrow = r.G["class"]('slider-cursor-arrow-w', this.element)[0];
        this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.element)[0];
        this.cursor.el.play = r.G["class"]('slider-cursor-play', this.element)[0];
        this.cursor.el.pause = r.G["class"]('slider-cursor-pause', this.element)[0];
        this.cursorShow = new r.M({
          el: this.cursor.el.main,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorScale = new r.M({
          el: this.cursor.el.bg,
          p: {
            scale: [0.9, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorArrowShow = new r.M({
          el: this.cursor.el.arrow,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorPlayShow = new r.M({
          el: this.cursor.el.play,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorPauseShow = new r.M({
          el: this.cursor.el.pause,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
      }

      this.mediaListItems = r.G["class"]('slider-img-translate-w', this.element);
      this.videoPosters = r.G["class"]('video-poster', this.element);
      this.cursorSlider = r.G["class"]('slider-cursor', this.element)[0];
      this.setSliderForVideo(0);

      if (this.c.isDesktop) {
        for (var i = 0; i < this.videoPosters.length; i++) {
          this.videoPosters[i].classList.add('hidden');
        }
      } else {
        this.element.classList.add('needs-poster');
      }

      if (this.c.isTouch) {
        this.element.classList.add('mobile-device');
      }
    }

    _createClass(MediaSlideshow, [{
      key: "l",
      value: function l(a) {
        if (this.c.isTouch) {
          r.L(this.area, a, 'touchstart', this.down);
          r.L(this.area, a, 'touchend', this.up);
        } else {
          r.L(this.area, a, 'click', this.slide);
          r.L(this.area, a, 'mouseover', this.mouseEnter);
        }
      }
    }, {
      key: "setSliderForVideo",
      value: function setSliderForVideo(index) {
        if (this.mediaListItems[index].classList.contains('video')) {
          this.noAreaCenter = false;
          this.area.classList.add('video-center');

          if (this.videoPlayer) {
            this.videoPlayer.pause();
          }

          this.videoPlayer = r.G.tag('video', this.mediaListItems[index])[0];

          if (!this.c.isTouch) {
            r.L(this.videoPlayer, 'a', 'ended', this.videoEnded);
          } else {
            this.cursorSlider.classList.remove('hidden');
          }
        } else {
          this.noAreaCenter = true;
          this.area.classList.remove('video-center');

          if (this.videoPlayer) {
            if (!this.c.isTouch) {
              r.L(this.videoPlayer, 'r', 'ended', this.videoEnded);
            }

            this.videoPlayer.pause();
            this.isPlaying = false;
            this.videoPlayer = null;
          }

          if (this.c.isTouch) {
            this.cursorSlider.classList.add('hidden');
          }
        }

        this.resize();
      }
    }, {
      key: "down",
      value: function down(e) {
        this.alreadySlided = false;
        var tt = e.targetTouches[0];
        this.start.x = tt.pageX;
        this.start.y = tt.pageY + pageYOffset;
      }
    }, {
      key: "up",
      value: function up(e) {
        if (!this.alreadySlided) {
          var ct = e.changedTouches[0];
          var x = ct.pageX;
          var y = ct.pageY;
          var deltaY = Math.abs(this.start.y - (y + pageYOffset));
          var deltaX = Math.abs(this.start.x - x);
          var overLink = y > this.areaCenterTop && y < this.areaCenterBottom;

          if (deltaY < 2 && deltaX < 2 && overLink) {
            this.click();
          }
        }
      }
    }, {
      key: "mouseEnter",
      value: function mouseEnter() {
        this.areaTop = this.area.getBoundingClientRect().top + pageYOffset;
      }
    }, {
      key: "click",
      value: function click() {
        if (this.c.isMobile) {
          if (this.videoPlayer.requestFullScreen) {
            this.videoPlayer.requestFullScreen();
          } else if (this.videoPlayer.webkitRequestFullScreen) {
            this.videoPlayer.webkitRequestFullScreen();
          } else if (this.videoPlayer.mozRequestFullScreen) {
            this.videoPlayer.mozRequestFullScreen();
          }

          this.videoPlayer.play();
        } else {
          if (this.videoPlayer.paused) {
            this.videoPlayer.play();
            this.cursorPlayShow.play({
              d: 0,
              reverse: true
            });
            this.cursorPauseShow.play({
              d: 0
            });
            this.isPlaying = true;
          } else {
            this.videoPlayer.pause();
            this.cursorPlayShow.play({
              d: 0
            });
            this.cursorPauseShow.play({
              d: 0,
              reverse: true
            });
            this.isPlaying = false;
          }
        }
      }
    }, {
      key: "slide",
      value: function slide() {
        if (this.isRunning || r.Is.und(this.cursorIsCenter) && !this.c.isTouch) return;

        if (this.direction === 0) {
          this.click();
          return;
        } else if (!this.limit) {
          return;
        } else {
          this.isRunning = true;
          this.c.outroIsOn = false;

          if (this.direction === 1) {
            if (this.no === this.limit) {
              this.newNo = 0;
            } else {
              this.newNo = this.no + 1;
            }
          } else if (this.direction === -1) {
            if (this.no === 0) {
              this.newNo = this.limit;
            } else {
              this.newNo = this.no - 1;
            }
          }
        }

        this.setSliderForVideo(this.newNo);
        var d0 = 600;
        var d1 = 1000;
        var e0 = 'i3';
        var e1 = 'o5';
        var eMobile = 'o4';
        var dMobile = 1000; // Translate

        var tl0 = new r.TL();
        var tl1 = new r.TL();
        var noEnd = -60 * this.direction;
        var noEndDemi = noEnd / 2;
        var newNoEnd = 100 * this.direction;
        var newNoEndDemi = newNoEnd / 2;

        if (this.hasProgress) {
          var progressStart = r.R(this.progressStep * this.no);
          var progressEnd = r.R(this.progressStep * this.newNo);
          var progressDemi = (progressStart + progressEnd) / 2;

          if (!this.c.isTouch) {
            tl1.from({
              el: this.progress,
              p: {
                x: [progressStart, progressDemi, 'px']
              },
              d: d0,
              e: e0
            });
            tl1.from({
              el: this.progress,
              p: {
                x: [progressDemi, progressEnd, 'px']
              },
              d: d1,
              e: e1,
              delay: d0
            });
          } else {
            tl1.from({
              el: this.progress,
              p: {
                x: [progressStart, progressEnd, 'px']
              },
              d: dMobile,
              e: eMobile
            });
          }
        }

        if (!this.c.isTouch) {
          // Step 0
          tl0.from({
            el: this.imgW[this.no],
            p: {
              x: [0, noEndDemi]
            },
            d: d0,
            e: e0
          });
          tl0.from({
            el: this.imgW[this.newNo],
            p: {
              x: [newNoEnd, newNoEndDemi]
            },
            d: d0,
            e: e0
          });
          tl0.from({
            el: this.img[this.newNo],
            p: {
              scale: [1.4, 1.2]
            },
            d: d0,
            e: e0,
            r: 4
          }); // Step 1

          tl0.from({
            el: this.imgW[this.no],
            p: {
              x: [noEndDemi, noEnd]
            },
            d: d1,
            e: e1,
            delay: d0
          });
          tl0.from({
            el: this.imgW[this.newNo],
            p: {
              x: [newNoEndDemi, 0]
            },
            d: d1,
            e: e1
          });
          tl0.from({
            el: this.img[this.newNo],
            p: {
              scale: [1.2, 1]
            },
            d: d1,
            e: e1,
            cb: this.cb,
            r: 4
          });
        } else {
          tl0.from({
            el: this.imgW[this.no],
            p: {
              x: [0, noEnd]
            },
            d: dMobile,
            e: eMobile
          });
          tl0.from({
            el: this.imgW[this.newNo],
            p: {
              x: [newNoEnd, 0]
            },
            d: dMobile,
            e: eMobile
          });
          tl0.from({
            el: this.img[this.newNo],
            p: {
              scale: [1.4, 1]
            },
            d: dMobile,
            e: eMobile,
            cb: this.cb,
            r: 4
          });
        } // Z Index


        this.imgW[this.newNo].style.zIndex = 2;
        this.imgW[this.no].style.zIndex = 1; // -------------------------------------------
        // Pagination

        if (this.hasPagination) {
          var currValue = this.newNo + 1;
          var leadingZero = currValue < 10 ? '0' : '';
          this.pagination.textContent = '0' + leadingZero + currValue;
        } // -------------------------------------------
        // Go


        tl0.play();
        tl1.play();
      }
    }, {
      key: "cb",
      value: function cb() {
        this.imgW[this.no].style.zIndex = 1;
        r.T(this.imgW[this.no], -100, 0);
        this.no = this.newNo;
        this.c.outroIsOn = true;
        this.isRunning = false;
      }
    }, {
      key: "videoEnded",
      value: function videoEnded() {
        console.log(this.cursorPlayShow);
        this.cursorPlayShow.play({
          d: 0
        });
        this.cursorPauseShow.play({
          d: 0,
          reverse: true
        });
        this.isPlaying = false;
      }
    }, {
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "resize",
      value: function resize() {
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top; // Desktop

        if (!this.c.isTouch) {
          this.areaTop = areaRectTop + pageYOffset;
          this.areaLeft = areaRect.left;

          if (this.noAreaCenter) {
            this.areaCenterLeft = this.area.offsetWidth / 2;
            this.areaCenterRight = this.areaCenterLeft;
          } else {
            this.areaCenterLeft = this.areaCenter.getBoundingClientRect().left - this.areaLeft;
            this.areaCenterRight = this.areaCenterLeft + this.areaCenter.offsetWidth;
          }

          this.cursor.w = this.cursor.el.main.offsetWidth;
          this.cursor.wDemi = this.cursor.w / 2;
          this.cursor.x.max = this.area.offsetWidth;
          this.cursor.y.max = this.area.offsetHeight; // Mobile
        } else {
          this.areaCenterTop = areaRectTop + pageYOffset;
          this.areaCenterBottom = this.areaCenterTop + this.area.offsetHeight;
        }

        if (this.hasProgress) {
          var progressWWidth = this.progressW.offsetWidth;
          var progressWidth = progressWWidth / this.imgL;
          this.progress.style.width = progressWidth + 'px';
          this.progressStep = progressWidth;
          var progressEnd = r.R(this.progressStep * this.no);
          r.T(this.progress, progressEnd, 0, 'px');
        }

        if (this.c.isDesktop) {
          for (var i = 0; i < this.videoPosters.length; i++) {
            this.videoPosters[i].classList.add('hidden');
          }
        } else {
          this.element.classList.add('needs-poster');

          for (var l = 0; l < this.videoPosters.length; l++) {
            this.videoPosters[l].classList.remove('hidden');
          }
        }

        if (this.c.isTouch) {
          this.element.classList.add('mobile-device');
        } else {
          this.element.classList.remove('mobile-device');
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y);

        if (!this.c.isTouch) {
          // Check if in slider
          var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
          var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
          var cursorIn = xIn && yIn;

          if (cursorIn) {
            cursorIn = !this.c.overPageIsOn;
          }

          if (cursorIn) {
            cursorIn = this.moveTarget.classList.contains(this.areaC);
          }

          if (cursorIn) {
            this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
            this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

            if (!this.cursorIsVisible) {
              this.cursorIsVisible = true;
              this.cursor.x.curr = this.cursor.x.targ;
              this.cursor.y.curr = this.cursor.y.targ;
              this.cursorShow.play();
              this.cursorScale.play();
            }
          } else if (!cursorIn && this.cursorIsVisible) {
            this.cursorIsVisible = false;
            this.cursorIsCenter = undefined;
            this.cursorShow.play({
              reverse: true
            });
            this.cursorScale.play({
              reverse: true
            });
          }

          var cursorXMoving = r.R(this.cursor.x.curr) !== this.cursor.x.targ;
          var cursorYMoving = r.R(this.cursor.y.curr) !== this.cursor.y.targ;
          var cursorMoving = cursorXMoving || cursorYMoving;

          if (cursorMoving || cursorIn) {
            // Direction
            if (this.x > this.areaCenterRight) {
              this.direction = 1;
            } else if (this.x <= this.areaCenterLeft) {
              this.direction = -1;
            } else {
              this.direction = 0;
            } // Change cursor


            this.firstTimeDi = r.Is.und(this.cursorIsCenter);
            var d = this.firstTimeDi ? 0 : 300;

            if (this.direction === 0 && (!this.cursorIsCenter || this.firstTimeDi)) {
              this.cursorIsCenter = true;
              this.cursorArrowShow.play({
                d: d,
                reverse: true
              });

              if (this.isPlaying) {
                this.cursorPauseShow.play({
                  d: d
                });
              } else {
                this.cursorPlayShow.play({
                  d: d
                });
              }
            } else if (this.direction !== 0) {
              if (this.cursorIsCenter || this.firstTimeDi) {
                this.cursorIsCenter = false;
                this.cursorArrowShow.play({
                  d: d
                });

                if (this.isPlaying) {
                  this.cursorPauseShow.play({
                    d: d,
                    reverse: true
                  });
                } else {
                  this.cursorPlayShow.play({
                    d: d,
                    reverse: true
                  });
                }
              }

              if (this.direction === 1) {
                this.cursor.el.arrow.style.transform = 'rotate(0deg)';
              } else {
                this.cursor.el.arrow.style.transform = 'rotate(180deg)';
              }
            }

            this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
            this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
            r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
          }
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (!this.c.isTouch) {
          this.moveDesktop(x, y, target); // -----------------------
          // Mobile
          // -----------------------
        } else if (this.c.isSliding) {
          // if (this.isHomeHero) {
          if (target === this.area) {
            this.moveMobile(x, y, target);
          }
        }
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "moveMobile",
      value: function moveMobile(x, y, target) {
        var deltaY = y - this.start.y + pageYOffset;
        var deltaX = x - this.start.x;
        if (Math.abs(deltaX) < 30 || Math.abs(deltaY) > Math.abs(deltaX) || this.alreadySlided) return;
        this.alreadySlided = true;
        this.direction = deltaX > 0 ? -1 : 1;
        this.slide();
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        var max = this.cursor[type].max - this.cursor.w;
        var min = this.cursor[type].min;
        return r.R(r.Clamp(v, min, max));
      }
    }]);

    return MediaSlideshow;
  }();

  var ThreeUp =
  /*#__PURE__*/
  function () {
    function ThreeUp(element) {
      _classCallCheck(this, ThreeUp);

      this.c = _C;
      this.element = element;

      if (this.c.isMobile) {
        this.slider = new Slider1({
          parent: '.three-up-content',
          element: element
        });
      }
    }

    _createClass(ThreeUp, [{
      key: "on",
      value: function on() {
        if (this.slider) {
          this.slider.on();
        }
      }
    }, {
      key: "off",
      value: function off() {
        if (this.slider) {
          this.slider.off();
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.slider) {
          this.slider.resize();
        } else if (!this.slider && this.c.isMobile) {
          this.slider = new Slider1({
            parent: '.three-up-content',
            element: this.element
          });
        } else {
          this.slider = null;
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (this.slider) {
          this.slider.loop();
        }
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (this.slider) {
          this.slider.move(x, y, target);
        }
      }
    }]);

    return ThreeUp;
  }();

  var SingleMedia =
  /*#__PURE__*/
  function () {
    function SingleMedia(element) {
      _classCallCheck(this, SingleMedia);

      this.c = _C;
      this.element = element;
      this.isVideo = r.G.tag('video', element)[0];

      if (this.isVideo) {
        this.area = r.G["class"]('video-interaction-area', this.element)[0];
        if (r.Is.und(this.area)) return;
        this.videoPlayer = r.G.id('single-video');
        this.videoPoster = r.G.id('video-poster');
        this.isPlaying = false;
        r.BM(this, ['playVideo', 'mouseEnter', 'videoEnded']);
        this.cursorIsVisible = false;
        this.x = -1;
        this.y = -1;
        this.cursor = {
          x: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          y: {
            targ: 0,
            curr: 0,
            max: 0,
            min: 0
          },
          el: {}
        };
        this.cursor.el.main = r.G["class"]('slider-cursor', this.element)[0];
        this.cursor.el.play = r.G["class"]('slider-cursor-play', this.element)[0];
        this.cursor.el.pause = r.G["class"]('slider-cursor-pause', this.element)[0];
        this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.element)[0];
        this.cursorShow = new r.M({
          el: this.cursor.el.main,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorScale = new r.M({
          el: this.cursor.el.bg,
          p: {
            scale: [0.9, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorPlayShow = new r.M({
          el: this.cursor.el.play,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });
        this.cursorPauseShow = new r.M({
          el: this.cursor.el.pause,
          p: {
            opacity: [0, 1]
          },
          d: 300,
          e: 'o2'
        });

        if (!this.c.isTouch) {
          this.videoPoster.classList.add('hidden');
        } else {
          this.element.classList.add('mobile-device');
        }
      }
    }

    _createClass(SingleMedia, [{
      key: "on",
      value: function on() {
        if (!this.isVideo) return;
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        if (!this.isVideo) return;
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (!this.isVideo) return;

        if (!this.c.isTouch) {
          r.L(this.area, a, 'mouseover', this.mouseEnter);
        }

        r.L(this.area, a, 'click', this.playVideo);
        r.L(this.videoPlayer, a, 'ended', this.videoEnded);
      }
    }, {
      key: "resize",
      value: function resize() {
        if (!this.isVideo) return;
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top;
        this.areaTop = areaRectTop + pageYOffset;
        this.areaLeft = areaRect.left;
        this.cursor.w = this.cursor.el.main.offsetWidth;
        this.cursor.wDemi = this.cursor.w / 2;
        this.cursor.x.max = this.area.offsetWidth;
        this.cursor.y.max = this.area.offsetHeight;

        if (!this.c.isTouch) {
          this.videoPoster.classList.add('hidden');
        } else {
          this.element.classList.add('mobile-device');
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        if (!this.isVideo) return;
        var x = r.R(this.x);
        var y = r.R(this.y); // Check if over video

        var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
        var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
        var cursorIn = xIn && yIn;

        if (cursorIn) {
          cursorIn = !this.c.overPageIsOn;
        }

        if (cursorIn) {
          this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
          this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

          if (!this.cursorIsVisible) {
            this.cursorIsVisible = true;
            this.cursor.x.curr = this.cursor.x.targ;
            this.cursor.y.curr = this.cursor.y.targ;
            this.cursorShow.play();
            this.cursorScale.play();

            if (this.isPlaying) {
              this.cursorPauseShow.play({
                d: 0
              });
            } else {
              this.cursorPlayShow.play({
                d: 0
              });
            }
          }
        } else if (!cursorIn && this.cursorIsVisible) {
          this.cursorIsVisible = false;
          this.cursorShow.play({
            reverse: true
          });
          this.cursorScale.play({
            reverse: true
          });

          if (this.isPlaying) {
            this.cursorPauseShow.play({
              d: 0,
              reverse: true
            });
          } else {
            this.cursorPlayShow.play({
              d: 0,
              reverse: true
            });
          }
        }

        this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
        this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
        r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        if (!this.isVideo) return;
        this.moveDesktop(x, y, target);
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "playVideo",
      value: function playVideo(e) {
        if (this.c.isTouch) {
          if (this.videoPlayer.requestFullScreen) {
            this.videoPlayer.requestFullScreen();
          } else if (this.videoPlayer.webkitRequestFullScreen) {
            this.videoPlayer.webkitRequestFullScreen();
          } else if (this.videoPlayer.mozRequestFullScreen) {
            this.videoPlayer.mozRequestFullScreen();
          }

          this.videoPlayer.play();
        } else {
          this.videoPlayer.controls = false;

          if (this.videoPlayer.paused) {
            this.videoPlayer.play();
            this.cursorPlayShow.play({
              d: 0,
              reverse: true
            });
            this.cursorPauseShow.play({
              d: 0
            });
            this.isPlaying = true;
          } else {
            this.videoPlayer.pause();
            this.cursorPlayShow.play({
              d: 0
            });
            this.cursorPauseShow.play({
              d: 0,
              reverse: true
            });
            this.isPlaying = false;
          }

          var _this = this;

          setTimeout(function () {
            _this.videoPlayer.controls = true;
          }, 0);
        }
      }
    }, {
      key: "videoEnded",
      value: function videoEnded() {
        this.cursorPlayShow.play({
          d: 0
        });
        this.cursorPauseShow.play({
          d: 0,
          reverse: true
        });
        this.isPlaying = false;

        if (this.c.isMobile) {
          this.videoPoster.classList.remove('hidden');
        }
      }
    }, {
      key: "mouseEnter",
      value: function mouseEnter() {
        if (!this.isVideo) return;
        this.areaTop = this.area.getBoundingClientRect().top + pageYOffset;
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }]);

    return SingleMedia;
  }();

  var SignInStandAlone =
  /*#__PURE__*/
  function () {
    function SignInStandAlone(element) {
      _classCallCheck(this, SignInStandAlone);

      this.c = _C;
      this.element = element;
      r.BM(this, ['on', 'off', 'showForgotPassword', 'showSignIn']);
      this.forgotPasswordLink = r.G["class"]('forgot-switch', this.element)[0];
      this.forgotPassword = r.G["class"]('forgot-password-standalone', document)[0];
      this.forgotPassword.classList.add('hidden');
      this.signIn = r.G.id('forgot-sign-in-standalone');
    }

    _createClass(SignInStandAlone, [{
      key: "on",
      value: function on() {
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        r.L(this.forgotPasswordLink, a, 'click', this.showForgotPassword);
        r.L(this.signIn, a, 'click', this.showSignIn);
      }
    }, {
      key: "showForgotPassword",
      value: function showForgotPassword() {
        this.forgotPassword.classList.remove('hidden');
        var tl = new r.TL();
        tl.from({
          el: this.element,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o3'
        });
        tl.from({
          el: this.forgotPassword,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3',
          delay: 300
        });
        tl.play();
      }
    }, {
      key: "showSignIn",
      value: function showSignIn() {
        this.forgotPassword.classList.add('hidden');
        var tl = new r.TL();
        tl.from({
          el: this.forgotPassword,
          p: {
            opacity: [1, 0]
          },
          d: 300,
          e: 'o3'
        });
        tl.from({
          el: this.element,
          p: {
            opacity: [0, 1]
          },
          d: 500,
          e: 'o3',
          delay: 300
        });
        tl.play();
      }
    }]);

    return SignInStandAlone;
  }();

  var VideoLightbox =
  /*#__PURE__*/
  function () {
    function VideoLightbox() {
      _classCallCheck(this, VideoLightbox);

      this.c = _C;
      r.BM(this, ['open', 'close', 'populateSource']);
      this.videoLightbox = r.G.id('video-lightbox');
      this.videoWrapper = r.G.id('video-lightbox-wrapper');
      this.video = r.G.id('video');
      this.closeButton = r.G.id('video-close');
      this.videoShow = new r.M({
        el: this.videoWrapper,
        p: {
          opacity: [0, 1]
        },
        d: 500,
        e: 'o2'
      });
      this.closeShow = new r.M({
        el: this.closeButton,
        p: {
          opacity: [0, 1]
        },
        d: 500,
        e: 'o2'
      });
    }

    _createClass(VideoLightbox, [{
      key: "open",
      value: function open() {
        var _this = this;

        if (this.c.isDesktop) ;

        r.T(this.videoLightbox, 0, 0);
        this.c.overPage.videoShow();
        this.videoShow.play({
          delay: 400
        });
        this.closeShow.play({
          delay: 400
        });
        setTimeout(function (_) {
          _this.playVideo();

          _this.resetVideo();
        }, 900);
        this.closeButton.addEventListener('click', this.close);
      }
    }, {
      key: "close",
      value: function close() {
        var _this2 = this;

        if (this.c.isDesktop) ;

        setTimeout(function (_) {
          r.T(_this2.videoLightbox, -100, 0);

          _this2.source.remove();

          _this2.source = null;
        }, 500);
        this.pauseVideo();
        this.c.overPage.hide();
        this.videoShow.play({
          delay: 0,
          reverse: true
        });
        this.closeShow.play({
          delay: 0,
          reverse: true
        });
        this.closeButton.removeEventListener('click', this.close);
      }
    }, {
      key: "playVideo",
      value: function playVideo() {
        this.video.play();
      }
    }, {
      key: "pauseVideo",
      value: function pauseVideo() {
        this.video.pause();
      }
    }, {
      key: "resetVideo",
      value: function resetVideo() {
        this.video.currentTime = 0;
      }
    }, {
      key: "populateSource",
      value: function populateSource(src) {
        this.source = document.createElement('source');
        this.source.setAttribute('src', src);
        this.video.appendChild(this.source);
      }
    }]);

    return VideoLightbox;
  }();

  var VideoText =
  /*#__PURE__*/
  function () {
    function VideoText(element) {
      var _this = this;

      _classCallCheck(this, VideoText);

      this.c = _C;
      this.isSupported = true;
      if (r.Snif.isSafari) this.isSupported = false;
      if (this.c.isTouch) this.isSupported = false;
      if (r.Snif.isIE11) this.isSupported = false;
      if (r.Snif.isEdge) this.isSupported = false;
      if (!this.isSupported) element.classList.add('unsupported');
      r.BM(this, ['playVideo', 'mouseEnter']);
      this.element = element;
      this.svg = r.G.tag('svg', element)[0];
      this.clipPath = r.G.tag('clipPath', element)[0];
      var id = Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
      this.clipPath.id = id;
      this.video = r.G.tag('video', element)[0];
      this.video.style.setProperty('clip-path', 'url(#' + this.clipPath.id + ')');
      var textContainer = r.G["class"]('text-container', element)[0];
      var text = textContainer.innerHTML;
      this.words = text.split(' ');
      textContainer.innerHTML = this.words.map(function (t) {
        return "<span>".concat(t, "</span>");
      }).join(' ');
      this.spans = r.G.tag('span', textContainer);
      this.isMobileLayout = innerWidth <= 768;
      this.area = r.G["class"]('video-text-interaction-area', this.element)[0];
      this.cursorIsVisible = false;
      this.x = -1;
      this.y = -1;
      this.cursor = {
        x: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        y: {
          targ: 0,
          curr: 0,
          max: 0,
          min: 0
        },
        el: {}
      };
      this.cursor.el.main = r.G["class"]('slider-cursor', this.element)[0];
      this.cursor.el.play = r.G["class"]('slider-cursor-play', this.element)[0];
      this.cursor.el.bg = r.G["class"]('slider-cursor-bg', this.element)[0];
      this.cursorShow = new r.M({
        el: this.cursor.el.main,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorScale = new r.M({
        el: this.cursor.el.bg,
        p: {
          scale: [0.9, 1]
        },
        d: 300,
        e: 'o2'
      });
      this.cursorPlayShow = new r.M({
        el: this.cursor.el.play,
        p: {
          opacity: [0, 1]
        },
        d: 300,
        e: 'o2'
      });

      if (r.G.id('home')) {
        this.cursor.el.main.classList.remove('slider-cursor-dark');
        this.cursor.el.main.classList.add('slider-cursor-light');
      }

      setTimeout(function (_) {
        _this.buildSvg();
      }, 1000);
    }

    _createClass(VideoText, [{
      key: "buildSvg",
      value: function buildSvg(isResizing) {
        if (!this.isSupported) return;
        this.clipPath.innerHTML = '';
        var starts = [0];
        var ends = [];
        var spans = this.spans;
        var spanLength = spans.length;
        var prevY = 0;

        for (var i = 0; i < spanLength; i++) {
          var rect = spans[i].getBoundingClientRect();
          if (i === 0) prevY = rect.y;

          if (rect.y > prevY) {
            starts.push(i);
            ends.push(i - 1);
          }

          prevY = rect.y;
        }

        ends.push(spanLength - 1);
        this.lineLength = starts.length;

        for (var _i = 0; _i < this.lineLength; _i++) {
          var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          text.setAttribute('x', 0);
          text.innerHTML = this.words.slice(starts[_i], ends[_i] + 1).join(' ');
          this.clipPath.appendChild(text);
        }

        this.video.classList.add('clipped');
        if (!isResizing) this.resize();
      }
    }, {
      key: "on",
      value: function on() {
        console.log('ON');
        this.l('a');
      }
    }, {
      key: "off",
      value: function off() {
        console.log('OFFFF');
        this.l('r');
      }
    }, {
      key: "l",
      value: function l(a) {
        if (!this.c.isTouch) {
          r.L(this.area, a, 'click', this.playVideo);
          r.L(this.area, a, 'mouseover', this.mouseEnter);
        } else {
          r.L(this.area, a, 'touchend', this.playVideo);
        }
      }
    }, {
      key: "resize",
      value: function resize(secondTime) {
        var areaRect = this.area.getBoundingClientRect();
        var areaRectTop = areaRect.top;
        this.areaTop = areaRectTop + pageYOffset;
        this.areaLeft = areaRect.left;
        this.cursor.w = this.cursor.el.main.offsetWidth;
        this.cursor.wDemi = this.cursor.w / 2;
        this.cursor.x.max = this.area.offsetWidth;
        this.cursor.y.max = this.area.offsetHeight;
        if (!this.isSupported) return;

        if (innerWidth <= 768 && !this.isMobileLayout) {
          this.isMobileLayout = true;
          this.buildSvg(true);
        } else if (innerWidth > 768 && this.isMobileLayout) {
          this.isMobileLayout = false;
          this.buildSvg(true);
        }

        var initialOffset = 64;
        var lineHeightBase = 80;
        var scaleMultiple = innerWidth / 1440;

        if (innerWidth <= 768) {
          initialOffset = 24;
          lineHeightBase = 40;
          scaleMultiple = innerWidth / 375;
        }

        for (var i = 0; i < this.lineLength; i++) {
          var y = scaleMultiple * (initialOffset + lineHeightBase * i);
          var text = this.clipPath.children[i];
          text.setAttribute('y', Math.round(y * 100) / 100);
        }
      }
    }, {
      key: "loop",
      value: function loop() {
        var x = r.R(this.x);
        var y = r.R(this.y); // Check if over video

        var xIn = x <= this.cursor.x.max && x >= this.cursor.x.min;
        var yIn = y <= this.cursor.y.max && y >= this.cursor.y.min;
        var cursorIn = xIn && yIn;

        if (cursorIn) {
          cursorIn = !this.c.overPageIsOn;
        }

        if (cursorIn) {
          this.cursor.x.targ = this.minMax(x - this.cursor.wDemi, 'x');
          this.cursor.y.targ = this.minMax(y - this.cursor.wDemi, 'y');

          if (!this.cursorIsVisible) {
            this.cursorIsVisible = true;
            this.cursor.x.curr = this.cursor.x.targ;
            this.cursor.y.curr = this.cursor.y.targ;
            this.cursorShow.play();
            this.cursorScale.play();
            this.cursorPlayShow.play({
              d: 0
            });
          }
        } else if (!cursorIn && this.cursorIsVisible) {
          this.cursorIsVisible = false;
          this.cursorShow.play({
            reverse: true
          });
          this.cursorScale.play({
            reverse: true
          });
          this.cursorPlayShow.play({
            d: 0,
            reverse: true
          });
        }

        this.cursor.x.curr += (this.cursor.x.targ - this.cursor.x.curr) * 0.30;
        this.cursor.y.curr += (this.cursor.y.targ - this.cursor.y.curr) * 0.30;
        r.T(this.cursor.el.main, r.R(this.cursor.x.curr), r.R(this.cursor.y.curr), 'px');
      }
    }, {
      key: "move",
      value: function move(x, y, target) {
        this.moveDesktop(x, y, target);
      }
    }, {
      key: "moveDesktop",
      value: function moveDesktop(x, y, target) {
        this.x = x - this.areaLeft;
        this.y = y - this.areaTop;
        this.moveTarget = target;
      }
    }, {
      key: "playVideo",
      value: function playVideo(e) {
        var fullVideo = this.element.dataset.fullVideo;

        if (fullVideo && fullVideo.length) {
          this.c.videoLightbox.populateSource(fullVideo);
          this.c.videoLightbox.open();
        }
      }
    }, {
      key: "mouseEnter",
      value: function mouseEnter() {
        this.areaTop = this.area.getBoundingClientRect().top + pageYOffset;
      }
    }, {
      key: "minMax",
      value: function minMax(v, type) {
        return v; // const max = this.cursor[type].max - this.cursor.w
        // const min = this.cursor[type].min
        // return R.R(R.Clamp(v, min, max))
      }
    }]);

    return VideoText;
  }();

  // import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'
  var SmoothScroll =
  /*#__PURE__*/
  function () {
    function SmoothScroll(target, speed, smooth) {
      _classCallCheck(this, SmoothScroll);

      this.target = target;

      if (target === document) {
        this.target = document.documentElement || document.body.parentNode || document.body; // cross browser support for document scrolling
      }

      this.speed = speed;
      this.smooth = smooth;
      this.calculatedScroll = 0;
      this.moving = false;
      this.wheelTarget = pageYOffset;
      this.paginateTarget = 0;
      this.scrollingDown = true;
      this.touchY = 0;
      this.deltaTouch = 0;
      this.isScrollingDisabled = false;
      this.isTouching = false;

      this.requestFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (func) {
        window.setTimeout(func, 1000 / 50);
      };

      this.requestFrame = this.requestFrame.bind(window);
      this.preventDefaultForScrollKeys = this.preventDefaultForScrollKeys.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onWheel = this.onWheel.bind(this);
      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);
      target.addEventListener('mousewheel', this.onWheel, {
        capture: false,
        passive: false
      });
      target.addEventListener('DOMMouseScroll', this.onWheel, {
        capture: false,
        passive: false
      });
      target.addEventListener('touchstart', this.onTouchStart, false);
      target.addEventListener('touchmove', this.onTouchMove, false);
      target.addEventListener('touchend', this.onTouchEnd, false);
      addEventListener('scroll', this.onScroll); // addEventListener('resize', onResize)
    }

    _createClass(SmoothScroll, [{
      key: "scrollToY",
      value: function scrollToY(y, animated) {
        if (animated) {
          this.wheelTarget = y;
          if (!this.moving) this.update();
        } else {
          var delta = y - this.calculatedScroll;
          this.scrollingDown = delta > 0;
          this.calculatedScroll = y;
          this.wheelTarget = this.calculatedScroll;
          scrollTo(0, y);
        }
      }
    }, {
      key: "reset",
      value: function reset() {
        this.calculatedScroll = pageYOffset;
        this.wheelTarget = this.calculatedScroll;
      }
    }, {
      key: "preventDefault",
      value: function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      }
    }, {
      key: "preventDefaultForScrollKeys",
      value: function preventDefaultForScrollKeys(e) {
        // left: 37, up: 38, right: 39, down: 40,
        // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
        var keys = {
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 1
        };

        if (keys[e.keyCode]) {
          if (!document.activeElement.form) {
            this.preventDefault(e);
            return false;
          }
        }
      }
    }, {
      key: "enableScrolling",
      value: function enableScrolling() {
        if (!this.isScrollingDisabled) return;
        document.onkeydown = null; // enableBodyScroll

        this.isScrollingDisabled = false;
      }
    }, {
      key: "disableScrolling",
      value: function disableScrolling() {
        if (this.isScrollingDisabled) return; // disableBodyScroll

        document.onkeydown = this.preventDefaultForScrollKeys;
        this.isScrollingDisabled = true;
      }
    }, {
      key: "onTouchStart",
      value: function onTouchStart(e) {
        if (e.changedTouches.length === 1) {
          this.reset();
          this.touchY = e.changedTouches[0].screenY;
          this.deltaTouch = 0;
        }

        this.isTouching = true;
      }
    }, {
      key: "onTouchMove",
      value: function onTouchMove(e) {
        if (e.changedTouches.length === 1) {
          var prevY = this.touchY;
          this.touchY = e.changedTouches[0].screenY;
          this.deltaTouch += this.touchY - prevY;
        }
      }
    }, {
      key: "onTouchEnd",
      value: function onTouchEnd(e) {
        this.isTouching = e.touches.length;
      }
    }, {
      key: "onWheel",
      value: function onWheel(e) {
        e.preventDefault(); // disable default scrolling

        if (this.isScrollingDisabled) return;
        if (this.isHorizontal(e)) return;
        var delta = this.normalizeWheelDelta(e);
        this.wheelTarget += delta * this.speed;
        this.wheelTarget = Math.max(0, Math.min(this.wheelTarget, this.target.scrollHeight - this.target.clientHeight)); // limit scrolling

        if (!this.moving) this.update();
      }
    }, {
      key: "normalizeWheelDelta",
      value: function normalizeWheelDelta(e) {
        if (e.detail) {
          if (e.wheelDelta) {
            return -e.wheelDelta / e.detail / 40 * (e.detail > 0 ? 1 : -1); // Opera
          } else {
            return e.detail / 3; // Firefox
          }
        } else {
          return -e.wheelDelta / 120; // IE,Safari,Chrome
        }
      }
    }, {
      key: "isHorizontal",
      value: function isHorizontal(e) {
        if (e.deltaX || e.deltaY) {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            return true;
          }
        }

        if (e.wheelDeltaX || e.wheelDeltaY) {
          if (Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY)) {
            return true;
          }
        }

        return false;
      }
    }, {
      key: "update",
      value: function update(timestamp) {
        if (!timestamp) {
          this.moving = true;
        }

        if (!this.moving) return;
        var prevScrollTop = this.calculatedScroll;
        var delta = (this.wheelTarget - prevScrollTop) / this.smooth;
        var newScrollTop = prevScrollTop + delta;
        this.calculatedScroll = newScrollTop;
        this.scrollingDown = delta > 0;
        scrollTo(0, newScrollTop);

        if (Math.abs(newScrollTop - prevScrollTop) > 0.25 / this.smooth) {
          this.requestFrame(this.update);
        } else {
          this.calculatedScroll = this.wheelTarget;
          scrollTo(0, this.wheelTarget);
          this.moving = false;
        }
      }
    }, {
      key: "onScroll",
      value: function onScroll(e) {
        if (!this.isTouching && !this.moving) {
          this.reset();
        }
      }
    }]);

    return SmoothScroll;
  }();

  var HorizontalScroll =
  /*#__PURE__*/
  function () {
    function HorizontalScroll(target) {
      _classCallCheck(this, HorizontalScroll);

      this.target = target;

      if (target === document) {
        this.target = document.documentElement || document.body.parentNode || document.body; // cross browser support for document scrolling
      }

      this.c = _C;
      this.scrollFunctions = [];
      this.onWheel = this.onWheel.bind(this);
      target.addEventListener('mousewheel', this.onWheel, {
        capture: false,
        passive: false
      });
      target.addEventListener('DOMMouseScroll', this.onWheel, {
        capture: false,
        passive: false
      });
    }

    _createClass(HorizontalScroll, [{
      key: "registerScroll",
      value: function registerScroll(func) {
        this.scrollFunctions.push(func);
      }
    }, {
      key: "onWheel",
      value: function onWheel(e) {
        if (!this.isHorizontal(e)) return;
        this.scrollFunctions.forEach(function (func) {
          func(-e.wheelDelta, e.target);
        });
      }
    }, {
      key: "normalizeWheelDelta",
      value: function normalizeWheelDelta(e) {
        if (e.detail) {
          if (e.wheelDelta) {
            return -e.wheelDelta / e.detail / 40 * (e.detail > 0 ? 1 : -1) * 3; // Opera
          } else {
            return e.detail / 3 * 3; // Firefox
          }
        } else {
          return -e.wheelDelta / 120 * 3; // IE,Safari,Chrome
        }
      }
    }, {
      key: "isHorizontal",
      value: function isHorizontal(e) {
        if (e.deltaX || e.deltaY) {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            return true;
          }
        }

        if (e.wheelDeltaX || e.wheelDeltaY) {
          if (Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY)) {
            return true;
          }
        }

        return false;
      }
    }]);

    return HorizontalScroll;
  }();

  var TextModal =
  /*#__PURE__*/
  function () {
    function TextModal() {
      _classCallCheck(this, TextModal);

      this.c = _C;
      r.BM(this, ['open', 'close', 'populate']);
      this.modal = r.G.id('text-modal');
      this.wrapper = r.G.id('text-modal-wrapper');
      this.closeButton = r.G.id('text-modal-close');
      this.title = r.G.tag('h2', this.wrapper)[0];
      this.body = r.G.tag('div', this.wrapper)[0];
      this.wrapperShow = new r.M({
        el: this.wrapper,
        p: {
          opacity: [0, 1]
        },
        d: 500,
        e: 'o2'
      });
      this.closeShow = new r.M({
        el: this.closeButton,
        p: {
          opacity: [0, 1]
        },
        d: 500,
        e: 'o2'
      });
    }

    _createClass(TextModal, [{
      key: "open",
      value: function open() {
        if (this.c.isDesktop) ;

        r.T(this.modal, 0, 0);
        this.c.overPage.textModalShow();
        this.wrapperShow.play({
          delay: 400
        });
        this.closeShow.play({
          delay: 400
        }); // setTimeout(_ => {
        //     this.playVideo()
        //     this.resetVideo()
        // }, 900)

        this.closeButton.addEventListener('click', this.close);
      }
    }, {
      key: "close",
      value: function close() {
        if (this.c.isDesktop) ; // this.c.scroll.on({reset: false})
        // setTimeout(_ => {
        //     R.T(this.videoLightbox, -100, 0)
        //     this.source.remove()
        //     this.source = null
        // }, 500)
        // this.pauseVideo()


        this.c.overPage.hide();
        this.wrapperShow.play({
          delay: 0,
          reverse: true
        });
        this.closeShow.play({
          delay: 0,
          reverse: true
        });
        this.closeButton.removeEventListener('click', this.close);
      }
    }, {
      key: "populate",
      value: function populate(title, body) {
        this.title.innerHTML = title;
        var markdown = marked(body);
        this.body.innerHTML = markdown;
        var uls = Array.from(r.G.tag('ul', this.body));

        if (uls.length > 0) {
          var children = Array.from(this.body.children);
          var index = children.indexOf(uls[0]);

          if (index > 0) {
            var prev = children[index - 1];
            var prevTag = prev.tagName;

            switch (prevTag) {
              case 'H1':
              case 'H2':
              case 'H3':
                index = index - 1;
                break;

              case 'P':
                if (prev.innerHTML.split(' ').length < 6) {
                  index = index - 1;
                }

                break;
            }
          }

          var splitUlIndex = Math.ceil(uls.length / 2) - 1;
          var splitIndex = children.indexOf(uls[splitUlIndex]);
          var lastIndex = children.indexOf(uls[uls.length - 1]);
          var left = document.createElement('div');
          left.className = 'column';

          for (var i = index; i <= splitIndex; i++) {
            left.appendChild(children[i]);
          }

          this.body.appendChild(left);

          if (splitIndex < lastIndex) {
            var right = document.createElement('div');
            right.className = 'column';

            for (var _i = splitIndex + 1; _i <= lastIndex; _i++) {
              right.appendChild(children[_i]);
            }

            this.body.appendChild(right);
          }
        }
      } // playVideo () {
      //     this.video.play()
      // }
      //
      // pauseVideo () {
      //     this.video.pause()
      // }
      //
      // resetVideo () {
      //     this.video.currentTime = 0
      // }
      //
      // populateSource (src) {
      //     this.source = document.createElement('source')
      //     this.source.setAttribute('src', src)
      //     this.video.appendChild(this.source)
      // }

    }]);

    return TextModal;
  }();

  var TertiaryHeader =
  /*#__PURE__*/
  function () {
    function TertiaryHeader(element) {
      _classCallCheck(this, TertiaryHeader);

      this.spanSplit = new SpanSplit({
        elClass: 'tertiary-header-title',
        parent: element
      });
      this.spanSplit.init();
      this.header = element.getElementsByClassName('tertiary-header-title')[0];
      this.outerSpans = [];
      this.innerSpans = [];
      var spans = element.getElementsByTagName('span');

      for (var i = spans.length - 1; i >= 0; i--) {
        var inner = spans[i].innerHTML;
        spans[i].innerHTML = '<span>' + inner + '</span>';
        this.outerSpans.push(spans[i]);
        this.innerSpans.push(spans[i].getElementsByTagName('span')[0]);
      }
    }

    _createClass(TertiaryHeader, [{
      key: "resize",
      value: function resize() {
        var _this = this;

        if (this.timeout) clearTimeout(this.timeout);
        this.scale = 100;
        this.outerSpans.forEach(function (span) {
          span.style.fontSize = _this.scale + '%';
        });
        this.checkSizing();
      }
    }, {
      key: "checkSizing",
      value: function checkSizing() {
        var _this2 = this;

        var fits = true;

        for (var i = 0; i < this.innerSpans.length; i++) {
          fits = fits && this.innerSpans[i].clientWidth < this.outerSpans[i].clientWidth;
        }

        if (!fits) {
          this.scale -= 12.5;
          this.outerSpans.forEach(function (span) {
            span.style.fontSize = _this2.scale + '%';
          });
          this.checkSizing();
        }
      }
    }]);

    return TertiaryHeader;
  }();

  var _Listener =
  /*#__PURE__*/
  function () {
    function _Listener() {
      _classCallCheck(this, _Listener);

      this.c = _C;
      this.isDesktop = this.c.isDesktop;
      this.c.sideBarIsOpen = {};
      r.BM(this, ['move', 'resize', 'loop']);
      this.ro = new r.RO({
        cb: this.resize,
        throttleDelay: 100
      });
      this.raf = new r.Raf(this.loop);
      this.mm = new r.MM({
        cb: this.move
      });
      this.c.smoothScroll = new SmoothScroll(document, 90, 9);
      this.c.horizontalScroll = new HorizontalScroll(document);
      this.c.cart = new GlobalCart();
      this.c.topNav = new TopNav();
      this.c.lightbox = new Lightbox();
      this.mobileMenu = new MobileMenu();
      this.c.videoLightbox = new VideoLightbox();
      this.c.textModal = new TextModal();
      this.c.cartSidebar = new SideBar({
        moduleName: 'cart',
        triggerClass: 'top-nav-link-cart'
      });
      this.c.signinSidebar = new SideBar({
        moduleName: 'sign',
        triggerClass: 'top-nav-link-login'
      });
      this.alsoBought = new Slider0({
        parent: '.also-bought-slider'
      });
      this.logos = new Slider0({
        parent: '.logos-slider'
      });
      this.popin = new Popin();
      this.c.search = new Search();
      this.productCarouselHeroSplit = new SpanSplit({
        elClass: 'product-carousel-hero-primary'
      });

      if (r.Snif.isMobile) {
        this.mobileSS = new MobileSS();
      }

      this.modules = {};
    }

    _createClass(_Listener, [{
      key: "init",
      value: function init() {
        this.mm.off();
        this.raf.stop();

        if (r.Snif.isMobile) {
          this.mobileSS.init();
        }

        this.c.cartSidebar.init();
        this.c.signinSidebar.init();
        this.alsoBought.init();
        this.logos.init();
        SearchResults$1.init();
        this.popin.init();
        this.c.search.init();
        this.productCarouselHeroSplit.init(); // -----------------------
        // Resize
        // -----------------------

        this.resize();
        this.ro.on();
      }
    }, {
      key: "createModules",
      value: function createModules(page) {
        var subpage = r.G["class"]('subpage', page)[0];
        var p = subpage || page;
        var modulesId = page.dataset.modulesId;
        this.modules[modulesId] = [];
        this.currentModulesId = modulesId;

        if (page.id === 'account-page') {
          this.modules[modulesId].push(new AccountPage(page, this.popin));
        }

        for (var i = 0; i < p.children.length; i++) {
          var module = this.createModule(p.children[i]);

          if (module) {
            this.modules[modulesId].push(module);
          }
        } // Subpage Nav isn't inside 'page' or 'subpage'


        if (subpage) {
          var subpageMobileNav = r.G["class"]('subpage-nav-w', page)[0];

          var _module = this.createModule(subpageMobileNav);

          if (_module) {
            this.modules[modulesId].push(_module);
          }
        }
      }
    }, {
      key: "destroyModules",
      value: function destroyModules(page) {
        var modulesId = page.dataset.modulesId;
        this.modules[modulesId].forEach(function (module) {
          if (module.deinit) {
            module.deinit();
          }
        });
        delete this.modules[modulesId];
      }
    }, {
      key: "createModule",
      value: function createModule(element) {
        for (var i = 0; i < element.classList.length; i++) {
          switch (element.classList[i]) {
            case 'simple-product':
              return new SimpleProductBuy(element);

            case 'pack-config':
              return new PackConfigurationBuy(element);

            case 'editorial-copy-w':
              return new EditorialCopy(element);

            case 'product-grid':
              return new ProductGrid(element);

            case 'editorial-photo-strip':
              return new EditorialPhotoStrip(element);

            case 'subpage-nav-w':
              return new MobileNav(element);

            case 'home-hero-w':
              return new HomeHero(element);

            case 'product-carousel-w':
              return new ProductCarouselHero(element);

            case 'media-slideshow-w':
              return new MediaSlideshow(element);
            // case 'also-bought':
            //     return new AlsoBought(element)
            // case 'logos':
            //     return new Logos(element)

            case 'three-up-w':
              return new ThreeUp(element);

            case 'reviews-questions-w':
              return new ReviewQuestion(element);

            case 'single-media':
              return new SingleMedia(element);

            case 'sign-in-standalone':
              return new SignInStandAlone(element);

            case 'video-text':
              return new VideoText(element);

            case 'material-features-w':
              return new MaterialFeatures(element);

            case 'materials-list':
              return new MaterialsList(element);

            case 'collapsible-copy-w':
              return new CollapsibleCopy(element);

            case 'tertiary-header-w':
              return new TertiaryHeader(element);

            default:
              break;
          }
        }

        return undefined;
      }
    }, {
      key: "resize",
      value: function resize() {
        this.c.lightbox.resize();
        this.alsoBought.resize();
        this.logos.resize();
        this.c.search.resize();
        this.mobileMenu.resize();
        this.modules[this.currentModulesId].forEach(function (module) {
          if (module.resize) module.resize();
        });
      }
    }, {
      key: "on",
      value: function on() {
        this.c.topNav.on();
        this.c.lightbox.on();
        this.alsoBought.on();
        this.logos.on();
        this.raf.run();
        this.mm.on();
        SearchResults$1.on();
        Form$1.on();
        this.popin.on();
        this.c.cartSidebar.on();
        this.c.signinSidebar.on();
        this.c.search.on();
        this.mobileMenu.on();

        if (r.Snif.isMobile) {
          this.mobileSS.on();
        }

        this.modules[this.currentModulesId].forEach(function (module) {
          if (module.on) module.on();
        });
      }
    }, {
      key: "off",
      value: function off() {
        this.c.topNav.off();
        this.c.lightbox.off();
        this.ro.off();
        this.alsoBought.off();
        this.logos.off();
        SearchResults$1.off();
        Form$1.off();
        this.popin.off();
        this.c.cartSidebar.off();
        this.c.signinSidebar.off();
        this.c.search.off();
        this.mobileMenu.off();

        if (r.Snif.isMobile) {
          this.mobileSS.off();
        }

        this.modules[this.currentModulesId].forEach(function (module) {
          if (module.off) module.off();
        });
      }
    }, {
      key: "loop",
      value: function loop() {
        this.c.lightbox.loop();
        this.alsoBought.loop();
        this.logos.loop();
        this.modules[this.currentModulesId].forEach(function (module) {
          if (module.loop) module.loop();
        });
      }
    }, {
      key: "move",
      value: function move(x, y, e) {
        var target = e.target;

        if (!this.c.overPageIsOn) {
          this.c.lightbox.move(x, y, target);
          this.alsoBought.move(x, y);
          this.logos.move(x, y);
          this.modules[this.currentModulesId].forEach(function (module) {
            if (module.move) module.move(x, y, target);
          });
        } else if (this.c.lightboxIsOn) {
          this.c.lightboxSlider1.move(x, y, target);
        }
      }
    }]);

    return _Listener;
  }();

  var Data = {
    desktop: {
      psd: {
        w: 1440
      }
    },
    mobile: {
      psd: {
        w: 375
      }
    }
  };

  var App = function App() {
    _classCallCheck(this, App);

    new Support(); // Service worker
    // if ('serviceWorker' in navigator) {
    //     navigator.serviceWorker.register('/sw.js')
    // }

    var c = _C;
    c.s3Domain = 'boundary-admin-uploads.s3.amazonaws.com';
    c.cloudFrontDomain = 'd3mqmy56l3rjff.cloudfront.net'; // Scroll top when refresh (for normal scroll)

    if (c.isMobile) {
      r.TopRefresh();
    } // c.isLocal = location.hostname === 'localhost'


    c.isLocal = false;
    c.listener = new _Listener(); // c.GLCore = new GLCore()
    // c.GL = new GL()

    c.pi180 = Math.PI / 180;
    c.data = Data;
    new Resize();
    new Controller();
  };

  new App();

}());
